import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: string;
  /** The built-in `Decimal` scalar type. */
  Decimal: number;
  JSON: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
};

export enum AccountBalanceChangeDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING'
}

export type AccountBalanceChangeRow = {
  __typename?: 'AccountBalanceChangeRow';
  newValue: Scalars['Decimal'];
  previousValue: Scalars['Decimal'];
  tokenSymbol: Scalars['String'];
};

export type AccountBalanceChangedEventDetails = {
  __typename?: 'AccountBalanceChangedEventDetails';
  direction: AccountBalanceChangeDirection;
  explorerName: Scalars['String'];
  explorerUrl: Scalars['String'];
  isWhaleWatch: Scalars['Boolean'];
  newValue: Scalars['Decimal'];
  previousValue: Scalars['Decimal'];
  tokenChanges: Array<AccountBalanceChangeRow>;
  tokenSymbol: Scalars['String'];
  walletBlockchain: WalletBlockchain;
};

export type ActivateFusionSourceInput = {
  /** The blockchain cursor value for the fusion source id. This is usually the starting block that the parser will run on. If none is provided, the latest block/sequence will be used. If IsActivatingForTest is true, then any block height can be provided, no matter how far back. */
  cursorValue?: InputMaybe<Scalars['String']>;
  /** Filter in JSON */
  filter?: InputMaybe<Scalars['String']>;
  /** Activate the fusion source with this id. */
  fusionSourceId: Scalars['String'];
  /** Activate this for testing a specific block/sequence. Source will be deactivated after a successful execution of the value. */
  isActivatingForTest?: InputMaybe<Scalars['Boolean']>;
};

export type ActivateFusionSourcePayload = {
  __typename?: 'ActivateFusionSourcePayload';
  activateFusionSourceResponse?: Maybe<ActivateFusionSourceResponse>;
};

export type ActivateFusionSourceResponse = {
  __typename?: 'ActivateFusionSourceResponse';
  /** Operation ID that will be set on success of queuing the operation. You can use this ID in the future to either poll for status or listen to updates from subscriptions */
  asyncOperationId?: Maybe<Scalars['String']>;
  /**
   * The updated fusion source
   * @deprecated Do not use this anymore, as the operation is async and eventually consistent. Check for queued success by looking at AsyncOperationId, and then periodically poll or listen for async updates via subscriptions
   */
  fusionSource: FusionSourceWithCursor;
};

export type ActivateServiceIdentifierInput = {
  sid: Scalars['String'];
};

export type ActivateServiceIdentifierPayload = {
  __typename?: 'ActivateServiceIdentifierPayload';
  success?: Maybe<Scalars['Boolean']>;
};

/** This is an active alert in the system that has been configured by the user */
export type ActiveAlert = {
  __typename?: 'ActiveAlert';
  createdTime?: Maybe<Timestamp>;
  filterOptionsJson?: Maybe<Scalars['String']>;
  fusionEventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  subscriptionValue?: Maybe<Scalars['String']>;
  user: ActiveAlertOwner;
};

/** An event emitted when an alert is created in the tenant */
export type ActiveAlertCreatedEvent = {
  __typename?: 'ActiveAlertCreatedEvent';
  activeAlert?: Maybe<ActiveAlert>;
};

/** An event emitted when an alert is deleted in the tenant */
export type ActiveAlertDeletedEvent = {
  __typename?: 'ActiveAlertDeletedEvent';
  alertId: Scalars['String'];
  timestamp: Scalars['DateTime'];
  userId: Scalars['String'];
};

/** User/Owner of the active alert */
export type ActiveAlertOwner = {
  __typename?: 'ActiveAlertOwner';
  connectedWallets?: Maybe<Array<Maybe<AlertOwnerConnectedWallet>>>;
  id: Scalars['String'];
};

/** A connection to a list of items. */
export type ActiveAlertsConnection = {
  __typename?: 'ActiveAlertsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ActiveAlertsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ActiveAlert>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActiveAlertsEdge = {
  __typename?: 'ActiveAlertsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ActiveAlert;
};

/** Object used to query active alerts for a tenant */
export type ActiveAlertsInput = {
  /** FusionEvent/Topic id to filter response to */
  fusionEventId: Scalars['String'];
};

/** Object used to add a new bot */
export type AddBotInput = {
  /** Bot credentials to be used when sending messages */
  botCredentials: Scalars['String'];
  /** Type of bot to be added */
  botType: BotType;
  /** Unique name of the bot. This may also be used when users are shown the bot name such as in Telegram or Discord */
  name: Scalars['String'];
};

export type AddCustomIconUrlInput = {
  iconUrl: Scalars['String'];
};

/** Object used to add an email sender domain for a tenant */
export type AddEmailSenderDomainInput = {
  /** Name of the domain that is being added */
  domainName: Scalars['String'];
};

export type AddFusionEventToFusionSourceInput = {
  /** Fusion event id to add to the fusion source */
  fusionEventId: Scalars['String'];
  /** Fusion source id that the fusion event will be added to */
  fusionSourceId: Scalars['String'];
};

export type AddFusionEventToFusionSourceResponse = {
  __typename?: 'AddFusionEventToFusionSourceResponse';
  /** The updated fusion source after the fusion event has been added. */
  fusionSource: FusionSourceWithCursor;
};

export type AddOidcProviderError = ArgumentError;

/** Object used to add an OIDC provider for a tenant */
export type AddOidcProviderInput = {
  /** Client ID for the OIDC provider */
  clientId: Scalars['String'];
  /** Custom OIDC provider configuration. Ignored for all other Issuers */
  customConfig?: InputMaybe<CustomOidcProviderConfigInput>;
  /** Issuer of the token used for OIDC */
  issuer: OidcProvider;
  requireVerifiedEmailAddress: Scalars['Boolean'];
};

export type AddOidcProviderPayload = {
  __typename?: 'AddOidcProviderPayload';
  errors?: Maybe<Array<AddOidcProviderError>>;
  oidcProviderConfiguration?: Maybe<OidcProviderConfiguration>;
};

/** Object used to create an FCM target. */
export type AddOrUpdateMobileFcmTargetInput = {
  /** The Project number of the corresponding Firebase project. */
  appId: Scalars['String'];
  /** An identifier unique to this device. */
  deviceId: Scalars['String'];
  /** Optional friendly name to identity the device. */
  name?: InputMaybe<Scalars['String']>;
  /** Optional array of TargetGroups to add this  FcmTarget to */
  targetGroupIds?: InputMaybe<Array<Scalars['String']>>;
  /** The client platform. */
  targetPlatform: FcmTargetPlatform;
  /** The actual token from Firebase. */
  token: Scalars['String'];
};

/** Add a Source to a SourceGroup. Id and AccountAddress/WalletBlockchain are mutually exclusive. If Id is set, other parameters will be ignored. Setting WalletAddress requires SourceType to be set */
export type AddSourceToSourceGroupInput = {
  /** Fusion event type Id for fusion sources */
  fusionEventTypeId?: InputMaybe<Scalars['String']>;
  /** Id of the SourceGroup object returned from CreateSourceGroup mutation or SourceGroup query */
  sourceGroupId: Scalars['String'];
  /** Id of the Source object returned from CreateSource or Sources */
  sourceId?: InputMaybe<Scalars['String']>;
  /** SourceType associated to WalletAddress */
  sourceType?: InputMaybe<SourceType>;
  /** For chains where public keys are rotatable and not tied to the lifetime of the account, use the accountId. Use public key for all other chains */
  walletAddress?: InputMaybe<Scalars['String']>;
};

/** Notifi Alert */
export type Alert = {
  __typename?: 'Alert';
  createdDate: Scalars['DateTime'];
  filter: Filter;
  filterOptions: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  sourceGroup: SourceGroup;
  /** SubscriptionValue for the Alert. If the alert was configured with multiple Sources in the SourceGroup, this will be null */
  subscriptionValue?: Maybe<Scalars['String']>;
  targetGroup: TargetGroup;
  updatedDate: Scalars['DateTime'];
};

/** An event emitted when an alert is created in the tenant */
export type AlertCreatedEvent = {
  __typename?: 'AlertCreatedEvent';
  alert?: Maybe<TenantUserAlert>;
  user?: Maybe<TenantUser>;
};

/** An event emitted when an alert is deleted in the tenant */
export type AlertDeletedEvent = {
  __typename?: 'AlertDeletedEvent';
  alertId?: Maybe<Scalars['String']>;
  user?: Maybe<TenantUser>;
};

/** Notifi Tenant Connected Wallet */
export type AlertOwnerConnectedWallet = {
  __typename?: 'AlertOwnerConnectedWallet';
  address?: Maybe<Scalars['String']>;
  walletBlockchain: BlockchainType;
};

export enum ApplyPolicy {
  AFTER_RESOLVER = 'AFTER_RESOLVER',
  BEFORE_RESOLVER = 'BEFORE_RESOLVER',
  VALIDATION = 'VALIDATION'
}

export enum ApprovalStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export type ArchiveOpenRegistrationResponse = {
  __typename?: 'ArchiveOpenRegistrationResponse';
  archivedCampaign: Scalars['Boolean'];
  calculateSize: Scalars['Int'];
  clone?: Maybe<ArchiveOpenRegistrationResponse>;
};

export type ArchiveOpenUserRegistrationError = ArgumentError;

/** Object used to Archive an existing open user registration campaign allowing tenants to halt users from signing up for notifications to an existing campaign */
export type ArchiveOpenUserRegistrationInput = {
  /** ID of the campaign/link. This is used to help identify the respective campaign */
  openUserRegistrationCampaignId: Scalars['String'];
};

export type ArchiveOpenUserRegistrationPayload = {
  __typename?: 'ArchiveOpenUserRegistrationPayload';
  archiveOpenRegistrationResponse?: Maybe<ArchiveOpenRegistrationResponse>;
  errors?: Maybe<Array<ArchiveOpenUserRegistrationError>>;
};

export type ArgumentError = Error & {
  __typename?: 'ArgumentError';
  message: Scalars['String'];
  paramName?: Maybe<Scalars['String']>;
};

export type ArgumentNullError = Error & {
  __typename?: 'ArgumentNullError';
  message: Scalars['String'];
  paramName?: Maybe<Scalars['String']>;
};

export type ArgumentOutOfRangeError = Error & {
  __typename?: 'ArgumentOutOfRangeError';
  message: Scalars['String'];
  paramName?: Maybe<Scalars['String']>;
};

/** Authorization */
export type Authorization = {
  __typename?: 'Authorization';
  expiry: Scalars['DateTime'];
  serialNumber: Scalars['String'];
  tenantInfo?: Maybe<CorsPolicy>;
  token: Scalars['String'];
};

/** A connection to a list of items. */
export type AvailableTenantStatisticalReportsConnection = {
  __typename?: 'AvailableTenantStatisticalReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AvailableTenantStatisticalReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TenantStatisticalReportOutput>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AvailableTenantStatisticalReportsEdge = {
  __typename?: 'AvailableTenantStatisticalReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TenantStatisticalReportOutput;
};

export enum AvatarDataType {
  STOCK_NOTIFI = 'STOCK_NOTIFI',
  URL = 'URL'
}

export type BackupCodeTwoFactorChallengeAnswerInput = {
  backupCode: Scalars['String'];
};

/** Contains the message to broadcast. */
export type BatchBroadcastMessageInput = {
  /** Optional identifier used to dedupe messages for idempotency. If this is specified, messages sent after the first appearance of the value will be dropped. The initial request to queue this broadcast will still succeed. We recommend using UUID generators. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** A dictionary of variables for each target destination. These values are used to render each target destiation. */
  targetDestinationVariables: Array<KeyValuePairOfTargetTypeAndDictionaryOfStringAndStringInput>;
  /** Topic name to publish to. Users that subscribed to this topic name, will receive the alert. */
  topicName: Scalars['String'];
};

export type BatchBroadcastMessageResult = {
  __typename?: 'BatchBroadcastMessageResult';
  /** Id of the message scheduled */
  id: Scalars['String'];
};

export type BeginAddTotp2FaPayload = {
  __typename?: 'BeginAddTOTP2FAPayload';
  secret: Scalars['String'];
};

export type BeginConnectWalletToCurrentUserError = ArgumentError;

export type BeginConnectWalletToCurrentUserInput = {
  /** The blockchain address for the authenticating account */
  authAddress: Scalars['String'];
  /** The authentication flow to use */
  authType: Web3AuthType;
  /** BlockchainType ordinal for the authenticating account */
  blockchainType: WalletBlockchain;
  /** The tenant which this account is registering under */
  dappAddress: Scalars['String'];
  /** The pubkey of authenticating account - this is only required for some flows (e.g. Sui) */
  walletPubkey?: InputMaybe<Scalars['String']>;
};

export type BeginConnectWalletToCurrentUserPayload = {
  __typename?: 'BeginConnectWalletToCurrentUserPayload';
  beginConnectWalletToCurrentUserResponse?: Maybe<BeginConnectWalletToCurrentUserResponse>;
  errors?: Maybe<Array<BeginConnectWalletToCurrentUserError>>;
};

export type BeginConnectWalletToCurrentUserResponse = {
  __typename?: 'BeginConnectWalletToCurrentUserResponse';
  /** The nonce to use during public hash generation */
  nonce: Scalars['String'];
};

/** Object used to setup a QR code for login */
export type BeginLogInByQrCodeResult = {
  __typename?: 'BeginLogInByQRCodeResult';
  /** The nonce to use in the QR code. Code is invalid after 2 minutes */
  nonce: Scalars['String'];
};

export type BeginLogInByTransactionInput = {
  /** The dapp id for this tenant */
  dappAddress: Scalars['String'];
  /** Address of wallet logging in with */
  walletAddress: Scalars['String'];
  /** Blockchain of the wallet */
  walletBlockchain: WalletBlockchain;
};

export type BeginLogInByTransactionResult = {
  __typename?: 'BeginLogInByTransactionResult';
  /** The nonce to use during public hash generation */
  nonce: Scalars['String'];
};

export type BeginLogInWithWeb3Error = ArgumentError;

export type BeginLogInWithWeb3Input = {
  /** The blockchain address for the authenticating account */
  authAddress: Scalars['String'];
  /** The authentication flow to use */
  authType: Web3AuthType;
  /** BlockchainType ordinal for the authenticating account */
  blockchainType: WalletBlockchain;
  /** The tenant which this account is registering under */
  dappAddress: Scalars['String'];
  /** The pubkey of authenticating account - this is only required for some flows (e.g. Sui) */
  walletPubkey?: InputMaybe<Scalars['String']>;
};

export type BeginLogInWithWeb3Payload = {
  __typename?: 'BeginLogInWithWeb3Payload';
  beginLogInWithWeb3Response?: Maybe<BeginLogInWithWeb3Response>;
  errors?: Maybe<Array<BeginLogInWithWeb3Error>>;
};

export type BeginLogInWithWeb3Response = {
  __typename?: 'BeginLogInWithWeb3Response';
  /** The nonce to use during public hash generation */
  nonce: Scalars['String'];
};

/** Billing plan description */
export type BillingPlan = {
  __typename?: 'BillingPlan';
  /** BillingPlan type. This is Free by default. Enterprise plans must be created via sales@notifi.network */
  billingPlanType: BillingPlanType;
  /** Cost per message after included quota if a specific overrage value wasn't provided */
  defaultPerNotificationOverrage: Scalars['Float'];
  /** Included quantity for a month */
  includedDiscordNotifications: Scalars['Long'];
  /** Included quantity for a month */
  includedEmailNotifications: Scalars['Long'];
  /** Included quantity for a month */
  includedSlackNotifications: Scalars['Long'];
  /** Included quantity for a month */
  includedSmsNotifications: Scalars['Long'];
  /** Included quantity for a month */
  includedTelegramNotifications: Scalars['Long'];
  /** Included quantity for a month */
  includedWalletNotifications: Scalars['Long'];
  /** Included quantity for a month */
  includedWebhookNotifications: Scalars['Long'];
  /** Specifies that this tenant's bill will be paid by another tenant */
  payerTenantId?: Maybe<Scalars['String']>;
  /** Cost per message in USD after included quota */
  perDiscordOverrage: Scalars['Float'];
  /** Cost per message in USD after included quota */
  perEmailOverrage: Scalars['Float'];
  /** Cost per message in USD after included quota */
  perSlackOverrage: Scalars['Float'];
  /** Cost per message in USD after included quota */
  perSmsOverrage: Scalars['Float'];
  /** Cost per message in USD after included quota */
  perTelegramOverrage: Scalars['Float'];
  /** Cost per message in USD after included quota */
  perWalletOverrage: Scalars['Float'];
  /** Cost per message in USD after included quota */
  perWebhookOverrage: Scalars['Float'];
};

export enum BillingPlanType {
  ENTERPRISE = 'ENTERPRISE',
  FREE = 'FREE',
  UNSPECIFIED = 'UNSPECIFIED'
}

export enum BlockchainType {
  ACALA = 'ACALA',
  AGORIC = 'AGORIC',
  APTOS = 'APTOS',
  ARBITRUM = 'ARBITRUM',
  ARCH = 'ARCH',
  ARCHWAY = 'ARCHWAY',
  AVALANCHE = 'AVALANCHE',
  AXELAR = 'AXELAR',
  BASE = 'BASE',
  BERACHAIN = 'BERACHAIN',
  BINANCE = 'BINANCE',
  BITCOIN = 'BITCOIN',
  BLAST = 'BLAST',
  CELESTIA = 'CELESTIA',
  CELO = 'CELO',
  COSMOS = 'COSMOS',
  DYDX = 'DYDX',
  DYMENSION = 'DYMENSION',
  ELYS = 'ELYS',
  ETHEREUM = 'ETHEREUM',
  EVMOS = 'EVMOS',
  INJECTIVE = 'INJECTIVE',
  KAVA = 'KAVA',
  LINEA = 'LINEA',
  MANTA = 'MANTA',
  MANTLE = 'MANTLE',
  MONAD = 'MONAD',
  MOVEMENT = 'MOVEMENT',
  NEAR = 'NEAR',
  NEUTRON = 'NEUTRON',
  NIBIRU = 'NIBIRU',
  OFF_CHAIN = 'OFF_CHAIN',
  OPTIMISM = 'OPTIMISM',
  ORAI = 'ORAI',
  OSMOSIS = 'OSMOSIS',
  PERSISTENCE = 'PERSISTENCE',
  POLYGON = 'POLYGON',
  SCROLL = 'SCROLL',
  SOLANA = 'SOLANA',
  SUI = 'SUI',
  THE_ROOT_NETWORK = 'THE_ROOT_NETWORK',
  UNSPECIFIED = 'UNSPECIFIED',
  XION = 'XION',
  ZKSYNC = 'ZKSYNC'
}

/** Bot */
export type Bot = {
  __typename?: 'Bot';
  botType: BotType;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  status: BotStatus;
  updatedDate: Scalars['DateTime'];
};

export enum BotStatus {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  UNSPECIFIED = 'UNSPECIFIED'
}

export enum BotType {
  DISCORD = 'DISCORD',
  EMAIL = 'EMAIL',
  FCM = 'FCM',
  SMS = 'SMS',
  TELEGRAM = 'TELEGRAM',
  VAPID = 'VAPID',
  XMTP = 'XMTP'
}

export type BroadcastMessageEventDetails = {
  __typename?: 'BroadcastMessageEventDetails';
  message?: Maybe<Scalars['String']>;
  messageHtml?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Contains the message to broadcast. */
export type BroadcastMessageInput = {
  /** Email payload for rendering custom html without a template. If provided, it will override all templates for email. */
  customHtmlPayload?: InputMaybe<CustomHtmlPayloadInput>;
  /** Optional identifier used to dedupe messages for idempotency. If this is specified, messages sent after the first appearance of the value will be dropped. The initial request to queue this broadcast will still succeed. We recommend using UUID generators. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Source address to publish from. This address should be connected to this user account that's publishing. */
  sourceAddress?: InputMaybe<Scalars['String']>;
  /** Optionally specify the templates that should be used for each TargetType. */
  targetTemplates?: InputMaybe<Array<KeyValuePairOfTargetTypeAndStringInput>>;
  /** Timestamp in seconds since Unix epoch. January 1, 1970 (midnight UTC/GMT) */
  timestamp: Scalars['Long'];
  /** Variables that recipients can use to filter on, along with templates used to expand/replace on. Default templates require 'subject' and 'body'. Custom templates will require their own variable sets. */
  variables?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  /** Blockchain the SourceAddress is on. */
  walletBlockchain: WalletBlockchain;
};

export type BroadcastMessageResult = {
  __typename?: 'BroadcastMessageResult';
  /** Id of the message scheduled */
  id?: Maybe<Scalars['String']>;
};

/** Represents a community manager publish campaign. */
export type CmDashboardCampaignDetails = {
  __typename?: 'CMDashboardCampaignDetails';
  /** The unique identifier for the campaign. */
  campaignId: Scalars['String'];
  /** The time the campaign was created. */
  createdDate: Scalars['DateTime'];
  /** The number of delivered messages. */
  delivered: Scalars['Int'];
  /** The time the campaign was executed. */
  executionTime: Scalars['DateTime'];
  /** The Topic ID that was selected for the campaign. */
  fusionEventTypeId: Scalars['String'];
  /** The unique identifier of this particular campaign detail entry from the CommunityManagerPublish entity */
  id: Scalars['String'];
  /** The number of times the campaign content has been opened by subscribers. */
  opened: Scalars['Int'];
  /** The number of sent messages. */
  sent: Scalars['Int'];
  /** The current status of the campaign. */
  status: Scalars['String'];
};

/** Detailed information about a campaign. */
export type CampaignDetails = {
  __typename?: 'CampaignDetails';
  /** The unique identifier of the campaign. */
  campaignId: Scalars['String'];
  /** The timestamp of when the campaign was created. */
  created: Scalars['DateTime'];
  /** The execution timestamp of when the campaign was executed. */
  executionTime?: Maybe<Scalars['DateTime']>;
  /** The identifier of the topic associated with the campaign. */
  fusionEventTypeId: Scalars['String'];
  /** The identifier of a campaign in the CommunityManagerPublish table. */
  id: Scalars['String'];
  /** The timestamp of when the campaign was last updated. */
  lastUpdated: Scalars['DateTime'];
  /** Statistics for each target type in the campaign. */
  statisticsByTarget: Array<Maybe<StatisticsByTarget>>;
  /** The current status of the campaign. */
  status: Scalars['String'];
};

/** Connection type for campaigns grouped by status. */
export type CampaignStatusConnection = {
  __typename?: 'CampaignStatusConnection';
  /** Campaigns with Canceled status. */
  canceled: Array<CmDashboardCampaignDetails>;
  /** Campaigns with Completed status. */
  completed: Array<CmDashboardCampaignDetails>;
  /** Campaigns with Executing status. */
  executing: Array<CmDashboardCampaignDetails>;
  pageInfo: PageInfo;
  /** Campaigns with Scheduled status. */
  scheduled: Array<CmDashboardCampaignDetails>;
};

export type CancelCommunityManagerPublishTaskError = ArgumentError;

export type CancelCommunityManagerPublishTaskInput = {
  id: Scalars['String'];
};

export type CancelCommunityManagerPublishTaskPayload = {
  __typename?: 'CancelCommunityManagerPublishTaskPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<CancelCommunityManagerPublishTaskError>>;
};

export type ChangeExecutionTimeCmPublishTaskError = ArgumentError;

export type ChangeExecutionTimeCmPublishTaskInput = {
  id: Scalars['String'];
  newExecutionTime: Scalars['DateTime'];
};

export type ChangeExecutionTimeCmPublishTaskPayload = {
  __typename?: 'ChangeExecutionTimeCMPublishTaskPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<ChangeExecutionTimeCmPublishTaskError>>;
};

export type ChatMessageReceivedEventDetails = {
  __typename?: 'ChatMessageReceivedEventDetails';
  conversationId: Scalars['String'];
  messageBody: Scalars['String'];
  messageId: Scalars['String'];
  senderBlockchain: WalletBlockchain;
  senderId: Scalars['String'];
  senderName: Scalars['String'];
};

/** Configuration values for Notifi. */
export type ClientConfiguration = {
  __typename?: 'ClientConfiguration';
  /** The country codes supported for SMS, as ISO 3166-1 alpha-2 codes (two-letter codes) */
  supportedSmsCountryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The supported target types */
  supportedTargetTypes?: Maybe<Array<TargetType>>;
};

export enum CommunityManagerMessageStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  EXECUTING = 'EXECUTING',
  NONE = 'NONE',
  SCHEDULED = 'SCHEDULED'
}

export type CommunityManagerPreviewInput = {
  /** Payload for rendering custom html without a template. If provided, it will override all templates. */
  customHtmlPayload?: InputMaybe<CustomHtmlPayloadInput>;
  /** The target format that the template will rendered */
  previewTarget: TemplateType;
  /** User topic name that the user owns */
  sourceAddress: Scalars['String'];
  /** Timestamp in seconds since Unix epoch. January 1, 1970 (midnight UTC/GMT) */
  timestamp: Scalars['Long'];
  /** Variables that recipients can use to filter on, along with templates used to expand/replace on. Default templates require 'subject' and 'body'. Custom templates will require their own variable sets. */
  variables: Array<KeyValuePairOfStringAndStringInput>;
  /** Must be Offchain for user topics */
  walletBlockchain: WalletBlockchain;
};

export type CommunityManagerPreviewResult = {
  __typename?: 'CommunityManagerPreviewResult';
  /** Preview result. Most likely in the form of HTML */
  content: Scalars['String'];
};

export type CommunityManagerPublish = {
  __typename?: 'CommunityManagerPublish';
  campaignId: Scalars['String'];
  createdDate: Scalars['DateTime'];
  executionTime: Scalars['DateTime'];
  fusionEventTypeId: Scalars['String'];
  id: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
  specificWallets: Array<SpecificWalletTarget>;
  status: CommunityManagerMessageStatus;
  variablesJson: Scalars['String'];
};

export type CompleteAddTotp2FaInput = {
  totpCode: Scalars['String'];
};

export type CompleteAddTotp2FaPayload = {
  __typename?: 'CompleteAddTOTP2FAPayload';
  backupCodes: Array<Scalars['String']>;
  elevatedPermissionsAuthorization: Authorization;
  normalPermissionsAuthorization: Authorization;
  refreshAuthorization: Authorization;
};

export type CompleteConnectWalletToCurrentUserError = ArgumentError;

/** Object used to claim a wallet for the signed in account. */
export type CompleteConnectWalletToCurrentUserInput = {
  /** Describes how to deal with conflicts when connecting a wallet */
  connectWalletConflictResolutionTechnique?: InputMaybe<ConnectWalletConflictResolutionTechnique>;
  /** The Nonce associated with this ConnectWallet flow (from BeginConnectWallet) */
  nonce: Scalars['String'];
  /** Serialized signature over the `SignedMessage` */
  signature: Scalars['String'];
  /** Message that is signed by authenticating account - must include nonce */
  signedMessage: Scalars['String'];
  /** Signing address */
  signingAddress: Scalars['String'];
  /** Optional field for public key of the signing account */
  signingPubkey?: InputMaybe<Scalars['String']>;
};

export type CompleteConnectWalletToCurrentUserPayload = {
  __typename?: 'CompleteConnectWalletToCurrentUserPayload';
  connectedWallet?: Maybe<ConnectedWallet>;
  errors?: Maybe<Array<CompleteConnectWalletToCurrentUserError>>;
};

export type CompleteLogInByQrCodeInput = {
  /** DappId of the tenant being accessed */
  dappId: Scalars['String'];
  /** Nonce encoded in the QR code */
  nonce: Scalars['String'];
};

export type CompleteLogInByTransactionInput = {
  /** The dapp id for this tenant */
  dappAddress: Scalars['String'];
  /** Random client generated UUID used in hash generation of nonce+uuid. Recommend using UUIDv4 */
  randomUuid: Scalars['String'];
  /** Timestamp in seconds since Unix epoch. Required for Aptos chain. This will be the timestamp on the transaction. */
  timestamp?: InputMaybe<Scalars['Long']>;
  /** Transaction containing the HEX(SHA256(nonce+uuid)) printed to 'Notifi Auth: 0x<value>' */
  transactionSignature: Scalars['String'];
  /** Address of wallet attempting to log in with */
  walletAddress: Scalars['String'];
  /** Blockchain of the wallet */
  walletBlockchain: WalletBlockchain;
  /** Public key of wallet attempting to log in with. Required for Aptos chain. */
  walletPublicKey?: InputMaybe<Scalars['String']>;
};

export type CompleteLogInWithWeb3Error = ArgumentError;

/** Input for logging in with web3 authentication */
export type CompleteLogInWithWeb3Input = {
  /** The nonce obtained from BeginLoginWithWeb3 */
  nonce: Scalars['String'];
  /** Serialized signature over the `SignedMessage` */
  signature: Scalars['String'];
  /** Message that is signed by authenticating account - must include nonce */
  signedMessage: Scalars['String'];
  /** Signing address */
  signingAddress: Scalars['String'];
  /** Optional field for public key of the signing account */
  signingPubkey?: InputMaybe<Scalars['String']>;
};

export type CompleteLogInWithWeb3Payload = {
  __typename?: 'CompleteLogInWithWeb3Payload';
  errors?: Maybe<Array<CompleteLogInWithWeb3Error>>;
  user?: Maybe<User>;
};

export enum ConditionDetailsOneofCase {
  NONE = 'NONE',
  NOTIFICATIONS = 'NOTIFICATIONS',
  OFF_CHAIN = 'OFF_CHAIN',
  USER_ACTIONS = 'USER_ACTIONS',
  USER_INTERACTIONS = 'USER_INTERACTIONS'
}

export type ConfirmChannelForSlackChannelTargetInput = {
  slackChannelId: Scalars['String'];
  slackChannelTargetId: Scalars['String'];
};

export type ConfirmChannelForSlackChannelTargetResponse = {
  __typename?: 'ConfirmChannelForSlackChannelTargetResponse';
  slackChannelTarget: SlackChannelTarget;
};

/** Describes how to deal with conflicts when connecting a wallet */
export enum ConnectWalletConflictResolutionTechnique {
  /** Continue if wallet is connected to another user account, but can be safely disconnected from the old user and moved. If this is the last wallet on the account, fail and report the error without making any changes */
  DISCONNECT = 'DISCONNECT',
  /** Disconnects from the old user account even if it was the last wallet for that account. If this was the last wallet for the old account, then the account will be disabled and closed */
  DISCONNECT_AND_CLOSE_OLD_ACCOUNT = 'DISCONNECT_AND_CLOSE_OLD_ACCOUNT',
  /** If there's any conflict, fail and report back the error without making any changes */
  FAIL = 'FAIL'
}

/** Object used to claim a wallet for the signed in account. */
export type ConnectWalletInput = {
  /** Account ID if this chain supports it (required for Near and Aptos) */
  accountId?: InputMaybe<Scalars['String']>;
  /** Describes how to deal with conflicts when connecting a wallet */
  connectWalletConflictResolutionTechnique?: InputMaybe<ConnectWalletConflictResolutionTechnique>;
  /** Timestamp in seconds since Unix epoch. January 1, 1970 (midnight UTC/GMT) */
  timestamp: Scalars['Long'];
  /** Blockchain the wallet belongs to. */
  walletBlockchain: WalletBlockchain;
  /** User's wallet address. */
  walletPublicKey?: InputMaybe<Scalars['String']>;
};

/** Notifi Connected Wallet */
export type ConnectedWallet = {
  __typename?: 'ConnectedWallet';
  address?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  walletBlockchain: WalletBlockchain;
};

/** Notifi Conversation object */
export type Conversation = {
  __typename?: 'Conversation';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  conversationGates?: Maybe<Array<Maybe<ConversationGate>>>;
  conversationType: ConversationType;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  lastConversationMessage?: Maybe<ConversationMessage>;
  name: Scalars['String'];
  participants?: Maybe<Array<Maybe<ConversationParticipant>>>;
  updatedDate: Scalars['DateTime'];
};

export type ConversationGate = {
  __typename?: 'ConversationGate';
  conversationGateTokenType: ConversationGateTokenType;
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  minRequiredTokens: Scalars['Long'];
  name: Scalars['String'];
  participantCount: Scalars['Long'];
  tokenAddress: Scalars['String'];
  updatedDate: Scalars['DateTime'];
  walletBlockchain: WalletBlockchain;
};

export enum ConversationGateTokenType {
  FUNGIBLE_TOKEN = 'FUNGIBLE_TOKEN',
  NFT_AUTHORITY = 'NFT_AUTHORITY',
  NFT_COLLECTION = 'NFT_COLLECTION',
  NFT_COLLECTION_NAME_LTE3_DIGITS = 'NFT_COLLECTION_NAME_LTE3_DIGITS',
  NFT_COLLECTION_NAME_LTE4_DIGITS = 'NFT_COLLECTION_NAME_LTE4_DIGITS',
  NFT_CREATOR = 'NFT_CREATOR'
}

/** Notifi Conversation message object */
export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  conversationId: Scalars['String'];
  conversationParticipant?: Maybe<ConversationParticipant>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  message: Scalars['String'];
  updatedDate: Scalars['DateTime'];
  userId: Scalars['String'];
};

/** A connection to a list of items. */
export type ConversationMessagesConnection = {
  __typename?: 'ConversationMessagesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConversationMessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConversationMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConversationMessagesEdge = {
  __typename?: 'ConversationMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ConversationMessage;
};

/** Notifi Conversation object */
export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  conversationId: Scalars['String'];
  conversationParticipantType: ConversationParticipantType;
  profile: UserProfile;
  resolvedName?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  walletAddress: Scalars['String'];
  walletBlockchain: WalletBlockchain;
};

/** Object used to add a participant to a conversation */
export type ConversationParticipantInput = {
  /** Blockchain the wallet belongs to. */
  walletBlockchain: WalletBlockchain;
  /** User's wallet address. */
  walletPublicKey: Scalars['String'];
};

export enum ConversationParticipantType {
  ADMIN = 'ADMIN',
  BANNED = 'BANNED',
  MEMBER = 'MEMBER',
  SUPPORT = 'SUPPORT'
}

export enum ConversationType {
  CHANNEL = 'CHANNEL',
  GENERAL_PRIVATE = 'GENERAL_PRIVATE',
  GENERAL_PUBLIC = 'GENERAL_PUBLIC',
  SUPPORT = 'SUPPORT'
}

/** A connection to a list of items. */
export type ConversationsConnection = {
  __typename?: 'ConversationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConversationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Conversation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConversationsEdge = {
  __typename?: 'ConversationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Conversation;
};

/** CorsPolicy for tenant */
export type CorsPolicy = {
  __typename?: 'CorsPolicy';
  allowedDomains?: Maybe<Array<Maybe<CorsPolicyEntry>>>;
};

export type CorsPolicyEntry = {
  __typename?: 'CorsPolicyEntry';
  originAddress: Scalars['String'];
};

/** Object used to create an alert that listens to blockchain events. */
export type CreateAlertInput = {
  /** Filter Id of generic or previously created Filter. */
  filterId?: InputMaybe<Scalars['String']>;
  /** JSON object defining the options to use for Filter defined by FilterId */
  filterOptions?: InputMaybe<Scalars['String']>;
  /** Name of group to attach this Alert to. */
  groupName?: InputMaybe<Scalars['String']>;
  /** Friendly name that's displayed for the Alert. */
  name?: InputMaybe<Scalars['String']>;
  /** SourceGroup Id from a previously created SourceGroup that the alert should watch. */
  sourceGroupId?: InputMaybe<Scalars['String']>;
  /** TargetGroup Id from a previously created TargetGroup where messages should be sent. */
  targetGroupId?: InputMaybe<Scalars['String']>;
};

/** Object used to create a new conversation */
export type CreateConversationInput = {
  participants: Array<ConversationParticipantInput>;
};

/** Object used to create an Alert used by a tenant owner to push messages directly to users. Use this from dapp services on behalf of Users */
export type CreateDirectPushAlertInput = {
  emailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** JSON object defining the options to use for Filter defined by FilterId */
  filterOptions?: InputMaybe<Scalars['String']>;
  /** FusionEvent/Topic ID to use to subscribe */
  fusionEventId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** SubscriptionValue to use if FusionEventId was provided. If not provided, the default value of * will be used */
  subscriptionValue?: InputMaybe<Scalars['String']>;
  /** ID of the User obtained when calling CreateTenantUser */
  userId?: InputMaybe<Scalars['String']>;
};

/** Object used to create the tenant's discord bot configuration. */
export type CreateDiscordBotConfigurationInput = {
  /** The tenant's Dicord client id from Discord's developer portal. Used for OAuth2 */
  discordClientId: Scalars['String'];
  /** The tenant's Dicord client secret from Discord's developer portal. Used for OAuth2 */
  discordClientSecret: Scalars['String'];
  /** The Discord server id in which the Discord bot resides */
  discordGuildId: Scalars['String'];
  /** The invite link to join the tenant's Discord server. */
  discordServerInviteLink: Scalars['String'];
  /** The redirect site for OAuth2. This url is configured in Discord's developer portal */
  redirectUrl: Scalars['String'];
};

/** Object used to create an FCM target. */
export type CreateFcmTargetInput = {
  /** The Project number of the corresponding Firebase project. */
  appId: Scalars['String'];
  /** An identifier unique to this device. */
  deviceId: Scalars['String'];
  /** Optional friendly name to identity the device. */
  name?: InputMaybe<Scalars['String']>;
  /** Optional array of TargetGroups to add this  FcmTarget to */
  targetGroupIds?: InputMaybe<Array<Scalars['String']>>;
  /** The client platform. */
  targetPlatform: FcmTargetPlatform;
  /** The actual token from Firebase. */
  token: Scalars['String'];
};

/** Object used to create an alert triggered by a topic defined by a FusionEvent */
export type CreateFusionAlertInput = {
  /** JSON object defining the options to use for filtering. Options must be supported by the FusionEventId's supported Filters found on the FusionEvent metadata */
  filterOptions?: InputMaybe<Scalars['String']>;
  /** FusionEvent identifier that describes the topic that this alert should be triggered on */
  fusionEventId: Scalars['String'];
  /** Friendly name that's displayed for the Alert. */
  name?: InputMaybe<Scalars['String']>;
  /** The value to subscribe to. This is the value that will be used to filter the FusionEvent's messages. Typically, this is the user's wallet/vault/account/etc address of interest. This helps narrow down specific instances of the FusionEvent described by FusionEventId to only those that are important to this user */
  subscriptionValue: Scalars['String'];
  /** Target Group ID containing the targets that should have alert notifications delivered to */
  targetGroupId: Scalars['String'];
};

export type CreateFusionAlertsError = ArgumentError | ArgumentNullError | ArgumentOutOfRangeError;

export type CreateFusionAlertsInput = {
  alerts: Array<CreateFusionAlertInput>;
};

export type CreateFusionAlertsPayload = {
  __typename?: 'CreateFusionAlertsPayload';
  alerts?: Maybe<Array<Alert>>;
  errors?: Maybe<Array<CreateFusionAlertsError>>;
};

export type CreateFusionEventInput = {
  id?: InputMaybe<Scalars['String']>;
  isCommunityManagerEvent?: InputMaybe<Scalars['Boolean']>;
  metadataJson?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateFusionModuleInput = {
  /** Expected output schema in json */
  expectedMetadataOutputSchema?: InputMaybe<Scalars['String']>;
  fusionEventTypeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  moduleType: FusionModuleType;
  storageType: StorageType;
  validateMetadataOutput: Scalars['Boolean'];
};

export type CreateFusionModuleResponse = {
  __typename?: 'CreateFusionModuleResponse';
  fusionModule: FusionModuleData;
  fusionModulePutUrl: Scalars['String'];
};

export type CreateFusionSourceError = ArgumentError;

export type CreateFusionSourceInput = {
  /** The type of blockchain this Fusion Source will be using. */
  blockchainType: WalletBlockchain;
  /** Filter in JSON */
  filter: Scalars['String'];
  /** List of FusionEvent IDs that will be emitted from here */
  fusionEventTypeIds: Array<Scalars['String']>;
  /** The name of the Fusion Source. */
  name: Scalars['String'];
};

export type CreateFusionSourcePayload = {
  __typename?: 'CreateFusionSourcePayload';
  createFusionSourceResponse?: Maybe<CreateFusionSourceResponse>;
  errors?: Maybe<Array<CreateFusionSourceError>>;
};

export type CreateFusionSourceResponse = {
  __typename?: 'CreateFusionSourceResponse';
  fusionSource: FusionSourceWithCursor;
  /** @deprecated Use CreateFusionSourceUploadUrl instead */
  fusionSourcePutUrl: Scalars['String'];
};

export type CreateFusionSourceUploadUrlError = ArgumentError;

export type CreateFusionSourceUploadUrlInput = {
  /** Total byte count of the file being uploaded. This must match what's actually uploaded later */
  byteCount: Scalars['Long'];
  /** The id of the Fusion Source to update */
  fusionSourceId: Scalars['String'];
};

export type CreateFusionSourceUploadUrlPayload = {
  __typename?: 'CreateFusionSourceUploadUrlPayload';
  createFusionSourceUploadUrlResponse?: Maybe<CreateFusionSourceUploadUrlResponse>;
  errors?: Maybe<Array<CreateFusionSourceUploadUrlError>>;
};

export type CreateFusionSourceUploadUrlResponse = {
  __typename?: 'CreateFusionSourceUploadUrlResponse';
  fusionSourcePutUrl: Scalars['String'];
  version: Scalars['Long'];
};

export type CreateOpenUserRegistrationError = ArgumentError;

/** Object used to create a new open user registration campaign allowing users to sign up for any notifications */
export type CreateOpenUserRegistrationInput = {
  beginTime: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['DateTime']>;
  fusionEventIds: Array<Scalars['String']>;
  /** Name of the registration campaign/link. This is used to help identify in Admin Portal */
  name: Scalars['String'];
};

export type CreateOpenUserRegistrationPayload = {
  __typename?: 'CreateOpenUserRegistrationPayload';
  errors?: Maybe<Array<CreateOpenUserRegistrationError>>;
  openUserRegistration?: Maybe<OpenUserRegistration>;
};

export type CreateOrUpdateUserError = InvalidEmailError | LimitedResourceTypeError | RequiresElevatedTokenError;

/** Object used to create a new user for the admin panel. */
export type CreateOrUpdateUserInput = {
  /** Primary email address for account. This will be used for verification and password resets. */
  email: Scalars['String'];
  /** List of roles to assign to the user */
  roles: Array<Scalars['String']>;
};

export type CreateServiceIdentifierError = RequiresElevatedTokenError;

export type CreateServiceIdentifierPayload = {
  __typename?: 'CreateServiceIdentifierPayload';
  errors?: Maybe<Array<CreateServiceIdentifierError>>;
  secret?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
};

export type CreateSlackChannelTargetError = DuplicateSlackChannelTargetNamesError | TargetLimitExceededError | UnexpectedError;

export type CreateSlackChannelTargetResponse = {
  __typename?: 'CreateSlackChannelTargetResponse';
  errors?: Maybe<Array<CreateSlackChannelTargetError>>;
  slackChannelTarget?: Maybe<SlackChannelTarget>;
};

/** Object used to create a source that can be used on alerts to listen for blockchain events. */
export type CreateSourceInput = {
  /** Account address on blockchain. */
  blockchainAddress?: InputMaybe<Scalars['String']>;
  /** Fusion event type Id for fusion sources */
  fusionEventTypeId?: InputMaybe<Scalars['String']>;
  /** Friendly name for this Source. */
  name?: InputMaybe<Scalars['String']>;
  /** Type of the BlockAddress being referenced. Can be SolanaWallet, EthereumWallet, TerraWallet, etc. */
  type: SourceType;
};

/** Object used to create individual targets. */
export type CreateTargetInput = {
  /** Optional friendly name to identity the email address. */
  name?: InputMaybe<Scalars['String']>;
  /** Target value to be used. For SMS it would be the phone number. For email it would be the email address. For Telegram, the Telegram id. Fore Discord, the value will be empty. */
  value?: InputMaybe<Scalars['String']>;
};

/** Object used to create a tenant config. */
export type CreateTenantConfigInput = {
  /** JSON object defining the payload to store */
  data: Scalars['String'];
  /** Id of the Tenant Config. */
  id?: InputMaybe<Scalars['String']>;
  /** The type of config to create */
  type: TenantConfigType;
};

/** Object used to create a new tenant */
export type CreateTenantInput = {
  /** Captcha answer */
  captchaResponse: Scalars['String'];
  /** DappId that uniquely identifies this tenant. Must be >= 5 and <= 20 characters, only contain lowercase alpha-numeric, and up to a single '.' not preceeding or trailing */
  dappId?: InputMaybe<Scalars['String']>;
  /** Primary email address for tenant. This will be used for verification, updates and contact */
  email: Scalars['String'];
  /** Password used for account. Must be at least 10 characters with at least 1 capital, 1 lower, 1 numeric and one symbol */
  password: Scalars['String'];
  /** Tenant name */
  tenantName: Scalars['String'];
};

/** Object used to create a new User from a tenant's off-chain service. */
export type CreateTenantUserInput = {
  /** Blockchain the wallet belongs to. */
  walletBlockchain: WalletBlockchain;
  /** User's wallet address. */
  walletPublicKey?: InputMaybe<Scalars['String']>;
};

/** Object used to create a webhook target. */
export type CreateWeb3TargetInput = {
  /** Account ID or address. Use public key unless on a chain with accounts that can rotate keys, at which point use accountId */
  accountId?: InputMaybe<Scalars['String']>;
  /** Optional friendly name to identity the webhook. If specifying one, it must be unique for this type */
  name?: InputMaybe<Scalars['String']>;
  /** Web3 protocol to use. The AccountId must already be initialized to receive messages on that protocol */
  protocol: Web3TargetProtocol;
  /** Blockchain of the accountId */
  walletBlockchain: WalletBlockchain;
};

export type CreateWebPushTargetError = TargetLimitExceededError | UnexpectedError;

export type CreateWebPushTargetInput = {
  auth: Scalars['String'];
  endpoint: Scalars['String'];
  p256dh: Scalars['String'];
  vapidPublicKey: Scalars['String'];
};

export type CreateWebPushTargetResponse = {
  __typename?: 'CreateWebPushTargetResponse';
  errors?: Maybe<Array<CreateWebPushTargetError>>;
  webPushTarget?: Maybe<WebPushTarget>;
};

/** Object used to create a webhook target. */
export type CreateWebhookTargetInput = {
  /** The format of the payload sent to the Url */
  format: WebhookPayloadFormat;
  /** HTTP headers to add to the webhook requests */
  headers?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  /** Optional friendly name to identity the webhook. */
  name?: InputMaybe<Scalars['String']>;
  /** The Url to POST updates to. */
  url: Scalars['String'];
};

export type CursorEntry = {
  __typename?: 'CursorEntry';
  cursorValue: Scalars['String'];
  lastExecutedTimestamp: Scalars['DateTime'];
  sourceState: FusionSourceState;
};

export type CustomHtmlPayloadInput = {
  htmlMessage: Scalars['String'];
  unstyledMessage?: InputMaybe<Scalars['String']>;
};

export type CustomOidcProviderConfigInput = {
  /** Claim to use for the user id */
  claimToUseForUserId?: InputMaybe<Scalars['String']>;
  /** Issuer (iss claim) to use if no OidcConfigurationUrl is provided */
  issuer?: InputMaybe<Scalars['String']>;
  /** JWKS URL to use if no OidcConfigurationUrl is provided */
  jwksUrl?: InputMaybe<Scalars['String']>;
  /** URL of the OIDC configuration endpoint for Custom Issuer. Ignored for non custom */
  oidcConfigurationUrl?: InputMaybe<Scalars['String']>;
  /**
   * Prefix added to unique id of user (typically pulled from sub claim) on the Custom Issuer. Ignored for non custom. Each provider has a default, where Custom providers are the only ones that can be modified here.
   *
   * Maximum of 5 characters
   * Default for Custom is 'oidc:'
   */
  userIdPrefix?: InputMaybe<Scalars['String']>;
};

/** CustomPluginStorage */
export type CustomPluginStorageEntity = {
  __typename?: 'CustomPluginStorageEntity';
  createdDate: Scalars['DateTime'];
  key?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
  version: Scalars['Long'];
};

export type DaoProposalChangedEventDetails = {
  __typename?: 'DAOProposalChangedEventDetails';
  daoUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  proposalUrl?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenantName: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type DAppSubscription = {
  __typename?: 'DAppSubscription';
  dAppName: Scalars['String'];
  id: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  targetGroup: TargetGroup;
};

/** Earnings information for a specific dapp */
export type DappEarningsInfo = {
  __typename?: 'DappEarningsInfo';
  /** Number of alerts for this dapp */
  alertVolume: Scalars['Long'];
  /** The unique identifier of the dapp */
  dappId?: Maybe<Scalars['String']>;
  /** Public metadata of the dapp */
  dappPublicMetadata?: Maybe<DappPublicMetadata>;
  /** The tenant ID of the dapp */
  tenantId?: Maybe<Scalars['String']>;
  /** Total points available to the user in this dapp */
  totalPointsAvailableToUser: Scalars['Long'];
  /** Total points earned in this dapp */
  totalPointsEarned: Scalars['Long'];
};

/** Object used by Dapps to allow their members to log in to Notifi. */
export type DappLogInInput = {
  /** Account ID if this chain supports it (required for Near and Aptos) */
  accountId?: InputMaybe<Scalars['String']>;
  /** Dapp address/id */
  dappAddress?: InputMaybe<Scalars['String']>;
  /** Timestamp in seconds since Unix epoch. January 1, 1970 (midnight UTC/GMT) */
  timestamp: Scalars['Long'];
  /** WalletPublicKey chain */
  walletBlockchain?: InputMaybe<WalletBlockchain>;
  /** Dapp member's wallet public key */
  walletPublicKey?: InputMaybe<Scalars['String']>;
};

/** Public metadata of a dapp */
export type DappPublicMetadata = {
  __typename?: 'DappPublicMetadata';
  /** Description of the dapp */
  description?: Maybe<Scalars['String']>;
  /** URL of the dapp's logo */
  logoUrl?: Maybe<Scalars['String']>;
  /** Name of the dapp */
  name?: Maybe<Scalars['String']>;
  /** Website URL of the dapp */
  websiteUrl?: Maybe<Scalars['String']>;
};

export type DeactivateFusionSourceInput = {
  /** Deactivate the fusion source with this id. */
  fusionSourceId: Scalars['String'];
};

export type DeactivateFusionSourcePayload = {
  __typename?: 'DeactivateFusionSourcePayload';
  deactivateFusionSourceResponse?: Maybe<DeactivateFusionSourceResponse>;
};

export type DeactivateFusionSourceResponse = {
  __typename?: 'DeactivateFusionSourceResponse';
  /** Operation ID that will be set on success of queuing the operation. You can use this ID in the future to either poll for status or listen to updates from subscriptions */
  asyncOperationId?: Maybe<Scalars['String']>;
  /**
   * The updated fusion source
   * @deprecated Do not use this anymore, as the operation is async and eventually consistent. Check for queued success by looking at AsyncOperationId, and then periodically poll or listen for async updates via subscriptions
   */
  fusionSource: FusionSourceWithCursor;
};

export type DeactivateServiceIdentifierInput = {
  sid: Scalars['String'];
};

export type DeactivateServiceIdentifierPayload = {
  __typename?: 'DeactivateServiceIdentifierPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteAlertsError = ArgumentError | ArgumentNullError | ArgumentOutOfRangeError;

/** Object used to delete one or more alerts */
export type DeleteAlertsInput = {
  /** Alert IDs to be deleted */
  alertIds: Array<Scalars['String']>;
};

export type DeleteAlertsPayload = {
  __typename?: 'DeleteAlertsPayload';
  deleteAlertsResponse?: Maybe<DeleteAlertsResponse>;
  errors?: Maybe<Array<DeleteAlertsError>>;
};

export type DeleteAlertsResponse = {
  __typename?: 'DeleteAlertsResponse';
  /** Alert IDs that were deleted */
  alertsIds: Array<Scalars['String']>;
};

/** Object used to delete an Alert used by a tenant owner to push messages directly to users. Use this from dapp services on behalf of Users */
export type DeleteDirectPushAlertInput = {
  /** ID of the Alert obtained when calling CreateDirectPushAlert */
  alertId?: InputMaybe<Scalars['String']>;
};

export type DeleteFusionSourceInput = {
  fusionSourceId: Scalars['String'];
};

export type DeleteFusionSourceResponse = {
  __typename?: 'DeleteFusionSourceResponse';
  success: Scalars['Boolean'];
};

export type DeleteSlackChannelTargetError = TargetAssignedToExistingTargetGroupError | UnexpectedError;

export type DeleteSlackChannelTargetResponse = {
  __typename?: 'DeleteSlackChannelTargetResponse';
  errors?: Maybe<Array<DeleteSlackChannelTargetError>>;
  slackChannelTarget?: Maybe<SlackChannelTarget>;
};

/** Object used to delete individual targets. */
export type DeleteTargetInput = {
  /** Id of the target requesting to be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

/** Object used to delete a tenant config. */
export type DeleteTenantConfigInput = {
  /** Id of the Tenant Config. */
  id: Scalars['String'];
  /** The type of config to delete */
  type: TenantConfigType;
};

export type DeleteWebPushTargetError = TargetDoesNotExistError | UnexpectedError;

export type DeleteWebPushTargetInput = {
  id: Scalars['String'];
};

export type DeleteWebPushTargetResponse = {
  __typename?: 'DeleteWebPushTargetResponse';
  errors?: Maybe<Array<DeleteWebPushTargetError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DirectTenantMessageEventDetails = {
  __typename?: 'DirectTenantMessageEventDetails';
  targetTemplatesJson?: Maybe<Scalars['String']>;
  templateVariablesJson?: Maybe<Scalars['String']>;
  tenantName: Scalars['String'];
};

export type DisableTotp2FaRequiredForEmailLoginsError = RequiresElevatedTokenError;

export type DisableTotp2FaRequiredForEmailLoginsPayload = {
  __typename?: 'DisableTOTP2FARequiredForEmailLoginsPayload';
  errors?: Maybe<Array<DisableTotp2FaRequiredForEmailLoginsError>>;
  totp2faRequired?: Maybe<Scalars['Boolean']>;
};

/** Object used to disconnect a wallet for the signed in account. */
export type DisconnectWalletInput = {
  /** Blockchain the wallet belongs to. */
  walletBlockchain: WalletBlockchain;
  /** User's wallet address. */
  walletPublicKey?: InputMaybe<Scalars['String']>;
};

/** DiscordBotConfiguration */
export type DiscordBotConfiguration = {
  __typename?: 'DiscordBotConfiguration';
  discordClientId?: Maybe<Scalars['String']>;
  discordGuildId?: Maybe<Scalars['String']>;
  discordServerInviteLink?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
};

/** Discord Target */
export type DiscordTarget = {
  __typename?: 'DiscordTarget';
  createdDate: Scalars['DateTime'];
  discordAccountId?: Maybe<Scalars['String']>;
  discordServerInviteLink?: Maybe<Scalars['String']>;
  discriminator?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
  userStatus: DiscordTargetStatus;
  username?: Maybe<Scalars['String']>;
  verificationLink?: Maybe<Scalars['String']>;
};

export enum DiscordTargetStatus {
  COMPLETE = 'COMPLETE',
  DISCORD_SERVER_NOT_JOINED = 'DISCORD_SERVER_NOT_JOINED',
  UNVERIFIED = 'UNVERIFIED'
}

export type DuplicateSlackChannelTargetNamesError = Error & {
  __typename?: 'DuplicateSlackChannelTargetNamesError';
  message: Scalars['String'];
};

/** User's earnings information across different dapps */
export type EarningsInfo = {
  __typename?: 'EarningsInfo';
  /** List of earnings information for each dapp */
  dappEarningsInfo?: Maybe<Array<Maybe<DappEarningsInfo>>>;
};

/** Email setting defaults for the tenant */
export type EmailSenderDefaults = {
  __typename?: 'EmailSenderDefaults';
  allowedDomains?: Maybe<Array<Maybe<CorsPolicyEntry>>>;
  defaultEmailSenderDisplayName?: Maybe<Scalars['String']>;
  /** @deprecated Use defaultEmailSenderDomainId */
  defaultEmailSenderDomain?: Maybe<EmailSenderDomain>;
  defaultEmailSenderDomainId?: Maybe<Scalars['String']>;
  defaultEmailSenderName?: Maybe<Scalars['String']>;
};

/** Custom email domain that can be used to send email from */
export type EmailSenderDomain = {
  __typename?: 'EmailSenderDomain';
  /** Create a CNAME for each of these tokens */
  dkimTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Use DKIM instead */
  dnsVerificationToken?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  verificationStatus: EmailSenderDomainStatus;
};

export enum EmailSenderDomainStatus {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  UNSPECIFIED = 'UNSPECIFIED',
  VERIFIED = 'VERIFIED'
}

export type EmailTarget = {
  __typename?: 'EmailTarget';
  createdDate: Scalars['DateTime'];
  emailAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAccountOwner: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export type EmailUserRegistrationExecutionEndpoint = {
  __typename?: 'EmailUserRegistrationExecutionEndpoint';
  postUrl: Scalars['String'];
  targetType: TargetType;
};

/** Object used to enable or disable FCM targets for a specific device */
export type EnableOrDisableMobileFcmTargetsInput = {
  /** An identifier unique to this device. */
  deviceId: Scalars['String'];
  /** Enable or disable Inbox mobile FCM targets for this device */
  inboxEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Enable or disable xMS mobile FCM targets for this device */
  xmsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type EnableTotp2FaRequiredForEmailLoginsError = RequiresElevatedTokenError;

export type EnableTotp2FaRequiredForEmailLoginsPayload = {
  __typename?: 'EnableTOTP2FARequiredForEmailLoginsPayload';
  errors?: Maybe<Array<EnableTotp2FaRequiredForEmailLoginsError>>;
  totp2faRequired?: Maybe<Scalars['Boolean']>;
};

/** Object used to enqueue a new offchain event */
export type EnqueueOffChainEventInput = {
  /** The bucket in which the event should be stored */
  bucketName: Scalars['String'];
  /** The data that should be placed into the queue */
  offChainEvent: Scalars['String'];
};

/** Response object from queueing an offchain event */
export type EnqueueOffChainEventResult = {
  __typename?: 'EnqueueOffChainEventResult';
  /** The bucket in which the event should be stored */
  bucketName: Scalars['String'];
};

/** A connection to a list of items. */
export type EphemeralStorageConnection = {
  __typename?: 'EphemeralStorageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EphemeralStorageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EphemeralStorageEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EphemeralStorageEdge = {
  __typename?: 'EphemeralStorageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EphemeralStorageEntry;
};

/** Ephemeral storage entry used by the Fusion system */
export type EphemeralStorageEntry = {
  __typename?: 'EphemeralStorageEntry';
  /** Key of the entry */
  key?: Maybe<Scalars['String']>;
  /** Value of the entry */
  value?: Maybe<Scalars['String']>;
};

/** Represents an individual ephemeral storage entry to be created/updated */
export type EphemeralStorageEntryInput = {
  /** Key of the entry to update */
  key: Scalars['String'];
  /** Value to update the entry to. Null values will cause the entry to be deleted */
  value?: InputMaybe<Scalars['String']>;
};

/** Object used to query ephemeral storage used by the Fusion system */
export type EphemeralStorageQueryInput = {
  /** Keys of the entries to be returned. Max of 50 per query */
  keys?: InputMaybe<Array<Scalars['String']>>;
};

export type Error = {
  message: Scalars['String'];
};

export type EventDetails = AccountBalanceChangedEventDetails | BroadcastMessageEventDetails | ChatMessageReceivedEventDetails | DaoProposalChangedEventDetails | DirectTenantMessageEventDetails | GenericEventDetails | HealthValueOverThresholdEventDetails | NftAuctionChangedEventDetails | NftCollectionsReportEventDetails | WalletsActivityReportEventDetails;

export type FcmTarget = {
  __typename?: 'FcmTarget';
  appId?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  deviceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  targetPlatform: FcmTargetPlatform;
  token?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export enum FcmTargetPlatform {
  ANDROID = 'ANDROID',
  I_OS = 'I_OS'
}

/** Notifi Filter */
export type Filter = {
  __typename?: 'Filter';
  createdDate: Scalars['DateTime'];
  filterType: FilterType;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export enum FilterType {
  ASSET_BUYER_EVENTS = 'ASSET_BUYER_EVENTS',
  ASSET_CATALOG_EVENTS = 'ASSET_CATALOG_EVENTS',
  ASSET_SELLER_EVENTS = 'ASSET_SELLER_EVENTS',
  BALANCE = 'BALANCE',
  BENQI_LENDING_HEALTH_EVENTS = 'BENQI_LENDING_HEALTH_EVENTS',
  BROADCAST_MESSAGES = 'BROADCAST_MESSAGES',
  COIN_PRICE_CHANGE_EVENTS = 'COIN_PRICE_CHANGE_EVENTS',
  DAO_PROPOSAL_EVENTS = 'DAO_PROPOSAL_EVENTS',
  DELTA_PRIME_BORROW_RATE_EVENTS = 'DELTA_PRIME_BORROW_RATE_EVENTS',
  DELTA_PRIME_LENDING_HEALTH_EVENTS = 'DELTA_PRIME_LENDING_HEALTH_EVENTS',
  DELTA_PRIME_SUPPLY_RATE_EVENTS = 'DELTA_PRIME_SUPPLY_RATE_EVENTS',
  DEPOSITS = 'DEPOSITS',
  DE_FI_YIELD_STRATEGIES = 'DE_FI_YIELD_STRATEGIES',
  DIRECT_TENANT_MESSAGES = 'DIRECT_TENANT_MESSAGES',
  FUSION_SOURCE = 'FUSION_SOURCE',
  LIQUIDATIONS = 'LIQUIDATIONS',
  LIQUIDITY_POOL_PRICE_CHANGES = 'LIQUIDITY_POOL_PRICE_CHANGES',
  MULTI_SIG_SAFE_EVENTS = 'MULTI_SIG_SAFE_EVENTS',
  NFT_AUCTIONS = 'NFT_AUCTIONS',
  NFT_BACKED_LOANS = 'NFT_BACKED_LOANS',
  NOTIFI_CHAT_MESSAGES = 'NOTIFI_CHAT_MESSAGES',
  REALM_DAO_PROPOSAL_STATES = 'REALM_DAO_PROPOSAL_STATES',
  STAKING_CONFIRMATION_EVENTS = 'STAKING_CONFIRMATION_EVENTS',
  STAKING_REMINDER_EVENTS = 'STAKING_REMINDER_EVENTS',
  TRIBECA_DAO_PROPOSAL_STATES = 'TRIBECA_DAO_PROPOSAL_STATES',
  VALUE_THRESHOLD = 'VALUE_THRESHOLD',
  WEB3_CHAT_MESSAGES = 'WEB3_CHAT_MESSAGES',
  WITHDRAWALS = 'WITHDRAWALS'
}

/** Object used to find tenant configs. */
export type FindTenantConfigInput = {
  /** The ID of the config to find */
  id: Scalars['String'];
  /** The tenant identifier */
  tenant: Scalars['String'];
  /** The type of config to query */
  type: TenantConfigType;
};

/** Contains the message to broadcast. */
export type FusionBroadcastMessageInput = {
  /** Topic's fusion event id. Users that subscribed to this topic id, will receive the alert. */
  fusionTopicEventId: Scalars['String'];
  /** Optional identifier used to dedupe messages for idempotency. If this is specified, messages sent after the first appearance of the value will be dropped. The initial request to queue this broadcast will still succeed. We recommend using UUID generators. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** The specific wallets to target, if any */
  specificWallets?: InputMaybe<Array<KeyValuePairOfStringAndWalletBlockchainInput>>;
  /** A dictionary of variables for each target destination. These values are used to render each target destiation. */
  targetDestinationVariables: Array<KeyValuePairOfTargetTypeAndDictionaryOfStringAndStringInput>;
};

export type FusionBroadcastMessageResult = {
  __typename?: 'FusionBroadcastMessageResult';
  /** Id of the message scheduled */
  id: Scalars['String'];
};

export type FusionCommunityManagerPreviewInput = {
  /** The target format that the template will rendered */
  previewTarget: TemplateType;
  /** Template id for rendering. Id will be the topic's fusion event id for most cases. */
  targetTemplateId: Scalars['String'];
  /** Variables that recipients can use to filter on, along with templates used to expand/replace on. Default templates require 'subject' and 'body'. Custom templates will require their own variable sets. */
  variables: Array<KeyValuePairOfStringAndStringInput>;
};

export type FusionCommunityManagerPreviewResult = {
  __typename?: 'FusionCommunityManagerPreviewResult';
  /** Preview result. Most likely in the form of HTML */
  content: Scalars['String'];
};

export enum FusionEventCategory {
  COMMUNITY_MANAGER = 'COMMUNITY_MANAGER',
  GENERAL = 'GENERAL',
  TENANT_ADMIN = 'TENANT_ADMIN',
  TENANT_DEVELOPER = 'TENANT_DEVELOPER',
  TENANT_MARKETER = 'TENANT_MARKETER',
  UNSPECIFIED = 'UNSPECIFIED',
  USER = 'USER'
}

export type FusionEventData = {
  __typename?: 'FusionEventData';
  alertFilters?: Maybe<Scalars['JSON']>;
  archivedDate?: Maybe<Scalars['DateTime']>;
  createdDate: Scalars['DateTime'];
  fusionEventCategory: FusionEventCategory;
  fusionModules: Array<FusionModuleData>;
  fusionSource?: Maybe<FusionSourceWithCursor>;
  hasAlertFilter: Scalars['Boolean'];
  id: Scalars['String'];
  metadata: Scalars['String'];
  name: Scalars['String'];
  tenantId: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

/** Notifi FusionEventDescriptor object */
export type FusionEventDescriptor = {
  __typename?: 'FusionEventDescriptor';
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FusionEventRequiredParserVariables = {
  __typename?: 'FusionEventRequiredParserVariables';
  fusionEventId: Scalars['String'];
  requiredVariables: Array<RequiredVariable>;
};

/** A connection to a list of items. */
export type FusionEventsConnection = {
  __typename?: 'FusionEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FusionEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FusionEventData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FusionEventsEdge = {
  __typename?: 'FusionEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FusionEventData;
};

export type FusionExecutionDetails = GetFusionModuleExecutionDetailsResult | GetFusionSourceExecutionDetailsResult;

export enum FusionExecutionLogDataType {
  CLEAR_TEXT_DATA_URL = 'CLEAR_TEXT_DATA_URL',
  UNKNOWN = 'UNKNOWN'
}

/** A connection to a list of items. */
export type FusionExecutionLogsConnection = {
  __typename?: 'FusionExecutionLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FusionExecutionLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FusionExecutionDetails>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FusionExecutionLogsEdge = {
  __typename?: 'FusionExecutionLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FusionExecutionDetails;
};

export enum FusionExecutionStatus {
  FAILED = 'FAILED',
  HOST_EXECUTION_FAILED = 'HOST_EXECUTION_FAILED',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED'
}

export enum FusionExecutionType {
  /** Return all execution types */
  ALL = 'ALL',
  /** Return Fusion Alert Filter executions */
  FUSION_ALERT_FILTER = 'FUSION_ALERT_FILTER',
  /** Return Fusion Source Filter executions */
  FUSION_SOURCE_FILTER = 'FUSION_SOURCE_FILTER',
  /** Return Fusion Source Parser executions */
  FUSION_SOURCE_PARSER = 'FUSION_SOURCE_PARSER'
}

export type FusionModuleData = {
  __typename?: 'FusionModuleData';
  active: Scalars['Boolean'];
  archivedDate?: Maybe<Scalars['DateTime']>;
  createdDate: Scalars['DateTime'];
  expectedMetadataOutputSchema: Scalars['String'];
  fusionEventId: Scalars['String'];
  id: Scalars['String'];
  moduleType: FusionModuleType;
  storageType: StorageType;
  tenantId: Scalars['String'];
  validateMetadataOutput: Scalars['Boolean'];
};

export enum FusionModuleType {
  ALERT_FILTER = 'ALERT_FILTER',
  SOURCE_FILTER = 'SOURCE_FILTER',
  UNKNOWN = 'UNKNOWN'
}

/** A connection to a list of items. */
export type FusionNotificationHistoryConnection = {
  __typename?: 'FusionNotificationHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FusionNotificationHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FusionNotificationHistoryEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FusionNotificationHistoryEdge = {
  __typename?: 'FusionNotificationHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FusionNotificationHistoryEntry;
};

export type FusionNotificationHistoryEntry = {
  __typename?: 'FusionNotificationHistoryEntry';
  createdDate: Scalars['DateTime'];
  detail?: Maybe<EventDetails>;
  fusionEventVariables: Scalars['String'];
  id: Scalars['String'];
  read: Scalars['Boolean'];
};

/** Notifi FusionSource object */
export type FusionSource = {
  __typename?: 'FusionSource';
  archivedDate?: Maybe<Scalars['DateTime']>;
  blockchainSource?: Maybe<WalletBlockchain>;
  createdDate?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<Scalars['String']>;
  fusionEventTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Long']>;
};

export enum FusionSourceState {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  INACTIVE = 'INACTIVE',
  PROCESSING = 'PROCESSING',
  UNKNOWN = 'UNKNOWN'
}

export type FusionSourceWithCursor = {
  __typename?: 'FusionSourceWithCursor';
  archivedDate?: Maybe<Scalars['DateTime']>;
  blockchainSource: WalletBlockchain;
  createdDate: Scalars['DateTime'];
  cursor?: Maybe<CursorEntry>;
  filter: Scalars['String'];
  fusionEventTypeIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedDate: Scalars['DateTime'];
  version: Scalars['Long'];
};

/** A connection to a list of items. */
export type FusionSourcesConnection = {
  __typename?: 'FusionSourcesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FusionSourcesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FusionSourceWithCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FusionSourcesEdge = {
  __typename?: 'FusionSourcesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FusionSourceWithCursor;
};

export type GenerateElevatedPermissionsAuthorizationInput = {
  twoFactorAnswer?: InputMaybe<TwoFactorChallengeAnswerInput>;
};

export type GenerateElevatedPermissionsAuthorizationPayload = {
  __typename?: 'GenerateElevatedPermissionsAuthorizationPayload';
  authorization?: Maybe<Authorization>;
};

export type GenerateNormalPermissionsAuthorizationPayload = {
  __typename?: 'GenerateNormalPermissionsAuthorizationPayload';
  newRefreshAuthorization?: Maybe<Authorization>;
  normalPermissionsAuthorization?: Maybe<Authorization>;
};

export type GenerateRefreshAuthorizationInput = {
  twoFactorAnswer?: InputMaybe<TwoFactorChallengeAnswerInput>;
};

export type GenerateRefreshAuthorizationPayload = {
  __typename?: 'GenerateRefreshAuthorizationPayload';
  authorization?: Maybe<Authorization>;
};

export type GenericEventAction = {
  __typename?: 'GenericEventAction';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type GenericEventDetails = {
  __typename?: 'GenericEventDetails';
  action?: Maybe<GenericEventAction>;
  customIconUrl?: Maybe<Scalars['String']>;
  eventDetailsJson?: Maybe<Scalars['String']>;
  icon: GenericEventIconHint;
  message: Scalars['String'];
  messageHtml?: Maybe<Scalars['String']>;
  notificationTypeName: Scalars['String'];
  sourceName: Scalars['String'];
  tenantIconUrl?: Maybe<Scalars['String']>;
};

export enum GenericEventIconHint {
  CHART = 'CHART',
  CHECKMARK = 'CHECKMARK',
  CLOCK = 'CLOCK',
  DAO = 'DAO',
  DOWN_ARROW = 'DOWN_ARROW',
  FLAG = 'FLAG',
  GRAPH = 'GRAPH',
  INFO = 'INFO',
  MEGAPHONE = 'MEGAPHONE',
  PERCENT = 'PERCENT',
  STAR = 'STAR',
  SWAP = 'SWAP',
  UP_ARROW = 'UP_ARROW',
  URGENT = 'URGENT',
  WATCH = 'WATCH'
}

/** Object used to query all Alerts or an individual. */
export type GetAlertInput = {
  /** Id of the Alert to return. */
  id?: InputMaybe<Scalars['String']>;
};

export type GetAvailableTenantStatisticalReportsInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  reportTypes?: InputMaybe<Array<TenantStatisticalReportType>>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Object used to query bots by bot type */
export type GetBotsByTypeInput = {
  /** Bot type of Bot entity */
  botType: BotType;
};

/** Object used to specify the dapp address to be queried. */
export type GetConfigurationForDappInput = {
  dappAddress?: InputMaybe<Scalars['String']>;
};

/** Object used to query TargetGroups. */
export type GetConnectedWalletsInput = {
  /** Blockchain the wallet address belongs to. */
  connectedWalletBlockchain?: InputMaybe<WalletBlockchain>;
};

/** Parameters for getting a specific conversation */
export type GetConversationInput = {
  conversationId: Scalars['String'];
};

/** Object used to query messages for a conversation */
export type GetConversationMessagesInput = {
  conversationId: Scalars['String'];
};

/** Object used to query all Filters or an individual. */
export type GetFilterInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Object used to query Fusion executions for this tenant */
export type GetFusionExecutionLogsInput = {
  /** Optional parameter to specify which status of executions to return */
  fusionExecutionStatus?: InputMaybe<FusionExecutionStatus>;
  /** Optional parameter to specify which types of executions to return */
  fusionExecutionType?: InputMaybe<FusionExecutionType>;
  /** Optional parameter to specify which FusionSourceId or FusionModuleId to return executions for */
  fusionSourceOrModuleId?: InputMaybe<Scalars['String']>;
};

export type GetFusionModuleExecutionDetailsResult = {
  __typename?: 'GetFusionModuleExecutionDetailsResult';
  executionTimestamp: Scalars['DateTime'];
  fusionModuleId: Scalars['String'];
  fusionModuleType: FusionModuleType;
  logData: Scalars['String'];
  logDataType: FusionExecutionLogDataType;
  originatingFusionSourceId: Scalars['String'];
  status: FusionExecutionStatus;
};

export type GetFusionModulePutUrlResponse = {
  __typename?: 'GetFusionModulePutUrlResponse';
  fusionModulePutUrl: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Object to query the params needed for setting up a developer environment to build a Fusion Source parser */
export type GetFusionSourceDevParamsInput = {
  /** FusionSource ID of the params */
  id: Scalars['String'];
};

export type GetFusionSourceDevParamsResponse = {
  __typename?: 'GetFusionSourceDevParamsResponse';
  /** Filter that when compared against a block and its tx's, will conditionally trigger this FusionSource to execute */
  blockFilter?: Maybe<Scalars['String']>;
  /** Blockchain this parser is meant for */
  blockchain: BlockchainType;
  /** Optional variables that if provided, are required by the FusionSource to have returned in the output metadata in a top-level object named 'requiredParserVariables' */
  requiredParserVariablesPerEvent?: Maybe<Array<Maybe<FusionEventRequiredParserVariables>>>;
};

export type GetFusionSourceExecutionDetailsResult = {
  __typename?: 'GetFusionSourceExecutionDetailsResult';
  cursorId: Scalars['String'];
  executionTimestamp: Scalars['DateTime'];
  fusionSourceId: Scalars['String'];
  logData: Scalars['String'];
  logDataType: FusionExecutionLogDataType;
  status: FusionExecutionStatus;
};

export type GetFusionSourcePutUrlResponse = {
  __typename?: 'GetFusionSourcePutUrlResponse';
  fusionParserPutUrl: Scalars['String'];
  success: Scalars['Boolean'];
};

export type GetFusionSourceStateInput = {
  fusionSourceId: Scalars['String'];
};

/** Object used to query jabber messages for a thread */
export type GetJabberMessagesInput = {
  threadId: Scalars['String'];
};

export type GetMessageDeliveryStatisticsResult = {
  __typename?: 'GetMessageDeliveryStatisticsResult';
  messagesByAttributes: MessageStats;
  messagesByTarget: MessageStats;
};

export type GetPublicDappMetadataInput = {
  dappId: Scalars['String'];
};

/** Object used to query the public topics */
export type GetPublicTopicsInput = {
  /** Collections to use for filtering relevant topics */
  collectionName: Scalars['String'];
};

/** Object used to query previous public UserTopic posts */
export type GetPublicUserTopicPostInput = {
  /** Topic name to get previous posts for */
  topicName: Scalars['String'];
};

export type GetSlackChannelBotInfoInput = {
  slackChannelTargetId: Scalars['String'];
};

export type GetSlackChannelBotInfoResponse = {
  __typename?: 'GetSlackChannelBotInfoResponse';
  botName: Scalars['String'];
  iconUrl: Scalars['String'];
};

export type GetSlackWorkspaceIconInput = {
  slackChannelTargetId: Scalars['String'];
};

export type GetSlackWorkspaceIconResponse = {
  __typename?: 'GetSlackWorkspaceIconResponse';
  /** Slack workspace icon url */
  iconUrl: Scalars['String'];
};

/** Object used to query SourceGroups. */
export type GetSourceGroupInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Object used to query Sources. Optional fields are mutually exclusive. */
export type GetSourceInput = {
  /** Wallet address to query specific DAO Sources for. Memberships to DAOs will be verified and populated for connected wallet. */
  connectedWalletAddress?: InputMaybe<Scalars['String']>;
  /** Blockchain the wallet address belongs to. */
  connectedWalletBlockchain?: InputMaybe<WalletBlockchain>;
  /** ID of the Source to be queried. */
  id?: InputMaybe<Scalars['String']>;
};

/** Object used to query Sources */
export type GetSourcesInput = {
  /** IDs of the Sources to be queried. */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the SourceGroup to be used. */
  sourceGroupId?: InputMaybe<Scalars['String']>;
};

/** Object used to specify the dapp address to be queried. */
export type GetSupportedTargetTypesForDappInput = {
  dappAddress?: InputMaybe<Scalars['String']>;
};

/** Object used to query TargetGroups. */
export type GetTargetGroupInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Object used to query Targets. */
export type GetTargetInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Object used to query Targets. */
export type GetTargetsInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  /** IDs of the targets to be queried. */
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type GetTemplateDataInput = {
  templateName: Scalars['String'];
  type: TemplateType;
};

export type GetTemplateResponse = {
  __typename?: 'GetTemplateResponse';
  template?: Maybe<Template>;
};

export type GetTenantAvailableReportsResult = {
  __typename?: 'GetTenantAvailableReportsResult';
  reports: Array<Scalars['String']>;
};

/** Object used to query tenant configs. */
export type GetTenantConfigInput = {
  /** The type of config to query */
  type: TenantConfigType;
};

/** Object used to query ConnectedWallets that belong to a Tenant's Users. This can only be used from a service caller. */
export type GetTenantConnectedWalletInput = {
  userWallets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userWalletsBlockchain: WalletBlockchain;
};

export type GetTenantDeliveryReportRequestInput = {
  monthYears: Array<Scalars['String']>;
};

export type GetTenantDeliveryReportResult = {
  __typename?: 'GetTenantDeliveryReportResult';
  preSignedUrls: Array<KeyValuePairOfStringAndString>;
};

export type GetTotalMessagesPerMonthByTenantResult = {
  __typename?: 'GetTotalMessagesPerMonthByTenantResult';
  messagesPerMonth: Array<KeyValuePairOfStringAndInt32>;
};

export type GetTotalMessagesPerTopicByTenantInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type GetTotalMessagesPerTopicByTenantPayload = {
  __typename?: 'GetTotalMessagesPerTopicByTenantPayload';
  /** The unique ID representing this topic */
  eventTypeId: Scalars['String'];
  /** The total number of messages sent on this topic */
  messageCount: Scalars['Long'];
  /** The total number of subscribers on this topic */
  subscriberCount: Scalars['Long'];
  /** The display name of this topic */
  topicName: Scalars['String'];
};

/** Object used to query GetUnreadNotificationHistoryCount, optionally specifying a cardId to filter the count to. */
export type GetUnreadNotificationHistoryCountInput = {
  /** CardId that should be used to select which topics/fusionEventsIds should be used to filter the count to. */
  cardId?: InputMaybe<Scalars['String']>;
};

export type GetUnreadNotificationHistoryCountResponse = {
  __typename?: 'GetUnreadNotificationHistoryCountResponse';
  count: Scalars['Int'];
};

export type GetUrlsForTenantStatisticalReportsInput = {
  reportIds: Array<Scalars['String']>;
};

export type GetUrlsForTenantStatisticalReportsOutput = {
  __typename?: 'GetUrlsForTenantStatisticalReportsOutput';
  preSignedUrlsForReportIds: Array<KeyValuePairOfStringAndString>;
};

/** Object used to query an individual user profile */
export type GetUserProfileInput = {
  /** UserId of the profile to query */
  id: Scalars['String'];
};

export type GetUsersByTopicResult = {
  __typename?: 'GetUsersByTopicResult';
  usersByTopic: Array<KeyValuePairOfStringAndInt32>;
};

/** Object used to query Web3Targets */
export type GetWeb3TargetsInput = {
  /** IDs of the Web3Targets to be queried. */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the TargetGroup to be used. */
  targetGroupId?: InputMaybe<Scalars['String']>;
};

export type HealthValueOverThresholdEventDetails = {
  __typename?: 'HealthValueOverThresholdEventDetails';
  name: Scalars['String'];
  threshold: Scalars['String'];
  url: Scalars['String'];
  value: Scalars['String'];
};

export type InvalidEmailError = Error & {
  __typename?: 'InvalidEmailError';
  message: Scalars['String'];
};

export type InvalidXmtpConsentProofError = Error & {
  __typename?: 'InvalidXmtpConsentProofError';
  message: Scalars['String'];
};

/** A connection to a list of items. */
export type JabberMessagesConnection = {
  __typename?: 'JabberMessagesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JabberMessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<JabberV1Message>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JabberMessagesEdge = {
  __typename?: 'JabberMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JabberV1Message>;
};

/** A connection to a list of items. */
export type JabberThreadsConnection = {
  __typename?: 'JabberThreadsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JabberThreadsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<JabberV1Thread>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JabberThreadsEdge = {
  __typename?: 'JabberThreadsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JabberV1Thread;
};

export type JabberV1Message = {
  __typename?: 'JabberV1Message';
  id: Scalars['String'];
  isEncrypted: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  messageBase64: Scalars['String'];
  senderWalletAddress: Scalars['String'];
  senderWalletBlockchain: WalletBlockchain;
  threadId: Scalars['String'];
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** A Jabber chat participant */
export type JabberV1Participant = {
  __typename?: 'JabberV1Participant';
  notifiProfile?: Maybe<UserProfile>;
  resolvedName?: Maybe<Scalars['String']>;
  solPerMessage?: Maybe<Scalars['Float']>;
  walletAddress: Scalars['String'];
  walletBlockchain: WalletBlockchain;
};

/** A Jabber Conversation object */
export type JabberV1Thread = {
  __typename?: 'JabberV1Thread';
  id: Scalars['String'];
  lastConversationMessage?: Maybe<JabberV1Message>;
  participants: Array<JabberV1Participant>;
};

export type KeyValuePairOfStringAndInt32 = {
  __typename?: 'KeyValuePairOfStringAndInt32';
  key: Scalars['String'];
  value: Scalars['Int'];
};

export type KeyValuePairOfStringAndMessageDetails = {
  __typename?: 'KeyValuePairOfStringAndMessageDetails';
  key: Scalars['String'];
  value: MessageDetails;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValuePairOfStringAndWalletBlockchainInput = {
  key: Scalars['String'];
  value: WalletBlockchain;
};

export type KeyValuePairOfTargetTypeAndDictionaryOfStringAndStringInput = {
  key: TargetType;
  value: Array<KeyValuePairOfStringAndStringInput>;
};

export type KeyValuePairOfTargetTypeAndStringInput = {
  key: TargetType;
  value: Scalars['String'];
};

/** Object used to allow a user to leave conversation */
export type LeaveConversationInput = {
  /** Conversation id */
  conversationId: Scalars['String'];
};

export type LimitedResourceTypeError = Error & {
  __typename?: 'LimitedResourceTypeError';
  message: Scalars['String'];
};

export type ListAvailableSlackChannelInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  slackChannelTargetId: Scalars['String'];
};

export type ListAvailableSlackChannelResponse = {
  __typename?: 'ListAvailableSlackChannelResponse';
  nextCursor?: Maybe<Scalars['String']>;
  slackChannels?: Maybe<Array<SlackChannel>>;
};

export type ListTemplatesInput = {
  templateName: Scalars['String'];
};

export type ListTemplatesResponse = {
  __typename?: 'ListTemplatesResponse';
  templates: Array<Template>;
};

/** Object used to log in to an existing account via email/password pair */
export type LogInByEmailAddressInput = {
  /** Optional dappId to log in to. If not provided, this is assumed to be a Notifi Admin Portal login attempt */
  dappId?: InputMaybe<Scalars['String']>;
  /** Email address */
  emailAddress: Scalars['String'];
  /** Account password */
  password: Scalars['String'];
};

/** Describes the issuer of the OAuth token being used */
export type LogInByOAuthInput = {
  dappId: Scalars['String'];
  oAuthIssuer: OAuthIssuer;
  token: Scalars['String'];
};

export type LogInByOidcError = ArgumentError | UnauthorizedAccessError;

/** Object to complete login using OIDC id_token */
export type LogInByOidcInput = {
  dappId: Scalars['String'];
  idToken: Scalars['String'];
  oidcProvider: OidcProvider;
};

export type LogInByOidcPayload = {
  __typename?: 'LogInByOidcPayload';
  errors?: Maybe<Array<LogInByOidcError>>;
  user?: Maybe<User>;
};

export type MarkFusionNotificationHistoryAsReadInput = {
  /** Marks the given notification id and all the notifications that came before the id as read */
  beforeId?: InputMaybe<Scalars['String']>;
  /** List of ids to mark as read, leave as empty if using markNotificationAsReadBeforeId */
  ids: Array<Scalars['String']>;
  readState?: InputMaybe<NotificationHistoryReadState>;
};

export type MarkNotificationsAsReadInput = {
  /** List of Ids to update, at least 1 must be specified */
  ids: Array<Scalars['String']>;
};

export type MessageDetails = {
  __typename?: 'MessageDetails';
  messages: Scalars['Int'];
  users: Scalars['Int'];
};

export type MessageStats = {
  __typename?: 'MessageStats';
  stats?: Maybe<Array<KeyValuePairOfStringAndMessageDetails>>;
};

export enum MessageType {
  DIRECT_TENANT_MESSAGE = 'DIRECT_TENANT_MESSAGE',
  RAW_MESSAGE = 'RAW_MESSAGE',
  SIMPLE_HEALTH_THRESHOLD = 'SIMPLE_HEALTH_THRESHOLD'
}

export type MobilePushSettings = {
  __typename?: 'MobilePushSettings';
  inboxEnabled: Scalars['Boolean'];
  xmsEnabled: Scalars['Boolean'];
};

/** Input for retrieving device specific mobile push options */
export type MobilePushSettingsInput = {
  /** Device ID */
  deviceId: Scalars['String'];
};

export type NftAuctionChangedEventDetails = {
  __typename?: 'NftAuctionChangedEventDetails';
  auctionUrl?: Maybe<Scalars['String']>;
  highBidAmount: Scalars['Float'];
  highBidSymbol?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  walletBlockchain: WalletBlockchain;
};

export type NftCollectionStats = {
  __typename?: 'NftCollectionStats';
  collectionId: Scalars['String'];
  imgUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  volume1Day?: Maybe<Scalars['String']>;
  volume1DayChange?: Maybe<Scalars['String']>;
};

export type NftCollectionsReportEventDetails = {
  __typename?: 'NftCollectionsReportEventDetails';
  collections: Array<NftCollectionStats>;
  providerName: Scalars['String'];
  sourceLink: Scalars['String'];
  type: NftCollectionsReportType;
};

export enum NftCollectionsReportType {
  HOT = 'HOT',
  MOST_TRADED = 'MOST_TRADED'
}

export type NotifiMutation = {
  __typename?: 'NotifiMutation';
  activateFusionModule: Scalars['Boolean'];
  /** Activate a fusion source. A valid source must be provided by first calling CreateFusionSourceUploadUrl and uploading using the returned url. A new cursor position and filter can also be provided here during activation */
  activateFusionSource: ActivateFusionSourcePayload;
  /** Activate a SID for your Dapp account, allowing it to be used for authentication */
  activateServiceIdentifier: ActivateServiceIdentifierPayload;
  addBot: Bot;
  /** Add a custom icon url */
  addCustomIconUrl: PublicDappInfo;
  /** Add a custom sender domain that can be used for emails sent by this tenant custom_default@customdomain.com */
  addEmailSenderDomain?: Maybe<EmailSenderDomain>;
  addFusionEventToFusionSource: AddFusionEventToFusionSourceResponse;
  addOidcProvider: AddOidcProviderPayload;
  /** Add or update a mobile FcmTarget. This will add the FcmTarget to all TargetGroups */
  addOrUpdateMobileFcmTarget: FcmTarget;
  /** Add a source to a SourceGroup */
  addSourceToSourceGroup: SourceGroup;
  archiveOpenUserRegistration: ArchiveOpenUserRegistrationPayload;
  /** Allows a user to publish a message from a Source that they own for multiple destinations. */
  batchBroadcastMessage?: Maybe<BatchBroadcastMessageResult>;
  /** Begin adding TOTP two-factor authentication to your user account by generating an authenticator secret */
  beginAddTOTP2FA: BeginAddTotp2FaPayload;
  /** Mutation that allows users to obtain the nonce required for connecting a wallet to an existing account. */
  beginConnectWalletToCurrentUser: BeginConnectWalletToCurrentUserPayload;
  /** Mutation that allows users to begin flow for logging in via a QR code */
  beginLogInByQRCode: BeginLogInByQrCodeResult;
  /** Mutation to begin login flow via signed transaction */
  beginLogInByTransaction: BeginLogInByTransactionResult;
  /** Mutation that allows users to obtain the nonce required for a Web3 login */
  beginLogInWithWeb3: BeginLogInWithWeb3Payload;
  /** Allows a user to publish a message from a Source that they own. */
  broadcastMessage?: Maybe<BroadcastMessageResult>;
  cancelCommunityManagerPublishTask: CancelCommunityManagerPublishTaskPayload;
  changeExecutionTimeCMPublishTask: ChangeExecutionTimeCmPublishTaskPayload;
  /** Complete adding TOTP two-factor authentication to your user account by providing a TOTP code */
  completeAddTOTP2FA: CompleteAddTotp2FaPayload;
  /** Claim a wallet that belongs to this account. If another account was associated to this wallet, it will be removed. */
  completeConnectWalletToCurrentUser: CompleteConnectWalletToCurrentUserPayload;
  completeLogInByQRCode?: Maybe<User>;
  /** Mutation to complete login flow via signed transaction */
  completeLogInByTransaction?: Maybe<User>;
  /** Mutation facilitates account login via wallet signatures */
  completeLogInWithWeb3: CompleteLogInWithWeb3Payload;
  confirmChannelForSlackChannelTarget: ConfirmChannelForSlackChannelTargetResponse;
  /** Confirm email with token. */
  confirmEmail: Scalars['Boolean'];
  /**
   * Claim a wallet that belongs to this account. If another account was associated to this wallet, it will be removed.
   * @deprecated Please migrate to the `ConnectWalletToCurrentUser` mutation which uses the `BeginConnectWalletToCurrentUser` to generate the nonce.
   */
  connectWallet?: Maybe<ConnectedWallet>;
  /**
   * Mutation to create a new user or direct access account.
   * @deprecated This functionality is being removed for individual users
   */
  create?: Maybe<User>;
  /** Create a new Alert to watch for blockchain account changes. */
  createAlert?: Maybe<Alert>;
  /**
   * Create a new conversation
   * @deprecated Chat has been deprecated
   */
  createConversation: Conversation;
  /** Mutation to create a new Direct Push Alert for a User that's part of a this Tenant. */
  createDirectPushAlert?: Maybe<Alert>;
  createDiscordBotConfiguration: DiscordBotConfiguration;
  /** Create a DiscordTarget. */
  createDiscordTarget: DiscordTarget;
  /** Create an EmailTarget pointing to a destination that future Alerts can use to send messages to. */
  createEmailTarget?: Maybe<EmailTarget>;
  /** Create an Fcm pointing to a destination that future Alerts can use to send messages to. */
  createFcmTarget?: Maybe<FcmTarget>;
  /** Creates new Alerts to watch on topics created by CreateFusionEvents */
  createFusionAlerts: CreateFusionAlertsPayload;
  createFusionEvent: FusionEventData;
  createFusionModule: CreateFusionModuleResponse;
  createFusionSource: CreateFusionSourcePayload;
  /** Create a signed url for uploading a fusion source file. Once the new file has been accepted, the returned version on this object will be reflected on the FusionSource query object */
  createFusionSourceUploadUrl: CreateFusionSourceUploadUrlPayload;
  createOpenUserRegistration: CreateOpenUserRegistrationPayload;
  /** Mutation to create or update a user for the admin panel. */
  createOrUpdateUser: User;
  /** Add credentials to your Dapp account for a service to log in */
  createServiceIdentifier: CreateServiceIdentifierPayload;
  createSlackChannelTarget: CreateSlackChannelTargetResponse;
  /** Create an SmsTarget pointing to a destination that future Alerts can use to send messages to. */
  createSmsTarget?: Maybe<SmsTarget>;
  /** Create a Source pointing to a blockchain address that should be used for future Alerts. */
  createSource?: Maybe<Source>;
  /** Create a SourceGroup pointing to one or more Sources. */
  createSourceGroup?: Maybe<SourceGroup>;
  /**
   * Create or get the support conversation for this user
   * @deprecated Chat has been deprecated
   */
  createSupportConversation: Conversation;
  /** Create a TargetGroup pointing to one or more Targets that should be used for future Alerts. */
  createTargetGroup?: Maybe<TargetGroup>;
  /** Create an TelegramTarget pointing to a destination that future Alerts can use to send messages to. */
  createTelegramTarget?: Maybe<TelegramTarget>;
  /** Mutation to create a new tenant. Returned User is the tenant admin, associated with the provided email. Only 1 tenant can be assigned to an email */
  createTenant?: Maybe<User>;
  /** Create or update a tenant config */
  createTenantConfig: TenantConfig;
  /** Mutation to create a new User from a dapp off-chain service. */
  createTenantUser?: Maybe<TenantUser>;
  /** Create a Web3Target pointing to a destination that future Alerts can use to send messages to. */
  createWeb3Target?: Maybe<Web3Target>;
  createWebPushTarget: CreateWebPushTargetResponse;
  /** Create a WebhookTarget pointing to a destination that future Alerts can use to send messages to. */
  createWebhookTarget?: Maybe<WebhookTarget>;
  /** Deactivate a fusion source. This will stop processing and set the processing state to Inactive */
  deactivateFusionSource: DeactivateFusionSourcePayload;
  /** Deactivate a SID for your Dapp account, disallowing it from being used for authentication */
  deactivateServiceIdentifier: DeactivateServiceIdentifierPayload;
  /** Delete the Alert. */
  deleteAlert?: Maybe<Alert>;
  /** Delete one or more alerts by their respective IDs */
  deleteAlerts: DeleteAlertsPayload;
  /** Delete DApp subscription by ID. */
  deleteDAppSubscription?: Maybe<DAppSubscription>;
  /** Mutation to create a new Direct Push Alert for a User that's part of a this Tenant. */
  deleteDirectPushAlert?: Maybe<Alert>;
  deleteDiscordBotConfiguration?: Maybe<DiscordBotConfiguration>;
  /** Delete a DiscordTarget. */
  deleteDiscordTarget: DiscordTarget;
  /** Delete an EmailTarget. */
  deleteEmailTarget?: Maybe<EmailTarget>;
  /** Delete an FcmTarget. */
  deleteFcmTarget?: Maybe<FcmTarget>;
  deleteFusionEvent: Scalars['Boolean'];
  deleteFusionModule: Scalars['Boolean'];
  /** Delete a fusion source. This will set the source to archived, and no longer be allowed to be associated with any FusionEvents or activated */
  deleteFusionSource: DeleteFusionSourceResponse;
  deleteSlackChannelTarget: DeleteSlackChannelTargetResponse;
  /** Delete an SmsTarget. */
  deleteSmsTarget?: Maybe<SmsTarget>;
  /** Delete the Source. */
  deleteSource?: Maybe<Source>;
  /** Delete a SourceGroup. */
  deleteSourceGroup?: Maybe<SourceGroup>;
  /** Delete a TargetGroup. */
  deleteTargetGroup?: Maybe<TargetGroup>;
  /** Delete a TelegramTarget. */
  deleteTelegramTarget?: Maybe<TelegramTarget>;
  /** Delete a tenant config */
  deleteTenantConfig: TenantConfig;
  /** Delete an alert on behalf of a user that belongs to the tenant. */
  deleteUserAlert?: Maybe<Alert>;
  /** Delete a Web3Target */
  deleteWeb3Target?: Maybe<Web3Target>;
  deleteWebPushTarget: DeleteWebPushTargetResponse;
  /** Delete a WebhookTarget. */
  deleteWebhookTarget?: Maybe<WebhookTarget>;
  /** Stop requiring TOTP 2FA sign-in for all users of your Notifi Dapp account that sign in with an email address. */
  disableTOTP2FARequiredForEmailLogins: DisableTotp2FaRequiredForEmailLoginsPayload;
  /** Disconnect a wallet that belongs to this account. If this the last wallet on an account with no recovery email to sign in with, this will fail. */
  disconnectWallet?: Maybe<ConnectedWallet>;
  /** Disable or enable mobile FcmTargets for a particular device */
  enableOrDisableMobileFcmTargets: Array<FcmTarget>;
  /** Require TOTP 2FA sign-in for all users of your Notifi Dapp account that sign in with an email address. */
  enableTOTP2FARequiredForEmailLogins: EnableTotp2FaRequiredForEmailLoginsPayload;
  /** @deprecated Use publishFusionMessage endpoint on dpapi.notifi.network endpoint instead. See docs for more details. */
  enqueueOffChainEvent: EnqueueOffChainEventResult;
  /**
   * Allows a user to publish a message to a fusion event topic for multiple destinations.
   * @deprecated Use dpapi endpoint instead
   */
  fusionBroadcastMessage: FusionBroadcastMessageResult;
  /** Get a very short-lived JWT authorized specifically for performing sensitive actions on your account */
  generateElevatedPermissionsAuthorization: GenerateElevatedPermissionsAuthorizationPayload;
  /** Sends an email to confirm a newly created account. */
  generateEmailConfirmationToken: Scalars['Boolean'];
  /** Get a short-lived authorization token for performing normal user actions */
  generateNormalPermissionsAuthorization: GenerateNormalPermissionsAuthorizationPayload;
  /** Get a long-lived authorization token for fetching normal use credentials */
  generateRefreshAuthorization: GenerateRefreshAuthorizationPayload;
  /**
   * Create a new conversation
   * @deprecated Chat has been deprecated
   */
  leaveConversation: Conversation;
  /**
   * Mutation to log in.
   * @deprecated Please use LogInByEmailAddress
   */
  logIn?: Maybe<User>;
  /** Mutation to log in by email address */
  logInByEmailAddress?: Maybe<User>;
  /**
   * Mutation to log in after completing OAuth2 flow and obtaining an id_token. The tenant must be configured for the respective OIDC providers
   * @deprecated Please use LogInByOidc
   */
  logInByOAuth?: Maybe<User>;
  /** Mutation to log in after completing OAuth2 flow and obtaining an id_token. The tenant must be configured for the respective OIDC providers */
  logInByOidc: LogInByOidcPayload;
  /** Mutation that allows DAOs to log in via user wallet. */
  logInFromDapp?: Maybe<User>;
  /** Mutation to allow a service to log in. This is used to call other APIs on the tenant with elevated permissions. Note, this login can't be used for non service related APIs. */
  logInFromService?: Maybe<Authorization>;
  /** Log out of your current user session. (Calling this API will specifically invalidate the token you used to authorize it.) */
  logOut: Scalars['Boolean'];
  /** Log out of all sessions on your user account */
  logOutAllSessions: Scalars['Boolean'];
  /** Mark given notifications as read by the current user. */
  markFusionNotificationHistoryAsRead: Array<Scalars['String']>;
  /** Mark given notifications as read by the current user. */
  markNotificationsAsRead?: Maybe<Array<NotificationHistoryEntry>>;
  /** @deprecated Use dpapi endpoint instead */
  publishFusionMessage: PublishFusionMessageResult;
  /**
   * Use this API to get a refreshed JWT to prevent expiry.
   * @deprecated Use GenerateNormalPermissionsAuthorization with the Refresh JWT obtained from GenerateRefreshAuthorization instead
   */
  refreshAuthorization?: Maybe<Authorization>;
  /** Regenerate your two-factor backup codes. Requires an elevated permissions token. */
  regenerate2FABackupCodes: Regenerate2FaBackupCodesPayload;
  removeBot: Bot;
  /** Remove a custom sender domain */
  removeEmailSenderDomain?: Maybe<EmailSenderDomain>;
  removeFusionEventFromFusionSource: RemoveFusionEventFromFusionSourceResponse;
  /** Remove the service identifier with the given sid from your Dapp account */
  removeServiceIdentifier: RemoveServiceIdentifierPayload;
  /** Remove a source from a SourceGroup */
  removeSourceFromSourceGroup: SourceGroup;
  /** Remove TOTP two-factor authentication from your user account. Requires an elevated permissions token. This action also logs you out from all devices. */
  removeTOTP2FA: RemoveTotp2FaPayload;
  /** Mutation to remove a user from the admin panel. */
  removeTenantUserRoles?: Maybe<User>;
  /** Sets a new password for account owned by email if 2FA code is correct. */
  resetPassword: Scalars['Boolean'];
  /**
   * Send a message to a conversation
   * @deprecated Chat has been deprecated
   */
  sendConversationMessage: ConversationMessage;
  /** Send Target confirmation. Currently only EmailTarget is supported. */
  sendEmailTargetVerificationRequest?: Maybe<EmailTarget>;
  /** Directly send a message to a particular wallet address. The message will be sent to any destinations the wallet owner has setup. */
  sendMessage: Scalars['Boolean'];
  /** Sends a password reset email with a 2FA code embedded in the link. */
  sendResetPasswordEmail: Scalars['Boolean'];
  /** Unsubscribe from an alert for a single target type */
  unsubscribe: UnsubscribeResult;
  updateBot: Bot;
  /** Update the CORS policy for this tenant that any users calls from this dapp will be applied to */
  updateCorsPolicy?: Maybe<CorsPolicy>;
  /** Update the default display name that will be used for emails sent by this tenant Custom Default <custom_default>@mailer.notifi.network */
  updateDefaultEmailSenderDisplayName?: Maybe<EmailSenderDefaults>;
  /** Update the default sender domain that will be used for emails sent by this tenant custom_default@customdomain.com */
  updateDefaultEmailSenderDomain?: Maybe<EmailSenderDefaults>;
  /** Update the default sender name that will be used for emails sent by this tenant custom_default@mailer.notifi.network */
  updateDefaultEmailSenderName?: Maybe<EmailSenderDefaults>;
  updateDiscordBotConfiguration: DiscordBotConfiguration;
  /** Update tenant's ephemeral storage used by the Fusion system */
  updateEphemeralStorage: UpdateEphemeralStorageResult;
  updateFusionEvent: FusionEventData;
  updateFusionSource: UpdateFusionSourceResponse;
  updateOpenUserRegistration: UpdateOpenUserRegistrationPayload;
  /** Update tenant's persistent storage used by the Fusion system */
  updatePersistentStorage: UpdatePersistentStorageResult;
  /** Mutation to update current user profile. */
  updateUserProfile?: Maybe<UserProfile>;
  /** Mutation to update current user settings. */
  updateUserSettings?: Maybe<UserSettings>;
  updateWebPushTarget: UpdateWebPushTargetResponse;
  uploadTemplate: Scalars['Boolean'];
  verifyCbwTarget: VerifyCbwTargetResponse;
  /** Verify a DiscordTarget. */
  verifyDiscordTarget: DiscordTarget;
  verifySlackChannelForWebhook: VerifySlackChannelTargetForWebhookResponse;
  verifySlackChannelTarget: VerifySlackChannelTargetResponse;
  /** Verify EmailTarget for a user. */
  verifyTarget?: Maybe<EmailTarget>;
  verifyXmtpTarget: VerifyXmtpTargetResponse;
  verifyXmtpTargetViaXip42: VerifyXmtpTargetViaXip42Response;
};


export type NotifiMutationActivateFusionModuleArgs = {
  fusionModuleId: Scalars['String'];
};


export type NotifiMutationActivateFusionSourceArgs = {
  input: ActivateFusionSourceInput;
};


export type NotifiMutationActivateServiceIdentifierArgs = {
  input: ActivateServiceIdentifierInput;
};


export type NotifiMutationAddBotArgs = {
  addBotInput: AddBotInput;
};


export type NotifiMutationAddCustomIconUrlArgs = {
  input: AddCustomIconUrlInput;
};


export type NotifiMutationAddEmailSenderDomainArgs = {
  addEmailSenderDomainInput: AddEmailSenderDomainInput;
};


export type NotifiMutationAddFusionEventToFusionSourceArgs = {
  input: AddFusionEventToFusionSourceInput;
};


export type NotifiMutationAddOidcProviderArgs = {
  input: AddOidcProviderInput;
};


export type NotifiMutationAddOrUpdateMobileFcmTargetArgs = {
  addOrUpdateMobileFcmTargetInput: AddOrUpdateMobileFcmTargetInput;
};


export type NotifiMutationAddSourceToSourceGroupArgs = {
  addSourceToSourceGroupInput: AddSourceToSourceGroupInput;
};


export type NotifiMutationArchiveOpenUserRegistrationArgs = {
  input: ArchiveOpenUserRegistrationInput;
};


export type NotifiMutationBatchBroadcastMessageArgs = {
  broadcastMessageInput?: InputMaybe<BatchBroadcastMessageInput>;
};


export type NotifiMutationBeginConnectWalletToCurrentUserArgs = {
  beginConnectWalletInput: BeginConnectWalletToCurrentUserInput;
};


export type NotifiMutationBeginLogInByTransactionArgs = {
  beginLogInByTransactionInput: BeginLogInByTransactionInput;
};


export type NotifiMutationBeginLogInWithWeb3Args = {
  beginLogInWithWeb3Input: BeginLogInWithWeb3Input;
};


export type NotifiMutationBroadcastMessageArgs = {
  broadcastMessageInput?: InputMaybe<BroadcastMessageInput>;
  signature?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationCancelCommunityManagerPublishTaskArgs = {
  input: CancelCommunityManagerPublishTaskInput;
};


export type NotifiMutationChangeExecutionTimeCmPublishTaskArgs = {
  input: ChangeExecutionTimeCmPublishTaskInput;
};


export type NotifiMutationCompleteAddTotp2FaArgs = {
  input: CompleteAddTotp2FaInput;
};


export type NotifiMutationCompleteConnectWalletToCurrentUserArgs = {
  completeConnectWalletToCurrentUserInput?: InputMaybe<CompleteConnectWalletToCurrentUserInput>;
};


export type NotifiMutationCompleteLogInByQrCodeArgs = {
  completeLogInByQRCodeInput: CompleteLogInByQrCodeInput;
};


export type NotifiMutationCompleteLogInByTransactionArgs = {
  completeLogInByTransactionInput: CompleteLogInByTransactionInput;
};


export type NotifiMutationCompleteLogInWithWeb3Args = {
  completeLogInWithWeb3Input: CompleteLogInWithWeb3Input;
};


export type NotifiMutationConfirmChannelForSlackChannelTargetArgs = {
  input: ConfirmChannelForSlackChannelTargetInput;
};


export type NotifiMutationConfirmEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationConnectWalletArgs = {
  connectWalletInput?: InputMaybe<ConnectWalletInput>;
  signature?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationCreateArgs = {
  user?: InputMaybe<UserInput>;
};


export type NotifiMutationCreateAlertArgs = {
  alertInput?: InputMaybe<CreateAlertInput>;
};


export type NotifiMutationCreateConversationArgs = {
  createConversationInput: CreateConversationInput;
};


export type NotifiMutationCreateDirectPushAlertArgs = {
  createDirectPushAlertInput?: InputMaybe<CreateDirectPushAlertInput>;
};


export type NotifiMutationCreateDiscordBotConfigurationArgs = {
  createDiscordBotConfigurationInput: CreateDiscordBotConfigurationInput;
};


export type NotifiMutationCreateDiscordTargetArgs = {
  createTargetInput?: InputMaybe<CreateTargetInput>;
};


export type NotifiMutationCreateEmailTargetArgs = {
  createTargetInput?: InputMaybe<CreateTargetInput>;
};


export type NotifiMutationCreateFcmTargetArgs = {
  createFcmTargetInput: CreateFcmTargetInput;
};


export type NotifiMutationCreateFusionAlertsArgs = {
  input: CreateFusionAlertsInput;
};


export type NotifiMutationCreateFusionEventArgs = {
  input: CreateFusionEventInput;
};


export type NotifiMutationCreateFusionModuleArgs = {
  input: CreateFusionModuleInput;
};


export type NotifiMutationCreateFusionSourceArgs = {
  input: CreateFusionSourceInput;
};


export type NotifiMutationCreateFusionSourceUploadUrlArgs = {
  input: CreateFusionSourceUploadUrlInput;
};


export type NotifiMutationCreateOpenUserRegistrationArgs = {
  input: CreateOpenUserRegistrationInput;
};


export type NotifiMutationCreateOrUpdateUserArgs = {
  createOrUpdateUserInput: CreateOrUpdateUserInput;
};


export type NotifiMutationCreateSlackChannelTargetArgs = {
  input: CreateTargetInput;
};


export type NotifiMutationCreateSmsTargetArgs = {
  createTargetInput?: InputMaybe<CreateTargetInput>;
};


export type NotifiMutationCreateSourceArgs = {
  createSourceInput?: InputMaybe<CreateSourceInput>;
};


export type NotifiMutationCreateSourceGroupArgs = {
  sourceGroupInput?: InputMaybe<SourceGroupInput>;
};


export type NotifiMutationCreateTargetGroupArgs = {
  targetGroupInput?: InputMaybe<TargetGroupInput>;
};


export type NotifiMutationCreateTelegramTargetArgs = {
  createTargetInput?: InputMaybe<CreateTargetInput>;
};


export type NotifiMutationCreateTenantArgs = {
  createTenantInput: CreateTenantInput;
};


export type NotifiMutationCreateTenantConfigArgs = {
  createTenantConfigInput: CreateTenantConfigInput;
};


export type NotifiMutationCreateTenantUserArgs = {
  createTenantUserInput?: InputMaybe<CreateTenantUserInput>;
};


export type NotifiMutationCreateWeb3TargetArgs = {
  createWeb3TargetInput: CreateWeb3TargetInput;
};


export type NotifiMutationCreateWebPushTargetArgs = {
  input: CreateWebPushTargetInput;
};


export type NotifiMutationCreateWebhookTargetArgs = {
  createTargetInput: CreateWebhookTargetInput;
};


export type NotifiMutationDeactivateFusionSourceArgs = {
  input: DeactivateFusionSourceInput;
};


export type NotifiMutationDeactivateServiceIdentifierArgs = {
  input: DeactivateServiceIdentifierInput;
};


export type NotifiMutationDeleteAlertArgs = {
  alertId?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationDeleteAlertsArgs = {
  input: DeleteAlertsInput;
};


export type NotifiMutationDeleteDAppSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};


export type NotifiMutationDeleteDirectPushAlertArgs = {
  deleteDirectPushAlertInput?: InputMaybe<DeleteDirectPushAlertInput>;
};


export type NotifiMutationDeleteDiscordTargetArgs = {
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
};


export type NotifiMutationDeleteEmailTargetArgs = {
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
};


export type NotifiMutationDeleteFcmTargetArgs = {
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
};


export type NotifiMutationDeleteFusionEventArgs = {
  fusionEventId: Scalars['String'];
};


export type NotifiMutationDeleteFusionModuleArgs = {
  fusionModuleId: Scalars['String'];
};


export type NotifiMutationDeleteFusionSourceArgs = {
  input: DeleteFusionSourceInput;
};


export type NotifiMutationDeleteSlackChannelTargetArgs = {
  input: DeleteTargetInput;
};


export type NotifiMutationDeleteSmsTargetArgs = {
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
};


export type NotifiMutationDeleteSourceArgs = {
  sourceId?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationDeleteSourceGroupArgs = {
  sourceGroupInput?: InputMaybe<SourceGroupInput>;
};


export type NotifiMutationDeleteTargetGroupArgs = {
  targetGroupInput?: InputMaybe<TargetGroupInput>;
};


export type NotifiMutationDeleteTelegramTargetArgs = {
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
};


export type NotifiMutationDeleteTenantConfigArgs = {
  deleteTenantConfigInput: DeleteTenantConfigInput;
};


export type NotifiMutationDeleteUserAlertArgs = {
  alertId?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationDeleteWeb3TargetArgs = {
  deleteTargetInput: DeleteTargetInput;
};


export type NotifiMutationDeleteWebPushTargetArgs = {
  input: DeleteWebPushTargetInput;
};


export type NotifiMutationDeleteWebhookTargetArgs = {
  deleteTargetInput: DeleteTargetInput;
};


export type NotifiMutationDisconnectWalletArgs = {
  disconnectWalletInput?: InputMaybe<DisconnectWalletInput>;
};


export type NotifiMutationEnableOrDisableMobileFcmTargetsArgs = {
  enableOrDisableMobileFcmTargetsInput: EnableOrDisableMobileFcmTargetsInput;
};


export type NotifiMutationEnqueueOffChainEventArgs = {
  enqueueOffChainEventInput: EnqueueOffChainEventInput;
};


export type NotifiMutationFusionBroadcastMessageArgs = {
  fusionBroadcastMessageInput: FusionBroadcastMessageInput;
};


export type NotifiMutationGenerateElevatedPermissionsAuthorizationArgs = {
  input: GenerateElevatedPermissionsAuthorizationInput;
};


export type NotifiMutationGenerateEmailConfirmationTokenArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationGenerateRefreshAuthorizationArgs = {
  input: GenerateRefreshAuthorizationInput;
};


export type NotifiMutationLeaveConversationArgs = {
  leaveConversationInput: LeaveConversationInput;
};


export type NotifiMutationLogInArgs = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationLogInByEmailAddressArgs = {
  logInByEmailAddressInput: LogInByEmailAddressInput;
};


export type NotifiMutationLogInByOAuthArgs = {
  logInByOAuthInput: LogInByOAuthInput;
};


export type NotifiMutationLogInByOidcArgs = {
  input: LogInByOidcInput;
};


export type NotifiMutationLogInFromDappArgs = {
  dappLogInInput?: InputMaybe<DappLogInInput>;
  signature?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationLogInFromServiceArgs = {
  serviceLogInInput?: InputMaybe<ServiceLogInInput>;
};


export type NotifiMutationMarkFusionNotificationHistoryAsReadArgs = {
  input: MarkFusionNotificationHistoryAsReadInput;
};


export type NotifiMutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


export type NotifiMutationPublishFusionMessageArgs = {
  publishFusionMessageInput: PublishFusionMessageInput;
};


export type NotifiMutationRemoveBotArgs = {
  removeBotInput: RemoveBotInput;
};


export type NotifiMutationRemoveEmailSenderDomainArgs = {
  removeEmailSenderDomainInput: RemoveEmailSenderDomainInput;
};


export type NotifiMutationRemoveFusionEventFromFusionSourceArgs = {
  input: RemoveFusionEventFromFusionSourceInput;
};


export type NotifiMutationRemoveServiceIdentifierArgs = {
  input: RemoveServiceIdentifierInput;
};


export type NotifiMutationRemoveSourceFromSourceGroupArgs = {
  removeSourceFromSourceGroupInput: RemoveSourceFromSourceGroupInput;
};


export type NotifiMutationRemoveTenantUserRolesArgs = {
  removeTenantUserRolesInput: RemoveTenantUserRolesInput;
};


export type NotifiMutationResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  tfaCode?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationSendConversationMessageArgs = {
  sendConversationMessageInput: SendConversationMessageInput;
};


export type NotifiMutationSendEmailTargetVerificationRequestArgs = {
  sendTargetConfirmationRequestInput?: InputMaybe<SendTargetConfirmationRequestInput>;
};


export type NotifiMutationSendMessageArgs = {
  sendMessageInput?: InputMaybe<SendMessageInput>;
};


export type NotifiMutationSendResetPasswordEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type NotifiMutationUnsubscribeArgs = {
  unsubscribeInputType: UnsubscribeInputTypeInput;
};


export type NotifiMutationUpdateBotArgs = {
  updateBotInput: UpdateBotInput;
};


export type NotifiMutationUpdateCorsPolicyArgs = {
  updateCorsPolicyInput: UpdateCorsPolicyInput;
};


export type NotifiMutationUpdateDefaultEmailSenderDisplayNameArgs = {
  updateDefaultEmailSenderDisplayNameInput: UpdateDefaultEmailSenderDisplayNameInput;
};


export type NotifiMutationUpdateDefaultEmailSenderDomainArgs = {
  updateDefaultEmailSenderDomainInput: UpdateDefaultEmailSenderDomainInput;
};


export type NotifiMutationUpdateDefaultEmailSenderNameArgs = {
  updateDefaultEmailSenderNameInput: UpdateDefaultEmailSenderNameInput;
};


export type NotifiMutationUpdateDiscordBotConfigurationArgs = {
  updateDiscordBotConfigurationInput: UpdateDiscordBotConfigurationInput;
};


export type NotifiMutationUpdateEphemeralStorageArgs = {
  updateEphemeralStorageInput: UpdateEphemeralStorageInput;
};


export type NotifiMutationUpdateFusionEventArgs = {
  input: UpdateFusionEventInput;
};


export type NotifiMutationUpdateFusionSourceArgs = {
  input: UpdateFusionSourceInput;
};


export type NotifiMutationUpdateOpenUserRegistrationArgs = {
  input: UpdateOpenUserRegistrationInput;
};


export type NotifiMutationUpdatePersistentStorageArgs = {
  updatePersistentStorageInput: UpdatePersistentStorageInput;
};


export type NotifiMutationUpdateUserProfileArgs = {
  userProfileInput: UserProfileInput;
};


export type NotifiMutationUpdateUserSettingsArgs = {
  userSettings: UserSettingsInput;
};


export type NotifiMutationUpdateWebPushTargetArgs = {
  input: UpdateWebPushTargetInput;
};


export type NotifiMutationUploadTemplateArgs = {
  template: Scalars['String'];
  templateName: Scalars['String'];
  type: TemplateType;
};


export type NotifiMutationVerifyCbwTargetArgs = {
  input: VerifyCbwTargetInput;
};


export type NotifiMutationVerifyDiscordTargetArgs = {
  verifyDiscordTargetInput: VerifyDiscordTargetInput;
};


export type NotifiMutationVerifySlackChannelForWebhookArgs = {
  input: VerifySlackChannelTargetForWebhookInput;
};


export type NotifiMutationVerifySlackChannelTargetArgs = {
  input: VerifySlackChannelTargetInput;
};


export type NotifiMutationVerifyTargetArgs = {
  verifyTargetInput?: InputMaybe<VerifyTargetInput>;
};


export type NotifiMutationVerifyXmtpTargetArgs = {
  input: VerifyXmtpTargetInput;
};


export type NotifiMutationVerifyXmtpTargetViaXip42Args = {
  input: VerifyXmtpTargetViaXip42Input;
};

export type NotifiQuery = {
  __typename?: 'NotifiQuery';
  /** Query current active alerts */
  activeAlerts?: Maybe<ActiveAlertsConnection>;
  /** Query for Alerts. */
  alert?: Maybe<Array<Maybe<Alert>>>;
  /** Get all email senders available for this tenant */
  allEmailSenders: Array<Maybe<EmailSenderDomain>>;
  /** Get the available downloadable statistical reports for this tenant */
  availableTenantStatisticalReports?: Maybe<AvailableTenantStatisticalReportsConnection>;
  billingPlan: BillingPlan;
  /** Get bots by type */
  botsByType: Array<Bot>;
  /** Query for campaign performance for a specific campaign */
  campaignPerformance?: Maybe<CampaignDetails>;
  /** Get campaigns associated with the tenant, grouped by status. */
  campaignsByTenantId: CampaignStatusConnection;
  /** Query for community manager for a specific campaign */
  communityManagerPublishTask: CommunityManagerPublish;
  /** Get the configuration for a dapp */
  configurationForDapp?: Maybe<ClientConfiguration>;
  /** Query for ConnectedWallets. */
  connectedWallet?: Maybe<Array<Maybe<ConnectedWallet>>>;
  /**
   * Get a specific conversation
   * @deprecated This API will be removed
   */
  conversation: Conversation;
  /**
   * Get messages for a conversation
   * @deprecated This API will be removed
   */
  conversationMessages?: Maybe<ConversationMessagesConnection>;
  /**
   * Get conversations a user is part of
   * @deprecated This API will be removed
   */
  conversations?: Maybe<ConversationsConnection>;
  /** DApps subscriptions for all tenants */
  dAppsSubscriptions?: Maybe<Array<DAppSubscription>>;
  /** Query for DiscordTargets. */
  discordTarget?: Maybe<Array<DiscordTarget>>;
  /** Retrieve the user's earnings information across different dapps */
  earningsInfo: EarningsInfo;
  /** Get email sender defaults */
  emailSenderDefaults?: Maybe<EmailSenderDefaults>;
  /** Query for EmailTargets. */
  emailTarget?: Maybe<Array<Maybe<EmailTarget>>>;
  /** Get ephemeral storage entries used by the Fusion parsers and filters. This should only be used to query explicit keys. Wildcards are not allowed */
  ephemeralStorage?: Maybe<EphemeralStorageConnection>;
  /** Query for FcmTargets. */
  fcmTargets?: Maybe<Array<Maybe<FcmTarget>>>;
  /** Query for Filters. */
  filter?: Maybe<Array<Maybe<Filter>>>;
  /** Fetch a specific tenant config */
  findTenantConfig: TenantConfig;
  fusionEvents?: Maybe<FusionEventsConnection>;
  fusionExecutionLogs?: Maybe<FusionExecutionLogsConnection>;
  fusionModulePutUrl: GetFusionModulePutUrlResponse;
  /** Get users fusion notification history */
  fusionNotificationHistory?: Maybe<FusionNotificationHistoryConnection>;
  /** Allows a community manager to preview content for a given target and template */
  fusionPreviewCommunityManagerContent: FusionCommunityManagerPreviewResult;
  fusionSourceDevParams: GetFusionSourceDevParamsResponse;
  /** @deprecated Use CreateFusionSourceUploadUrl mutation instead */
  fusionSourcePutUrl: GetFusionSourcePutUrlResponse;
  fusionSourceState: FusionSourceWithCursor;
  fusionSources?: Maybe<FusionSourcesConnection>;
  /**
   * Get jabber messages for a thread
   * @deprecated This API will be removed
   */
  jabberMessages?: Maybe<JabberMessagesConnection>;
  /**
   * Get jabber threads a user is part of
   * @deprecated This API will be removed
   */
  jabberThreads?: Maybe<JabberThreadsConnection>;
  listAvailableSlackChannels: ListAvailableSlackChannelResponse;
  listTemplates: ListTemplatesResponse;
  /** Query for the count of messages delivered per target type across this tenant */
  messageDeliveryStatistics: GetMessageDeliveryStatisticsResult;
  /** Fetch a specific tenant config */
  mobilePushSettings: MobilePushSettings;
  /** Get notification by id, returns null if the notification is not found */
  notificationById?: Maybe<NotificationHistoryEntry>;
  /** Get users notification history */
  notificationHistory?: Maybe<NotificationHistoryConnection>;
  openUserRegistrations?: Maybe<OpenUserRegistrationsConnection>;
  /** Get persistent storage entries used by the Fusion parsers and filters */
  persistentStorage?: Maybe<PersistentStorageConnection>;
  /** Allows a community manager to preview content for a UserTopic that they own. */
  previewCommunityManagerContent: CommunityManagerPreviewResult;
  /** Retrieves the public metadata for a specified Dapp. */
  publicDappMetadata?: Maybe<PublicDappInfo>;
  /**
   * Get public topics to subscribe
   * @deprecated This query along with topics used here are no longer supported. This API will be removed in the future.
   */
  publicTopics?: Maybe<PublicTopicsConnection>;
  /** Get public posts to topics */
  publicUserTopicPost?: Maybe<PublicUserTopicPostConnection>;
  /**
   * Resolve name for SNS
   * @deprecated No longer used, and support will be removed from this namespace
   */
  resolveSNSFromAddress?: Maybe<Scalars['String']>;
  /** Query reward offers for users in a tenant, including wallet subscribers */
  rewardOffers?: Maybe<RewardOffersConnection>;
  /**
   * Get Service Identifier associated with a Tenant
   * @deprecated Deprecated - please use ServiceIdentifiers instead
   */
  serviceIdentifier?: Maybe<ServiceIdentifierOutput>;
  /** Get all Service Identifiers associated with a Tenant */
  serviceIdentifiers: Array<ServiceIdentifierOutput>;
  settings?: Maybe<UserSettings>;
  slackChannelBotInfo?: Maybe<GetSlackChannelBotInfoResponse>;
  slackChannelTargets?: Maybe<SlackChannelTargetsConnection>;
  slackWorkspaceIcon: GetSlackWorkspaceIconResponse;
  /** Query for SmsTargets. */
  smsTarget?: Maybe<Array<Maybe<SmsTarget>>>;
  /** Query for Sources. */
  source?: Maybe<Array<Maybe<Source>>>;
  /** Query for Source Groups. */
  sourceGroup?: Maybe<Array<Maybe<SourceGroup>>>;
  /** Query for Sources */
  sources?: Maybe<SourcesConnection>;
  /** Get the supported target types for the calling user (email/sms/telegram/etc) */
  supportedTargetTypes?: Maybe<Array<TargetType>>;
  /** Get the supported target types for a dapp (email/sms/telegram/etc) */
  supportedTargetTypesForDapp?: Maybe<Array<TargetType>>;
  /** Query for TargetGroups. */
  targetGroup?: Maybe<Array<Maybe<TargetGroup>>>;
  /** Query for TelegramTargets. */
  telegramTarget?: Maybe<Array<Maybe<TelegramTarget>>>;
  templateData: GetTemplateResponse;
  /** Get tenant's approval status */
  tenantApprovalStatus: ApprovalStatus;
  /**
   * Query for the count of messages delivered per target type across this tenant
   * @deprecated Use GetAvailableTenantStatisticalReports instead
   */
  tenantAvailableReports: GetTenantAvailableReportsResult;
  /** Get tenant configs */
  tenantConfigs?: Maybe<TenantConfigsConnection>;
  /** Get connected wallets for this tenant. */
  tenantConnectedWallet?: Maybe<TenantConnectedWalletConnection>;
  /**
   * Query for the monthly message delivery report for a tenant
   * @deprecated Use GetAvailableTenantStatisticalReports instead
   */
  tenantDeliveryReport: GetTenantDeliveryReportResult;
  tenantDiscordBotConfiguration?: Maybe<DiscordBotConfiguration>;
  /** Get a tenant's feature flag */
  tenantFeatureFlag: TenantFeatureFlag;
  /**
   * Get users for this tenant.
   * @deprecated This API will be removed
   */
  tenantUser?: Maybe<TenantUserConnection>;
  /**
   * Get users for this tenant.
   * @deprecated This API will be removed
   */
  tenantUsers?: Maybe<TenantUsersConnection>;
  /** Get the topics to broadcast */
  topics?: Maybe<TopicsConnection>;
  /** Query for the count of messages delivered per month for this tenant */
  totalMessagesPerMonthByTenant: GetTotalMessagesPerMonthByTenantResult;
  /** Query for the count of messages delivered per topic for this tenant */
  totalMessagesPerTopicByTenant?: Maybe<TotalMessagesPerTopicByTenantConnection>;
  /** Get whether or not 2FA is required to log into your Dapp with an email address (such as for Notifi Admin) */
  totp2FARequiredForEmailLogins: Totp2FaRequiredForEmailLoginsPayload;
  /** Get whether or not your account has 2FA set up and requires it to log in */
  totp2FAStatus: Totp2FaStatusPayload;
  /** Get users unread notification history count */
  unreadNotificationHistoryCount: GetUnreadNotificationHistoryCountResponse;
  /** Get the pre-signed URLs for the given reports */
  urlsForTenantStatisticalReports: GetUrlsForTenantStatisticalReportsOutput;
  /** User feature flags */
  userFeatureFlags?: Maybe<UserFeatureFlags>;
  /** Retrieve the user's points ranking information */
  userPointsRanking: UserPointsRanking;
  /** User profile. Omit GetUserProfileInput to retrieve caller's profile */
  userProfile?: Maybe<UserProfile>;
  /** User settings */
  userSettings?: Maybe<UserSettings>;
  /** Query for the count of users per topic across this tenant */
  usersByTopic: GetUsersByTopicResult;
  vapidPublicKeys?: Maybe<VapidPublicKeysConnection>;
  /** Query for Web3Targets */
  web3Targets?: Maybe<Web3TargetsConnection>;
  /** Query for WebPushTargets */
  webPushTargets?: Maybe<WebPushTargetsConnection>;
  /** Query for WebhookTargets. */
  webhookTarget?: Maybe<Array<WebhookTarget>>;
};


export type NotifiQueryActiveAlertsArgs = {
  activeAlertsInput: ActiveAlertsInput;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryAlertArgs = {
  getAlertInput?: InputMaybe<GetAlertInput>;
};


export type NotifiQueryAvailableTenantStatisticalReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GetAvailableTenantStatisticalReportsInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryBotsByTypeArgs = {
  getBotsByTypeInput: GetBotsByTypeInput;
};


export type NotifiQueryCampaignPerformanceArgs = {
  id: Scalars['String'];
};


export type NotifiQueryCampaignsByTenantIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryCommunityManagerPublishTaskArgs = {
  id: Scalars['String'];
};


export type NotifiQueryConfigurationForDappArgs = {
  getConfigurationForDappInput?: InputMaybe<GetConfigurationForDappInput>;
};


export type NotifiQueryConnectedWalletArgs = {
  getConnectedWalletsInput?: InputMaybe<GetConnectedWalletsInput>;
};


export type NotifiQueryConversationArgs = {
  getConversationInput: GetConversationInput;
};


export type NotifiQueryConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getConversationMessagesInput: GetConversationMessagesInput;
};


export type NotifiQueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryDiscordTargetArgs = {
  getTargetInput?: InputMaybe<GetTargetInput>;
};


export type NotifiQueryEmailTargetArgs = {
  getTargetInput?: InputMaybe<GetTargetInput>;
};


export type NotifiQueryEphemeralStorageArgs = {
  after?: InputMaybe<Scalars['String']>;
  ephemeralStorageQueryInput?: InputMaybe<EphemeralStorageQueryInput>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryFcmTargetsArgs = {
  getTargetInput?: InputMaybe<GetTargetInput>;
};


export type NotifiQueryFilterArgs = {
  getFilterInput?: InputMaybe<GetFilterInput>;
};


export type NotifiQueryFindTenantConfigArgs = {
  findTenantConfigInput: FindTenantConfigInput;
};


export type NotifiQueryFusionEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  fusionEventCategory?: InputMaybe<FusionEventCategory>;
};


export type NotifiQueryFusionExecutionLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getFusionExecutionLogsInput?: InputMaybe<GetFusionExecutionLogsInput>;
};


export type NotifiQueryFusionModulePutUrlArgs = {
  fusionSourceId: Scalars['String'];
  type: FusionModuleType;
};


export type NotifiQueryFusionNotificationHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  includeRead?: InputMaybe<Scalars['Boolean']>;
};


export type NotifiQueryFusionPreviewCommunityManagerContentArgs = {
  fusionCommunityManagerPreviewInput: FusionCommunityManagerPreviewInput;
};


export type NotifiQueryFusionSourceDevParamsArgs = {
  getFusionSourceDevParamsInput: GetFusionSourceDevParamsInput;
};


export type NotifiQueryFusionSourcePutUrlArgs = {
  fusionSourceId: Scalars['String'];
};


export type NotifiQueryFusionSourceStateArgs = {
  input: GetFusionSourceStateInput;
};


export type NotifiQueryFusionSourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryJabberMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getJabberMessagesInput: GetJabberMessagesInput;
};


export type NotifiQueryJabberThreadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryListAvailableSlackChannelsArgs = {
  input: ListAvailableSlackChannelInput;
};


export type NotifiQueryListTemplatesArgs = {
  input: ListTemplatesInput;
};


export type NotifiQueryMobilePushSettingsArgs = {
  mobilePushSettingsInput: MobilePushSettingsInput;
};


export type NotifiQueryNotificationByIdArgs = {
  id: Scalars['String'];
};


export type NotifiQueryNotificationHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<NotificationHistoryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryOpenUserRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryPersistentStorageArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  persistentStorageQueryInput?: InputMaybe<PersistentStorageQueryInput>;
};


export type NotifiQueryPreviewCommunityManagerContentArgs = {
  communityManagerPreviewInput: CommunityManagerPreviewInput;
};


export type NotifiQueryPublicDappMetadataArgs = {
  input: GetPublicDappMetadataInput;
};


export type NotifiQueryPublicTopicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<GetPublicTopicsInput>;
};


export type NotifiQueryPublicUserTopicPostArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getPublicUserTopicPostInput: GetPublicUserTopicPostInput;
};


export type NotifiQueryResolveSnsFromAddressArgs = {
  address: Scalars['String'];
};


export type NotifiQueryRewardOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: RewardOffersInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type NotifiQuerySlackChannelBotInfoArgs = {
  input: GetSlackChannelBotInfoInput;
};


export type NotifiQuerySlackChannelTargetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GetTargetsInput;
};


export type NotifiQuerySlackWorkspaceIconArgs = {
  input: GetSlackWorkspaceIconInput;
};


export type NotifiQuerySmsTargetArgs = {
  getTargetInput?: InputMaybe<GetTargetInput>;
};


export type NotifiQuerySourceArgs = {
  getSourceInput?: InputMaybe<GetSourceInput>;
};


export type NotifiQuerySourceGroupArgs = {
  getSourceGroupInput?: InputMaybe<GetSourceGroupInput>;
};


export type NotifiQuerySourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getSourcesInput?: InputMaybe<GetSourcesInput>;
};


export type NotifiQuerySupportedTargetTypesForDappArgs = {
  getSupportedTargetTypesForDappInput?: InputMaybe<GetSupportedTargetTypesForDappInput>;
};


export type NotifiQueryTargetGroupArgs = {
  getTargetGroupInput?: InputMaybe<GetTargetGroupInput>;
};


export type NotifiQueryTelegramTargetArgs = {
  getTargetInput?: InputMaybe<GetTargetInput>;
};


export type NotifiQueryTemplateDataArgs = {
  input: GetTemplateDataInput;
};


export type NotifiQueryTenantConfigsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getTenantConfigInput: GetTenantConfigInput;
};


export type NotifiQueryTenantConnectedWalletArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getTenantConnectedWalletInput?: InputMaybe<GetTenantConnectedWalletInput>;
};


export type NotifiQueryTenantDeliveryReportArgs = {
  input: GetTenantDeliveryReportRequestInput;
};


export type NotifiQueryTenantFeatureFlagArgs = {
  input: TenantFeatureFlagInput;
};


export type NotifiQueryTenantUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  tenantUsersInput?: InputMaybe<TenantUsersInput>;
};


export type NotifiQueryTenantUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  tenantUsersInput?: InputMaybe<TenantUsersInput>;
};


export type NotifiQueryTopicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryTotalMessagesPerTopicByTenantArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GetTotalMessagesPerTopicByTenantInput;
};


export type NotifiQueryUnreadNotificationHistoryCountArgs = {
  input?: InputMaybe<GetUnreadNotificationHistoryCountInput>;
};


export type NotifiQueryUrlsForTenantStatisticalReportsArgs = {
  input: GetUrlsForTenantStatisticalReportsInput;
};


export type NotifiQueryUserProfileArgs = {
  getUserProfileInput?: InputMaybe<GetUserProfileInput>;
};


export type NotifiQueryVapidPublicKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type NotifiQueryWeb3TargetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getWeb3TargetsInput?: InputMaybe<GetWeb3TargetsInput>;
};


export type NotifiQueryWebPushTargetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<GetTargetsInput>;
};


export type NotifiQueryWebhookTargetArgs = {
  getTargetInput?: InputMaybe<GetTargetInput>;
};

export type NotifiSubscription = {
  __typename?: 'NotifiSubscription';
  messageReceived: ConversationMessage;
  stateChanged: StateChangedEvent;
  tenantActiveAlertChanged: TenantActiveAlertChangeEvent;
  tenantEntityChanged: TenantEntityChangeEvent;
};

export enum NotificationCategory {
  BALANCE_CHANGE = 'BALANCE_CHANGE',
  CHAT = 'CHAT',
  COIN_PRICE_CHANGE = 'COIN_PRICE_CHANGE',
  CREATOR_MESSAGE = 'CREATOR_MESSAGE',
  DAO_PROPOSAL = 'DAO_PROPOSAL',
  NFT_AUCTION = 'NFT_AUCTION'
}

/** A connection to a list of items. */
export type NotificationHistoryConnection = {
  __typename?: 'NotificationHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NotificationHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<NotificationHistoryEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationHistoryEdge = {
  __typename?: 'NotificationHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NotificationHistoryEntry;
};

export type NotificationHistoryEntry = {
  __typename?: 'NotificationHistoryEntry';
  alertId: Scalars['String'];
  category?: Maybe<NotificationCategory>;
  createdDate: Scalars['DateTime'];
  detail?: Maybe<EventDetails>;
  eventId: Scalars['String'];
  id: Scalars['String'];
  read: Scalars['Boolean'];
  sourceAddress?: Maybe<Scalars['String']>;
  targets: Array<NotificationTarget>;
  transactionSignature?: Maybe<Scalars['String']>;
};

export type NotificationHistoryFilterInput = {
  categories?: InputMaybe<Array<NotificationCategory>>;
};

export enum NotificationHistoryReadState {
  HIDDEN = 'HIDDEN',
  NONE = 'NONE',
  READ = 'READ'
}

export type NotificationHistoryStateChangedEvent = {
  __typename?: 'NotificationHistoryStateChangedEvent';
  timestamp: Scalars['DateTime'];
};

export type NotificationTarget = {
  __typename?: 'NotificationTarget';
  name?: Maybe<Scalars['String']>;
  type: TargetType;
};

/** Data about notifications for reward conditions */
export type NotificationsData = {
  __typename?: 'NotificationsData';
  /** Unique identifier for the fusion event type */
  fusionEventTypeId: Scalars['String'];
  /** Delivery status of the notification target */
  targetDeliveryStatus: TargetDeliveryStatus;
  /** Type of the target for the notification */
  targetType: PointsTargetType;
};

export enum OAuthIssuer {
  APPLE = 'APPLE',
  CUSTOM = 'CUSTOM',
  FACEBOOK = 'FACEBOOK',
  GITHUB = 'GITHUB',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  TWITTER = 'TWITTER',
  UNSTOPPABLE_DOMAINS = 'UNSTOPPABLE_DOMAINS'
}

/** Output for off-chain conditions or data */
export type OffChainDataOutput = {
  __typename?: 'OffChainDataOutput';
  /** Placeholder for off-chain data */
  placeholder: Scalars['String'];
};

/** Conditions that need to be met for a reward offer */
export type OfferCondition = {
  __typename?: 'OfferCondition';
  calculateSize: Scalars['Int'];
  clone?: Maybe<OfferCondition>;
  conditionDetailsCase: ConditionDetailsOneofCase;
  /** Notification-related conditions */
  notifications?: Maybe<NotificationsData>;
  /** Off-chain conditions or data */
  offChain?: Maybe<OffChainDataOutput>;
  /** Number of times the condition needs to be met */
  requiredCount: Scalars['Int'];
  /** User actions that need to be performed */
  userActions?: Maybe<UserActionsDataOutput>;
  /** User interactions that need to occur */
  userInteractions?: Maybe<UserInteractionsDataOutput>;
};

/** Response object for a reward offer */
export type OfferResponse = {
  __typename?: 'OfferResponse';
  /** Current activation state of the offer */
  activationState?: Maybe<PointsOfferActivationState>;
  calculateSize: Scalars['Int'];
  clone?: Maybe<OfferResponse>;
  /** Conditions that need to be met for this offer */
  condition: OfferCondition;
  /** Timestamp for when the offer was first created */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Identifier of the dapp associated with this offer */
  dappId: Scalars['String'];
  /** Detailed description of the reward offer */
  description?: Maybe<Scalars['String']>;
  /** End date and time of the offer */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the reward offer */
  id: Scalars['String'];
  /** ID of the user who last updated this offer */
  lastUpdatedByUserId: Scalars['String'];
  /** Name of the reward offer */
  name: Scalars['String'];
  /** Rewards associated with this offer */
  reward?: Maybe<RewardData>;
  /** Start date and time of the offer */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Timestamp for when the offer was last updated */
  updatedDate?: Maybe<Scalars['DateTime']>;
};

export type OidcConfiguration = OidcCustomProviderConfiguration | OidcPublicProviderConfiguration;

export type OidcCustomProviderConfiguration = {
  __typename?: 'OidcCustomProviderConfiguration';
  claimToUseForUserId: Scalars['String'];
  clientId: Scalars['String'];
  issuer?: Maybe<Scalars['String']>;
  jwksUrl?: Maybe<Scalars['String']>;
  oidcConfigurationUrl?: Maybe<Scalars['String']>;
  oidcProvider: OidcProvider;
  requireVerifiedEmailAddress: Scalars['Boolean'];
  userIdPrefix?: Maybe<Scalars['String']>;
};

/** Indicates the issuer type of the id_token */
export enum OidcProvider {
  APPLE = 'APPLE',
  CUSTOM = 'CUSTOM',
  FACEBOOK = 'FACEBOOK',
  GITHUB = 'GITHUB',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  TWITTER = 'TWITTER',
  UNSTOPPABLE_DOMAINS = 'UNSTOPPABLE_DOMAINS'
}

/** OIDC provider enabled for this tenant */
export type OidcProviderConfiguration = {
  __typename?: 'OidcProviderConfiguration';
  /** ClientId set on the issuer that is producing the id_token. This value must be present in the aud claim */
  clientId?: Maybe<Scalars['String']>;
  /** Id of the OIDC provider configuration */
  id: Scalars['String'];
  /** Issuer of the id_token used for OIDC */
  issuer?: Maybe<OidcProvider>;
  /** The OIDC provider's configuration enabled for this tenant */
  providerConfig?: Maybe<OidcConfiguration>;
  /** Prefix added to unique id of user (typically pulled from sub claim) on the Custom Issuer */
  userIdPrefix?: Maybe<Scalars['String']>;
};

export type OidcPublicProviderConfiguration = {
  __typename?: 'OidcPublicProviderConfiguration';
  clientId: Scalars['String'];
  oidcProvider: OidcProvider;
  requireVerifiedEmailAddress: Scalars['Boolean'];
  userIdPrefix?: Maybe<Scalars['String']>;
};

/** Open user registration allowed for this tenant */
export type OpenUserRegistration = {
  __typename?: 'OpenUserRegistration';
  /** This is the time when this open user registration will be valid and allow users to sign up */
  beginTime?: Maybe<Timestamp>;
  /** Timestamp of when this open user registration was created */
  createdTime?: Maybe<Scalars['Long']>;
  /** Optional time when this open user registration ends */
  endTime?: Maybe<Timestamp>;
  /** FusionEvents/topics that a user registering through this open user registration will be automatically signed up for */
  fusionEventIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Id of the open user registration */
  id?: Maybe<Scalars['String']>;
  /** Name of the open user registration */
  name?: Maybe<Scalars['String']>;
  /** The user registration execution setup for this open user registration. This will provide the post url for emails, telegram action url, etc. */
  userRegistrationExecutionEndpoints?: Maybe<Array<Maybe<UserRegistrationExecutionEndpoint>>>;
};

/** A connection to a list of items. */
export type OpenUserRegistrationsConnection = {
  __typename?: 'OpenUserRegistrationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OpenUserRegistrationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OpenUserRegistration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OpenUserRegistrationsEdge = {
  __typename?: 'OpenUserRegistrationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OpenUserRegistration;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type PersistentStorageConnection = {
  __typename?: 'PersistentStorageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PersistentStorageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PersistentStorageEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PersistentStorageEdge = {
  __typename?: 'PersistentStorageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PersistentStorageEntry;
};

/** Persistent storage entry used by the Fusion system */
export type PersistentStorageEntry = {
  __typename?: 'PersistentStorageEntry';
  /** Date the entry was created */
  createdDate?: Maybe<Timestamp>;
  /** Key of the entry */
  key?: Maybe<Scalars['String']>;
  /** Date the entry was last updated */
  updatedDate?: Maybe<Timestamp>;
  /** Value of the entry */
  value?: Maybe<Scalars['String']>;
  /** Version of the entry */
  version?: Maybe<Scalars['Long']>;
};

export type PersistentStorageEntryInput = {
  /** Key of the entry to update */
  key: Scalars['String'];
  /** Value to update the entry to. Null values will cause the entry to be deleted */
  value?: InputMaybe<Scalars['String']>;
  /** Optional version of the entry to set. If provided, a write will only succeed if the version is greater than the current stored version. If omitted, the current version is overwritten */
  version?: InputMaybe<Scalars['Long']>;
};

/** Object used to query persistent storage used by the Fusion system */
export type PersistentStorageQueryInput = {
  /** Keys of the entries to be returned. Max of 50 per query */
  keys?: InputMaybe<Array<Scalars['String']>>;
};

/** Data about points rewards */
export type PointsDataGrpc = {
  __typename?: 'PointsDataGrpc';
  /** Amount of points to be rewarded */
  amount: Scalars['Long'];
  calculateSize: Scalars['Int'];
  clone?: Maybe<PointsDataGrpc>;
  /** Total supply of points (optional) */
  totalSupply?: Maybe<Scalars['Long']>;
};

export enum PointsEligibilityState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Entities that can perform actions in a points offer */
export enum PointsOfferActionEntity {
  /** Alert action entity */
  ALERT = 'ALERT',
  /** Source action entity */
  SOURCE = 'SOURCE',
  /** Target action entity */
  TARGET = 'TARGET',
  /** Unspecified action entity */
  UNSPECIFIED = 'UNSPECIFIED',
  /** User action entity */
  USER = 'USER'
}

/** Verbs describing actions in a points offer */
export enum PointsOfferActionVerb {
  /** Created action */
  CREATED = 'CREATED',
  /** Deleted action */
  DELETED = 'DELETED',
  /** Link opened action */
  LINK_OPENED = 'LINK_OPENED',
  /** Message opened action */
  MESSAGE_OPENED = 'MESSAGE_OPENED',
  /** Unspecified action verb */
  UNSPECIFIED = 'UNSPECIFIED',
  /** Updated action */
  UPDATED = 'UPDATED'
}

export enum PointsOfferActivationState {
  ACTIVATION_STATE_ACTIVE = 'ACTIVATION_STATE_ACTIVE',
  ACTIVATION_STATE_INACTIVE = 'ACTIVATION_STATE_INACTIVE',
  ACTIVATION_STATE_NEEDS_REVIEW = 'ACTIVATION_STATE_NEEDS_REVIEW',
  ACTIVATION_STATE_UNSPECIFIED = 'ACTIVATION_STATE_UNSPECIFIED'
}

export enum PointsTargetType {
  TARGET_TYPE_DISCORD = 'TARGET_TYPE_DISCORD',
  TARGET_TYPE_EMAIL = 'TARGET_TYPE_EMAIL',
  TARGET_TYPE_FCM = 'TARGET_TYPE_FCM',
  TARGET_TYPE_PLATFORM = 'TARGET_TYPE_PLATFORM',
  TARGET_TYPE_SLACK_CHANNEL = 'TARGET_TYPE_SLACK_CHANNEL',
  TARGET_TYPE_SMS = 'TARGET_TYPE_SMS',
  TARGET_TYPE_TELEGRAM = 'TARGET_TYPE_TELEGRAM',
  TARGET_TYPE_UNSPECIFIED = 'TARGET_TYPE_UNSPECIFIED',
  TARGET_TYPE_WEB3 = 'TARGET_TYPE_WEB3',
  TARGET_TYPE_WEBHOOK = 'TARGET_TYPE_WEBHOOK'
}

/** Public information about a Dapp */
export type PublicDappInfo = {
  __typename?: 'PublicDappInfo';
  /** A brief description of the Dapp */
  description?: Maybe<Scalars['String']>;
  /** The URL of the Dapp's icon */
  iconUrl?: Maybe<Scalars['String']>;
  /** The URL of the Dapp's logo */
  logoUrl?: Maybe<Scalars['String']>;
  /** The name of the Dapp */
  name?: Maybe<Scalars['String']>;
  /** The URL of the Dapp's website */
  websiteUrl?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type PublicTopicsConnection = {
  __typename?: 'PublicTopicsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PublicTopicsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SubscribeableTopic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PublicTopicsEdge = {
  __typename?: 'PublicTopicsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SubscribeableTopic;
};

/** Notifi Public UserTopic Post */
export type PublicUserTopicPost = {
  __typename?: 'PublicUserTopicPost';
  createdDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  topicName: Scalars['String'];
  variables: Array<KeyValuePairOfStringAndString>;
};

/** A connection to a list of items. */
export type PublicUserTopicPostConnection = {
  __typename?: 'PublicUserTopicPostConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PublicUserTopicPostEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PublicUserTopicPost>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PublicUserTopicPostEdge = {
  __typename?: 'PublicUserTopicPostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicUserTopicPost>;
};

export type PublishFusionMessageInput = {
  /** The event type ID */
  eventTypeId: Scalars['String'];
  /** The specific wallets to target, if any */
  specificWallets?: InputMaybe<Array<KeyValuePairOfStringAndWalletBlockchainInput>>;
  /** The variables to send, in json. Must be an object */
  variablesJson: Scalars['String'];
};

export type PublishFusionMessageResult = {
  __typename?: 'PublishFusionMessageResult';
  /** The uuid of the enqueued event */
  eventUuid: Scalars['String'];
};

export type Regenerate2FaBackupCodesError = RequiresElevatedTokenError;

export type Regenerate2FaBackupCodesPayload = {
  __typename?: 'Regenerate2FABackupCodesPayload';
  backupCodes?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<Regenerate2FaBackupCodesError>>;
};

/** Object used to remove an existing bot */
export type RemoveBotInput = {
  /** Id of the bot to remove */
  id: Scalars['String'];
};

/** Object used to remove an email sender domain for a tenant */
export type RemoveEmailSenderDomainInput = {
  /** Id of the domain that is being removed. If it was the default, no default will be set after removal */
  domainNameId: Scalars['String'];
};

export type RemoveFusionEventFromFusionSourceInput = {
  /** The fusion event id to remove from the fusion source id */
  fusionEventId: Scalars['String'];
};

export type RemoveFusionEventFromFusionSourceResponse = {
  __typename?: 'RemoveFusionEventFromFusionSourceResponse';
  /** The updated fusion source after the fusion event has been removed. */
  fusionSource: FusionSourceWithCursor;
};

export type RemoveServiceIdentifierInput = {
  sid: Scalars['String'];
};

export type RemoveServiceIdentifierPayload = {
  __typename?: 'RemoveServiceIdentifierPayload';
  success?: Maybe<Scalars['Boolean']>;
};

/** Remove a Source from a SourceGroup. Id and AccountAddress/WalletBlockchain are mutually exclusive. If SourceId is set, other parameters will be ignored. Setting WalletAddress requires SourceType to be set */
export type RemoveSourceFromSourceGroupInput = {
  /** Id of the SourceGroup object returned from CreateSourceGroup mutation or SourceGroup query */
  sourceGroupId: Scalars['String'];
  /** Id of the Source object returned from CreateSource or Sources */
  sourceId?: InputMaybe<Scalars['String']>;
  /** SourceType associated to WalletAddress */
  sourceType?: InputMaybe<SourceType>;
  /** For chains where public keys are rotatable and not tied to the lifetime of the account, use the accountId. Use public key for all other chains */
  walletAddress?: InputMaybe<Scalars['String']>;
};

export type RemoveTotp2FaError = RequiresElevatedTokenError;

export type RemoveTotp2FaPayload = {
  __typename?: 'RemoveTOTP2FAPayload';
  errors?: Maybe<Array<RemoveTotp2FaError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Object used to delete a user from the admin panel. */
export type RemoveTenantUserRolesInput = {
  /** Primary email address for account. */
  email: Scalars['String'];
  /** List of roles to remove from the user */
  roles: Array<Scalars['String']>;
};

export enum RequiredParserVariableType {
  /** Base58 wallets (Solana, Bitcoin) */
  BASE58_WALLET = 'BASE58_WALLET',
  /** Bech32 wallet (any prefix) */
  BECH32_WALLET = 'BECH32_WALLET',
  /** EVM wallet */
  EVM_WALLET = 'EVM_WALLET',
  /** Decimal value that can fit in a double precision float */
  FLOAT = 'FLOAT',
  /** Hexidecimal starting with 0x */
  HEX = 'HEX',
  /** Integer value that can fit in a signed 64bit integer */
  INTEGER = 'INTEGER',
  /** Any string */
  STRING = 'STRING',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type RequiredVariable = {
  __typename?: 'RequiredVariable';
  variableDescription: Scalars['String'];
  variableName: Scalars['String'];
  variableType: RequiredParserVariableType;
};

/** Thrown if this API is called without an elevated session token */
export type RequiresElevatedTokenError = Error & {
  __typename?: 'RequiresElevatedTokenError';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** Data about the rewards for an offer */
export type RewardData = {
  __typename?: 'RewardData';
  calculateSize: Scalars['Int'];
  clone?: Maybe<RewardData>;
  /** Points reward data */
  points?: Maybe<PointsDataGrpc>;
  rewardDetailsCase: RewardDetailsOneofCase;
  /** Tokens reward data */
  tokens?: Maybe<TokensDataGrpc>;
};

export enum RewardDetailsOneofCase {
  NONE = 'NONE',
  POINTS = 'POINTS',
  TOKENS = 'TOKENS'
}

/** Input for specifying conditions when querying reward offers */
export type RewardOffersConditionsInput = {
  /** Blockchain type for filtering offers */
  chainName?: InputMaybe<WalletBlockchain>;
};

/** A connection to a list of items. */
export type RewardOffersConnection = {
  __typename?: 'RewardOffersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RewardOffersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OfferResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RewardOffersEdge = {
  __typename?: 'RewardOffersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OfferResponse;
};

/** Input for querying reward offers */
export type RewardOffersInput = {
  /** Optional conditions for filtering offers */
  conditions?: InputMaybe<RewardOffersConditionsInput>;
  /** Optional end date for filtering offers */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional ID of a specific reward offer */
  id?: InputMaybe<Scalars['String']>;
  /** Optional name for filtering offers */
  name?: InputMaybe<Scalars['String']>;
  /** Optional start date for filtering offers */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Object used to query the public topics */
export type SendConversationMessageInput = {
  /** Conversation identifier */
  conversationId: Scalars['String'];
  /** Individual message of a conversation */
  message: Scalars['String'];
};

/** Describes a message to be sent directly to a user. */
export type SendMessageInput = {
  /** Message data to be sent. All but RawMessage require a JSON formatted object. See individual MessageTypes for requirements. Inlcude JSON members that your template requires. */
  message?: InputMaybe<Scalars['String']>;
  /** The key of the message. Multiple calls with the same key will be deduplicated. */
  messageKey?: InputMaybe<Scalars['String']>;
  /** Describes the message type of Message. RawMessage is a passthrough. SimpleHealthThreshold requires a single member, 'value', in range of [0, 100]. Include any other members required for your template. */
  messageType: MessageType;
  /** Blockchain the wallet belongs to. */
  walletBlockchain: WalletBlockchain;
  /** Target wallet address. */
  walletPublicKey?: InputMaybe<Scalars['String']>;
};

/** Describes the Target to send a confirmation request for */
export type SendTargetConfirmationRequestInput = {
  /** ID of the Target. Currently only EmailTargets are supported */
  targetId?: InputMaybe<Scalars['String']>;
};

/** An object describing credentials that an autonomous service can use to authenticate with Notifi APIs */
export type ServiceIdentifierOutput = {
  __typename?: 'ServiceIdentifierOutput';
  /** The SID portion of the service identifier */
  id: Scalars['String'];
  /** Whether or not the service identifier can be used to authenticate with Notifi */
  isActive: Scalars['Boolean'];
  /** @deprecated Secrets will not be returned in future versions */
  secret?: Maybe<Scalars['String']>;
  /** The internal ID of the user the service identifier authenticates */
  userId: Scalars['String'];
};

/** Input for service authentication using a SID/Secret pair */
export type ServiceLogInInput = {
  /** Secret for service auth params */
  secret: Scalars['String'];
  /** SID for service auth params */
  sid: Scalars['String'];
};

export type SidSecretTwoFactorChallengeAnswerInput = {
  secret: Scalars['String'];
  sid: Scalars['String'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Slack Channel Target */
export type SlackChannelTarget = {
  __typename?: 'SlackChannelTarget';
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slackChannelName?: Maybe<Scalars['String']>;
  slackWorkspaceName?: Maybe<Scalars['String']>;
  verificationLink?: Maybe<Scalars['String']>;
  verificationStatus: SlackTargetStatus;
  webhookVerificationLink?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type SlackChannelTargetsConnection = {
  __typename?: 'SlackChannelTargetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SlackChannelTargetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SlackChannelTarget>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SlackChannelTargetsEdge = {
  __typename?: 'SlackChannelTargetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SlackChannelTarget;
};

export enum SlackTargetStatus {
  MISSING_CHANNEL = 'MISSING_CHANNEL',
  MISSING_PERMISSIONS = 'MISSING_PERMISSIONS',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

export type SmsTarget = {
  __typename?: 'SmsTarget';
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

/** Notifi Source */
export type Source = {
  __typename?: 'Source';
  activeAlertCount: Scalars['Long'];
  applicableFilters?: Maybe<Array<Maybe<Filter>>>;
  blockchainAddress: Scalars['String'];
  createdDate: Scalars['DateTime'];
  fusionEventTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type: SourceType;
  updatedDate: Scalars['DateTime'];
};

export type SourceGroup = {
  __typename?: 'SourceGroup';
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Source>>>;
  updatedDate: Scalars['DateTime'];
};

/** Object used to create or bulk update a SourceGroup. Use AddSourceToSourceGroup or RemoveSourceFromSourceGroup for individual source updates */
export type SourceGroupInput = {
  /** Id of the SourceGroup */
  id?: InputMaybe<Scalars['String']>;
  /** Friendly name of SourceGroup */
  name?: InputMaybe<Scalars['String']>;
  /** Ids from previously created Sources */
  sourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum SourceType {
  ACALA_WALLET = 'ACALA_WALLET',
  AGORIC_WALLET = 'AGORIC_WALLET',
  APTOS_WALLET = 'APTOS_WALLET',
  ARBITRUM_WALLET = 'ARBITRUM_WALLET',
  ARCHWAY_WALLET = 'ARCHWAY_WALLET',
  ARCH_WALLET = 'ARCH_WALLET',
  AVALANCHE_WALLET = 'AVALANCHE_WALLET',
  AXELAR_WALLET = 'AXELAR_WALLET',
  BASE_WALLET = 'BASE_WALLET',
  BENQI = 'BENQI',
  BERACHAIN_WALLET = 'BERACHAIN_WALLET',
  BINANCE_WALLET = 'BINANCE_WALLET',
  BITCOIN_WALLET = 'BITCOIN_WALLET',
  BLAST_WALLET = 'BLAST_WALLET',
  BONFIDA_NAME_AUCTIONING = 'BONFIDA_NAME_AUCTIONING',
  BONFIDA_NAME_OFFERS = 'BONFIDA_NAME_OFFERS',
  BROADCAST = 'BROADCAST',
  CELESTIA_WALLET = 'CELESTIA_WALLET',
  CELO_WALLET = 'CELO_WALLET',
  COIN_PRICE_CHANGES = 'COIN_PRICE_CHANGES',
  COSMOS_WALLET = 'COSMOS_WALLET',
  DELTA_PRIME = 'DELTA_PRIME',
  DELTA_PRIME_LENDING_RATES = 'DELTA_PRIME_LENDING_RATES',
  DIRECT_PUSH = 'DIRECT_PUSH',
  DYDX_WALLET = 'DYDX_WALLET',
  DYMENSION_WALLET = 'DYMENSION_WALLET',
  ELYS_WALLET = 'ELYS_WALLET',
  ETHEREUM_WALLET = 'ETHEREUM_WALLET',
  FUSION_SOURCE = 'FUSION_SOURCE',
  HAWK_SIGHT = 'HAWK_SIGHT',
  HEDGE_PROTOCOL = 'HEDGE_PROTOCOL',
  KAVA_WALLET = 'KAVA_WALLET',
  LINEA_WALLET = 'LINEA_WALLET',
  MANTA_WALLET = 'MANTA_WALLET',
  MANTLE_WALLET = 'MANTLE_WALLET',
  METAPLEX_AUCTION_HOUSE = 'METAPLEX_AUCTION_HOUSE',
  MONAD_WALLET = 'MONAD_WALLET',
  MOVEMENT_WALLET = 'MOVEMENT_WALLET',
  NEUTRON_WALLET = 'NEUTRON_WALLET',
  NOTIFI_CHAT = 'NOTIFI_CHAT',
  OPTIMISM_WALLET = 'OPTIMISM_WALLET',
  ORAI_WALLET = 'ORAI_WALLET',
  ORCA = 'ORCA',
  PERSISTENCE_WALLET = 'PERSISTENCE_WALLET',
  POLYGON_WALLET = 'POLYGON_WALLET',
  PORT_FINANCE = 'PORT_FINANCE',
  REALM_PROPOSALS = 'REALM_PROPOSALS',
  SCROLL_WALLET = 'SCROLL_WALLET',
  SHARKY_PROTOCOL = 'SHARKY_PROTOCOL',
  SNAPSHOT = 'SNAPSHOT',
  SOLANA_BONFIDA_AUCTION = 'SOLANA_BONFIDA_AUCTION',
  SOLANA_JABBER_V1 = 'SOLANA_JABBER_V1',
  SOLANA_METAPLEX_AUCTION = 'SOLANA_METAPLEX_AUCTION',
  SOLANA_SNOWFLAKE = 'SOLANA_SNOWFLAKE',
  SOLANA_WALLET = 'SOLANA_WALLET',
  SUI_WALLET = 'SUI_WALLET',
  TERRA_WALLET = 'TERRA_WALLET',
  THE_ROOT_NETWORK = 'THE_ROOT_NETWORK',
  TOPAZ = 'TOPAZ',
  TRIBECA_PROPOSALS = 'TRIBECA_PROPOSALS',
  XION_WALLET = 'XION_WALLET',
  XMTP = 'XMTP',
  ZKSYNC = 'ZKSYNC',
  ZKSYNC_WALLET = 'ZKSYNC_WALLET'
}

/** A connection to a list of items. */
export type SourcesConnection = {
  __typename?: 'SourcesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SourcesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Source>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SourcesEdge = {
  __typename?: 'SourcesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Source;
};

export type SpecificWalletTarget = {
  __typename?: 'SpecificWalletTarget';
  address?: Maybe<Scalars['String']>;
  blockchainType: BlockchainType;
  calculateSize: Scalars['Int'];
  clone?: Maybe<SpecificWalletTarget>;
};

export type StateChangedEvent = NotificationHistoryStateChangedEvent | TargetStateChangedEvent;

/** Statistics for a specific target type in the campaign. */
export type StatisticsByTarget = {
  __typename?: 'StatisticsByTarget';
  /** The number of messages closed by recipients for this target type. */
  closed: Scalars['Int'];
  /** The number of messages successfully delivered for this target type. */
  delivered: Scalars['Int'];
  /** The number of messages opened by recipients for this target type. */
  opened: Scalars['Int'];
  /** The number of messages sent for this target type. */
  sent: Scalars['Int'];
  /** The identifier of the target type. */
  targetType: Scalars['String'];
};

export enum StorageType {
  INTERNAL_BLOB = 'INTERNAL_BLOB',
  INTERNAL_CACHE = 'INTERNAL_CACHE',
  INTERNAL_DB = 'INTERNAL_DB',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** A public topic that can be subscribed. */
export type SubscribeableTopic = {
  __typename?: 'SubscribeableTopic';
  /** The user-friendly name of this topic */
  displayName?: Maybe<Scalars['String']>;
  /** The topic identifier */
  topicName?: Maybe<Scalars['String']>;
};

export type Totp2FaRequiredForEmailLoginsPayload = {
  __typename?: 'TOTP2FARequiredForEmailLoginsPayload';
  totp2faRequired: Scalars['Boolean'];
};

export type Totp2FaStatusPayload = {
  __typename?: 'TOTP2FAStatusPayload';
  /** Whether or not your account has TOTP 2FA set up */
  isAdded: Scalars['Boolean'];
  /** Whether Notifi will ask you for your 2FA code, if you have one, in order to log in */
  isEnforced: Scalars['Boolean'];
  /** Whether your Dapp requires you to have 2FA set up in order to log in */
  isRequired: Scalars['Boolean'];
};

export type TargetAssignedToExistingTargetGroupError = Error & {
  __typename?: 'TargetAssignedToExistingTargetGroupError';
  message: Scalars['String'];
};

export enum TargetDeliveryStatus {
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  OPENED = 'OPENED',
  SENT = 'SENT',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type TargetDoesNotExistError = Error & {
  __typename?: 'TargetDoesNotExistError';
  message: Scalars['String'];
};

/** Notifi TargetGroup */
export type TargetGroup = {
  __typename?: 'TargetGroup';
  alerts?: Maybe<Array<Maybe<Alert>>>;
  createdDate: Scalars['DateTime'];
  discordTargets?: Maybe<Array<Maybe<DiscordTarget>>>;
  emailTargets?: Maybe<Array<Maybe<EmailTarget>>>;
  fcmTargets?: Maybe<Array<Maybe<FcmTarget>>>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slackChannelTargets?: Maybe<Array<Maybe<SlackChannelTarget>>>;
  smsTargets?: Maybe<Array<Maybe<SmsTarget>>>;
  telegramTargets?: Maybe<Array<Maybe<TelegramTarget>>>;
  updatedDate: Scalars['DateTime'];
  web3Targets?: Maybe<Array<Maybe<Web3Target>>>;
  webPushTargets?: Maybe<Array<Maybe<WebPushTarget>>>;
  webhookTargets?: Maybe<Array<Maybe<WebhookTarget>>>;
};

/** Object used to create or update a TargetGroup. */
export type TargetGroupInput = {
  /** Ids from previously created DiscordTargets. */
  discordTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created EmailTargets. */
  emailTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created FcmTargets. */
  fcmTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the TargetGroup. */
  id?: InputMaybe<Scalars['String']>;
  /** Friendly name of TargetGroup. */
  name?: InputMaybe<Scalars['String']>;
  /** Ids from previously created SlackChannelTargets. */
  slackChannelTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created SmsTargets. */
  smsTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created TelegramTargets. */
  telegramTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created SlackChannelTargets. */
  web3TargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created WebPushTargets. */
  webPushTargetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Ids from previously created WebhookTargets. */
  webhookTargetIds?: InputMaybe<Array<Scalars['String']>>;
};

export type TargetLimitExceededError = Error & {
  __typename?: 'TargetLimitExceededError';
  message: Scalars['String'];
};

export type TargetStateChangedEvent = {
  __typename?: 'TargetStateChangedEvent';
  targetId: Scalars['String'];
  targetType: TargetType;
  timestamp: Scalars['DateTime'];
};

export enum TargetType {
  BROWSER_PUSH = 'BROWSER_PUSH',
  DISCORD = 'DISCORD',
  EMAIL = 'EMAIL',
  FCM = 'FCM',
  PLATFORM = 'PLATFORM',
  SLACK_CHANNEL = 'SLACK_CHANNEL',
  SMS = 'SMS',
  TELEGRAM = 'TELEGRAM',
  WEB3 = 'WEB3',
  WEBHOOK = 'WEBHOOK'
}

export type TelegramTarget = {
  __typename?: 'TelegramTarget';
  /** Used to confirm the Telegram chat. User must click url and start bot. */
  confirmationUrl?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  isAccountOwner: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  telegramId: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

export type TelegramUserRegistrationExecutionEndpoint = {
  __typename?: 'TelegramUserRegistrationExecutionEndpoint';
  groupUserActionUrl: Scalars['String'];
  targetType: TargetType;
  userActionUrl: Scalars['String'];
};

export type Template = {
  __typename?: 'Template';
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  message: Scalars['String'];
  templateName: Scalars['String'];
  templateType: TemplateType;
  tenantId: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

export enum TemplateType {
  BROWSER_PUSH = 'BROWSER_PUSH',
  BROWSER_PUSH_SUBJECT = 'BROWSER_PUSH_SUBJECT',
  DISCORD = 'DISCORD',
  EMAIL = 'EMAIL',
  EMAIL_SUBJECT = 'EMAIL_SUBJECT',
  EVENT_DETAIL_BODY = 'EVENT_DETAIL_BODY',
  EVENT_DETAIL_TITLE = 'EVENT_DETAIL_TITLE',
  FCM = 'FCM',
  FCM_SUBJECT = 'FCM_SUBJECT',
  SLACK_CHANNEL = 'SLACK_CHANNEL',
  SMS = 'SMS',
  TELEGRAM = 'TELEGRAM',
  WEB3 = 'WEB3',
  WEBHOOK = 'WEBHOOK'
}

/** Notifi tenant information */
export type Tenant = {
  __typename?: 'Tenant';
  dappId: Scalars['String'];
  name: Scalars['String'];
};

export type TenantActiveAlertChangeEvent = ActiveAlertCreatedEvent | ActiveAlertDeletedEvent;

/** The response for a tenant config query */
export type TenantConfig = {
  __typename?: 'TenantConfig';
  createdDate: Scalars['DateTime'];
  dataJson: Scalars['String'];
  fusionEvents?: Maybe<Array<Maybe<FusionEventDescriptor>>>;
  id: Scalars['String'];
  type: TenantConfigType;
  updatedDate: Scalars['DateTime'];
};

export enum TenantConfigType {
  INTERCOM_CARD = 'INTERCOM_CARD',
  SUBSCRIPTION_CARD = 'SUBSCRIPTION_CARD'
}

/** A connection to a list of items. */
export type TenantConfigsConnection = {
  __typename?: 'TenantConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TenantConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TenantConfigsEdge = {
  __typename?: 'TenantConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TenantConfig;
};

/** Notifi Tenant Connected Wallet */
export type TenantConnectedWallet = {
  __typename?: 'TenantConnectedWallet';
  address?: Maybe<Scalars['String']>;
  user?: Maybe<TenantUser>;
  walletBlockchain: WalletBlockchain;
};

/** A connection to a list of items. */
export type TenantConnectedWalletConnection = {
  __typename?: 'TenantConnectedWalletConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantConnectedWalletEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TenantConnectedWallet>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TenantConnectedWalletEdge = {
  __typename?: 'TenantConnectedWalletEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TenantConnectedWallet>;
};

export type TenantEntityChangeEvent = AlertCreatedEvent | AlertDeletedEvent | UserCreatedEvent;

export type TenantFeatureFlag = {
  __typename?: 'TenantFeatureFlag';
  /** Tenant feature flag name. */
  name: Scalars['String'];
  /** Tenant feature flag value. Value can be a string or a json string. */
  value: Scalars['String'];
};

export type TenantFeatureFlagInput = {
  /** Query will fetch the feature flag value for the given name. */
  tenantFeatureFlagName: Scalars['String'];
};

export type TenantStatisticalReportOutput = {
  __typename?: 'TenantStatisticalReportOutput';
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  reportType: TenantStatisticalReportType;
  startTime: Scalars['DateTime'];
};

export enum TenantStatisticalReportType {
  ACTIVITY_REPORT = 'ACTIVITY_REPORT',
  MESSAGE_DELIVERY_REPORT = 'MESSAGE_DELIVERY_REPORT',
  NOTIFICATIONS_REPORT = 'NOTIFICATIONS_REPORT',
  SUBSCRIBER_LIST = 'SUBSCRIBER_LIST'
}

/** Notifi Tenant Target Group */
export type TenantTargetGroup = {
  __typename?: 'TenantTargetGroup';
  hasVerifiedDiscord: Scalars['Boolean'];
  hasVerifiedEmails: Scalars['Boolean'];
  hasVerifiedFcm: Scalars['Boolean'];
  hasVerifiedSms: Scalars['Boolean'];
  hasVerifiedTelegram: Scalars['Boolean'];
  hasVerifiedWeb3: Scalars['Boolean'];
  hasVerifiedWebhook: Scalars['Boolean'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** Notifi Tenant User */
export type TenantUser = {
  __typename?: 'TenantUser';
  alerts?: Maybe<Array<Maybe<TenantUserAlert>>>;
  connectedWallets?: Maybe<Array<Maybe<TenantConnectedWallet>>>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  userName?: Maybe<Scalars['String']>;
};

/** Notifi Tenant User Alert */
export type TenantUserAlert = {
  __typename?: 'TenantUserAlert';
  filter: Filter;
  filterOptions: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  sourceGroup: SourceGroup;
  targetGroup?: Maybe<TenantTargetGroup>;
  user?: Maybe<TenantUser>;
};

/** A connection to a list of items. */
export type TenantUserConnection = {
  __typename?: 'TenantUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TenantUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TenantUserEdge = {
  __typename?: 'TenantUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TenantUser>;
};

/** A connection to a list of items. */
export type TenantUsersConnection = {
  __typename?: 'TenantUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TenantUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TenantUsersEdge = {
  __typename?: 'TenantUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TenantUser>;
};

/** Object used to query TenantUsers. */
export type TenantUsersInput = {
  /** Filter roles for admin panel */
  filterRoles?: InputMaybe<Array<Scalars['String']>>;
};

export type Timestamp = {
  __typename?: 'Timestamp';
  calculateSize: Scalars['Int'];
  clone?: Maybe<Timestamp>;
  nanos: Scalars['Int'];
  seconds: Scalars['Long'];
  toDateTime: Scalars['DateTime'];
  toDateTimeOffset: Scalars['DateTime'];
  toDiagnosticString?: Maybe<Scalars['String']>;
};

/** Data about token rewards */
export type TokensDataGrpc = {
  __typename?: 'TokensDataGrpc';
  /** Amount of tokens to be rewarded */
  amount: Scalars['Long'];
  calculateSize: Scalars['Int'];
  clone?: Maybe<TokensDataGrpc>;
  /** Symbol or identifier of the token */
  symbol: Scalars['String'];
  /** Total supply of tokens (optional) */
  totalSupply?: Maybe<Scalars['Long']>;
};

/** A connection to a list of items. */
export type TopicsConnection = {
  __typename?: 'TopicsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TopicsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserTopic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopicsEdge = {
  __typename?: 'TopicsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserTopic;
};

/** A connection to a list of items. */
export type TotalMessagesPerTopicByTenantConnection = {
  __typename?: 'TotalMessagesPerTopicByTenantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TotalMessagesPerTopicByTenantEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<GetTotalMessagesPerTopicByTenantPayload>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TotalMessagesPerTopicByTenantEdge = {
  __typename?: 'TotalMessagesPerTopicByTenantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GetTotalMessagesPerTopicByTenantPayload;
};

export type TotpTwoFactorChallengeAnswerInput = {
  totpCode: Scalars['String'];
};

export type TwoFactorChallengeAnswerInput = {
  backupCodeAnswer?: InputMaybe<BackupCodeTwoFactorChallengeAnswerInput>;
  sidSecretAnswer?: InputMaybe<SidSecretTwoFactorChallengeAnswerInput>;
  totpAnswer?: InputMaybe<TotpTwoFactorChallengeAnswerInput>;
};

export type UnauthorizedAccessError = Error & {
  __typename?: 'UnauthorizedAccessError';
  message: Scalars['String'];
};

export type UnauthorizedXmtpAccountError = Error & {
  __typename?: 'UnauthorizedXmtpAccountError';
  message: Scalars['String'];
};

export type UnexpectedError = Error & {
  __typename?: 'UnexpectedError';
  message: Scalars['String'];
};

export type UnsubscribeInputTypeInput = {
  token: Scalars['String'];
};

/** A response from unsubscribing a target. */
export type UnsubscribeResult = {
  __typename?: 'UnsubscribeResult';
  targetValue: Scalars['String'];
  tenantName: Scalars['String'];
};

export type UnsupportedWeb3ProtocolError = Error & {
  __typename?: 'UnsupportedWeb3ProtocolError';
  message: Scalars['String'];
};

export type UnverifiedXmtpTargetError = Error & {
  __typename?: 'UnverifiedXmtpTargetError';
  message: Scalars['String'];
};

/** Object used to update an existing bot */
export type UpdateBotInput = {
  /** Bot credentials to be used when sending messages */
  botCredentials?: InputMaybe<Scalars['String']>;
  /** Existing bot id */
  id: Scalars['String'];
  /** Unique name of the bot. This may also be used when users are shown the bot name such as in Telegram or Discord */
  name?: InputMaybe<Scalars['String']>;
};

/** Object used to update the CORS policy for a tenant */
export type UpdateCorsPolicyInput = {
  /** Non-wildcard domains that are allowed to be used for CORS validation */
  allowedDomains: Array<Scalars['String']>;
};

/** Object used to update the default email sender name for a tenant */
export type UpdateDefaultEmailSenderDisplayNameInput = {
  /** Default sender display name to use. Omit to remove */
  defaultDisplayName?: InputMaybe<Scalars['String']>;
};

/** Object used to update the default email sender domain for a tenant */
export type UpdateDefaultEmailSenderDomainInput = {
  /** Id of the default sender domain to use. Omit to remove */
  defaultDomainId?: InputMaybe<Scalars['String']>;
};

/** Object used to update the default email sender name for a tenant */
export type UpdateDefaultEmailSenderNameInput = {
  /** Default sender name to use. Omit to remove */
  defaultName?: InputMaybe<Scalars['String']>;
};

/** Object used to update the tenant's discord bot configuration. */
export type UpdateDiscordBotConfigurationInput = {
  /** The Discord server id in which the Discord bot resides */
  discordGuildId: Scalars['String'];
  /** The invite link to join the tenant's Discord server. */
  discordServerInviteLink: Scalars['String'];
  /** The redirect site for OAuth2. This url is configured in Discord's developer portal */
  redirectUrl: Scalars['String'];
};

/** Object used to upsert values in ephemeral storage */
export type UpdateEphemeralStorageInput = {
  /** Entries to update the persistent storage with */
  entries: Array<EphemeralStorageEntryInput>;
};

/** Result from UpdateEphemeralStorageResult mutation */
export type UpdateEphemeralStorageResult = {
  __typename?: 'UpdateEphemeralStorageResult';
  /** Entries that were updated */
  entries?: Maybe<Array<Maybe<EphemeralStorageEntry>>>;
};

export type UpdateFusionEventInput = {
  fusionEventId: Scalars['String'];
  metadataJson?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateFusionSourceInput = {
  /** Update the fusion source filter. NOTE: The update will not actually happen unless the source is activated after setting this. If the source is currently running, Deactivate, then Activate again after setting this */
  filter?: InputMaybe<Scalars['String']>;
  /** Update the fusion source with this id. */
  fusionSourceId: Scalars['String'];
  /** Update the fusion source name */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFusionSourceResponse = {
  __typename?: 'UpdateFusionSourceResponse';
  /** Operation ID that will be set on success of queuing the operation. You can use this ID in the future to either poll for status or listen to updates from subscriptions */
  asyncOperationId?: Maybe<Scalars['String']>;
  /**
   * The updated fusion source
   * @deprecated Do not use this anymore, as the operation is async and eventually consistent. Check for queued success by looking at AsyncOperationId, and then periodically poll or listen for async updates via subscriptions
   */
  fusionSource: FusionSourceWithCursor;
};

export type UpdateOpenRegistrationResponse = {
  __typename?: 'UpdateOpenRegistrationResponse';
  calculateSize: Scalars['Int'];
  clone?: Maybe<UpdateOpenRegistrationResponse>;
};

export type UpdateOpenUserRegistrationError = ArgumentError;

/** Object used to update an existing open user registration campaign allowing users to sign up for any notifications */
export type UpdateOpenUserRegistrationInput = {
  endTime: Scalars['DateTime'];
  /** ID of the campaign/link. This is used to help identify the respective campaign */
  openUserRegistrationCampaignId: Scalars['String'];
};

export type UpdateOpenUserRegistrationPayload = {
  __typename?: 'UpdateOpenUserRegistrationPayload';
  errors?: Maybe<Array<UpdateOpenUserRegistrationError>>;
  updateOpenRegistrationResponse?: Maybe<UpdateOpenRegistrationResponse>;
};

/** Object used to upsert values in persistent storage */
export type UpdatePersistentStorageInput = {
  /** Entries to update the persistent storage with */
  entries: Array<PersistentStorageEntryInput>;
};

/** Result from UpdatePersistentStorageResult mutation */
export type UpdatePersistentStorageResult = {
  __typename?: 'UpdatePersistentStorageResult';
  /** Entries that were updated */
  entries?: Maybe<Array<Maybe<PersistentStorageEntry>>>;
};

export type UpdateWebPushTargetError = TargetDoesNotExistError | UnexpectedError;

export type UpdateWebPushTargetInput = {
  auth: Scalars['String'];
  endpoint: Scalars['String'];
  id: Scalars['String'];
  p256dh: Scalars['String'];
};

export type UpdateWebPushTargetResponse = {
  __typename?: 'UpdateWebPushTargetResponse';
  errors?: Maybe<Array<UpdateWebPushTargetError>>;
  webPushTarget?: Maybe<WebPushTarget>;
};

/** Notifi User */
export type User = {
  __typename?: 'User';
  alerts?: Maybe<Array<Maybe<Alert>>>;
  authorization?: Maybe<Authorization>;
  email?: Maybe<Scalars['String']>;
  emailConfirmed?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<CreateOrUpdateUserError>>;
  id?: Maybe<Scalars['String']>;
  profile?: Maybe<UserProfile>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  settings?: Maybe<UserSettings>;
};

/** Output for user actions that need to be performed */
export type UserActionsDataOutput = {
  __typename?: 'UserActionsDataOutput';
  /** Entity associated with the action */
  actionEntity: PointsOfferActionEntity;
  /** Verb describing the action */
  actionVerb: PointsOfferActionVerb;
  /** Identifier of the entity associated with the action */
  entityId: Scalars['String'];
};

/** An event emitted when a user is created in the tenant */
export type UserCreatedEvent = {
  __typename?: 'UserCreatedEvent';
  user?: Maybe<TenantUser>;
};

export type UserFeatureFlags = {
  __typename?: 'UserFeatureFlags';
  chatEnabled?: Maybe<Scalars['Boolean']>;
};

/** Object used to login/create an account. */
export type UserInput = {
  /** Primary email address for account. This will be used for verification and password resets. */
  email?: InputMaybe<Scalars['String']>;
  /** Password used for account. Must be at least 10 characters with at least 1 capital, 1 lower, 1 numeric and one symbol. */
  password?: InputMaybe<Scalars['String']>;
};

/** Output for user interactions that need to occur */
export type UserInteractionsDataOutput = {
  __typename?: 'UserInteractionsDataOutput';
  /** Verb describing the interaction */
  actionVerb: PointsOfferActionVerb;
  /** Delivery status of the target */
  targetDeliveryStatus: TargetDeliveryStatus;
};

/** User's points ranking information */
export type UserPointsRanking = {
  __typename?: 'UserPointsRanking';
  /** The timestamp of when the ranking was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** The user's current ranking */
  ranking: Scalars['Int'];
  /** The total number of dapps the user has interacted with */
  totalDapps: Scalars['Long'];
  /** The total points earned by the user */
  totalPoints: Scalars['Long'];
};

/** Notifi user profile */
export type UserProfile = {
  __typename?: 'UserProfile';
  avatarData?: Maybe<Scalars['String']>;
  avatarDataType: AvatarDataType;
  id: Scalars['String'];
  preferredAddress?: Maybe<Scalars['String']>;
  preferredBlockchain: WalletBlockchain;
  preferredName?: Maybe<Scalars['String']>;
  tenantInfo?: Maybe<Tenant>;
};

/** Object used to update a user's profile. Only specified fields will be updated */
export type UserProfileInput = {
  /** Avatar data specifying the url or notifi stock avatar to use. Requires AvatarDataType */
  avatarData?: InputMaybe<Scalars['String']>;
  /** Avatar data type used to interpret the AvatarData. Requires AvatarData */
  avatarDataType?: InputMaybe<AvatarDataType>;
  /** The Preferred address to use. Requires PreferredBlockchain */
  preferredAddress?: InputMaybe<Scalars['String']>;
  /** The Preferred blockchain to use. Requires PreferredAddress */
  preferredBlockchain?: InputMaybe<WalletBlockchain>;
};

export type UserRegistrationExecutionEndpoint = EmailUserRegistrationExecutionEndpoint | TelegramUserRegistrationExecutionEndpoint;

/** User Settings */
export type UserSettings = {
  __typename?: 'UserSettings';
  detailedAlertHistoryEnabled: Scalars['Boolean'];
  ftuStage?: Maybe<Scalars['Int']>;
  pointsState: PointsEligibilityState;
  pointsStateLastUpdated?: Maybe<Scalars['DateTime']>;
  userHasChatEnabled: Scalars['Boolean'];
};

/** Object used to update user settings. Only specified fields will be updated */
export type UserSettingsInput = {
  /** Allow Notifi to store details as part of alert history */
  detailedAlertHistoryEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The FTU stage to set */
  ftuStage?: InputMaybe<Scalars['Int']>;
  /** The points eligibility state to set */
  pointsState?: InputMaybe<PointsEligibilityState>;
  /** Enable the chat on the UI */
  userHasChatEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UserTopic = {
  __typename?: 'UserTopic';
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  targetCollections?: Maybe<Array<Scalars['String']>>;
  targetTemplate?: Maybe<Scalars['String']>;
  topicName: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

export type VapidPublicKey = {
  __typename?: 'VapidPublicKey';
  publicKey: Scalars['String'];
};

/** A connection to a list of items. */
export type VapidPublicKeysConnection = {
  __typename?: 'VapidPublicKeysConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VapidPublicKeysEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VapidPublicKey>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VapidPublicKeysEdge = {
  __typename?: 'VapidPublicKeysEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: VapidPublicKey;
};

export type VerifyCbwTargetError = UnsupportedWeb3ProtocolError | UnverifiedXmtpTargetError | Web3TargetNotFoundError;

export type VerifyCbwTargetInput = {
  targetId: Scalars['String'];
};

export type VerifyCbwTargetResponse = {
  __typename?: 'VerifyCbwTargetResponse';
  errors?: Maybe<Array<VerifyCbwTargetError>>;
  web3Target?: Maybe<Web3Target>;
};

/** Object used to verify a new Discord target. */
export type VerifyDiscordTargetInput = {
  /** Code from OAuth2 */
  code: Scalars['String'];
  /** Discord target id */
  discordTargetId: Scalars['String'];
  /** Redirected Uri */
  redirectUri: Scalars['String'];
  /** Token value sent in verification message. */
  token?: InputMaybe<Scalars['String']>;
};

export type VerifySlackChannelTargetForWebhookInput = {
  /** Code from OAuth2 */
  code: Scalars['String'];
  slackChannelTargetId: Scalars['String'];
};

export type VerifySlackChannelTargetForWebhookResponse = {
  __typename?: 'VerifySlackChannelTargetForWebhookResponse';
  slackChannelTarget: SlackChannelTarget;
};

export type VerifySlackChannelTargetInput = {
  /** Code from OAuth2 */
  code: Scalars['String'];
  slackChannelTargetId: Scalars['String'];
};

export type VerifySlackChannelTargetResponse = {
  __typename?: 'VerifySlackChannelTargetResponse';
  slackChannelTarget: SlackChannelTarget;
};

/** Object used to verify a new Target. */
export type VerifyTargetInput = {
  /** Token value sent in verification message. */
  token?: InputMaybe<Scalars['String']>;
};

export type VerifyXmtpTargetError = InvalidXmtpConsentProofError | UnauthorizedXmtpAccountError | UnsupportedWeb3ProtocolError | Web3TargetNotFoundError;

export type VerifyXmtpTargetInput = {
  /** Xmtp wallet address */
  accountId: Scalars['String'];
  /** Consent proof to prove consent for a receiving address as outlined in XIP-43 */
  consentProofSignature: Scalars['String'];
  /** Special flag for Coinbase Wallet. Will be depreciated later. Set this to false if unsure. */
  isCBW?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp in milliseconds since Unix epoch. January 1, 1970 (midnight UTC/GMT) */
  timestamp: Scalars['Long'];
  /** Specify the web3 target id that you will be verifying. */
  web3TargetId: Scalars['String'];
};

export type VerifyXmtpTargetResponse = {
  __typename?: 'VerifyXmtpTargetResponse';
  errors?: Maybe<Array<VerifyXmtpTargetError>>;
  web3Target?: Maybe<Web3Target>;
};

export type VerifyXmtpTargetViaXip42Error = UnauthorizedXmtpAccountError | UnsupportedWeb3ProtocolError | Web3TargetNotFoundError | XmtpAccountIsntConnectedWalletError;

export type VerifyXmtpTargetViaXip42Input = {
  /** Xmtp wallet address */
  accountId: Scalars['String'];
  /** The conversation topic created in the XMTP network. */
  conversationTopic: Scalars['String'];
  /** Specify the web3 target id that you will be verifying. */
  web3TargetId: Scalars['String'];
};

export type VerifyXmtpTargetViaXip42Response = {
  __typename?: 'VerifyXmtpTargetViaXip42Response';
  errors?: Maybe<Array<VerifyXmtpTargetViaXip42Error>>;
  web3Target?: Maybe<Web3Target>;
};

export enum WalletBlockchain {
  ACALA = 'ACALA',
  AGORIC = 'AGORIC',
  APTOS = 'APTOS',
  ARBITRUM = 'ARBITRUM',
  ARCH = 'ARCH',
  ARCHWAY = 'ARCHWAY',
  AVALANCHE = 'AVALANCHE',
  AXELAR = 'AXELAR',
  BASE = 'BASE',
  BERACHAIN = 'BERACHAIN',
  BINANCE = 'BINANCE',
  BITCOIN = 'BITCOIN',
  BLAST = 'BLAST',
  CELESTIA = 'CELESTIA',
  CELO = 'CELO',
  COSMOS = 'COSMOS',
  DYDX = 'DYDX',
  DYMENSION = 'DYMENSION',
  ELYS = 'ELYS',
  ETHEREUM = 'ETHEREUM',
  EVMOS = 'EVMOS',
  INJECTIVE = 'INJECTIVE',
  KAVA = 'KAVA',
  LINEA = 'LINEA',
  MANTA = 'MANTA',
  MANTLE = 'MANTLE',
  MONAD = 'MONAD',
  MOVEMENT = 'MOVEMENT',
  NEAR = 'NEAR',
  NEUTRON = 'NEUTRON',
  NIBIRU = 'NIBIRU',
  OFF_CHAIN = 'OFF_CHAIN',
  OPTIMISM = 'OPTIMISM',
  ORAI = 'ORAI',
  OSMOSIS = 'OSMOSIS',
  PERSISTENCE = 'PERSISTENCE',
  POLYGON = 'POLYGON',
  SCROLL = 'SCROLL',
  SOLANA = 'SOLANA',
  SUI = 'SUI',
  THE_ROOT_NETWORK = 'THE_ROOT_NETWORK',
  XION = 'XION',
  ZKSYNC = 'ZKSYNC'
}

export type WalletsActivityReportEventDetails = {
  __typename?: 'WalletsActivityReportEventDetails';
  providerName: Scalars['String'];
  sourceLink: Scalars['String'];
  type: WalletsActivityReportType;
  wallets: Array<WalletsActivityReportWallet>;
};

export enum WalletsActivityReportType {
  MOST_ACTIVE = 'MOST_ACTIVE'
}

export type WalletsActivityReportWallet = {
  __typename?: 'WalletsActivityReportWallet';
  address: Scalars['String'];
  maxPurchase1Day?: Maybe<Scalars['String']>;
  maxPurchaseImgUrl?: Maybe<Scalars['String']>;
  maxPurchaseName?: Maybe<Scalars['String']>;
  maxPurchaseTokenAddress?: Maybe<Scalars['String']>;
  volume1Day: Scalars['String'];
};

export enum Web3AuthType {
  APTOS_SIGNED_MESSAGE = 'APTOS_SIGNED_MESSAGE',
  COSMOS_ADR36 = 'COSMOS_ADR36',
  COSMOS_AUTHZ_GRANT = 'COSMOS_AUTHZ_GRANT',
  EIP1271 = 'EIP1271',
  ETHEREUM_PERSONAL_SIGN = 'ETHEREUM_PERSONAL_SIGN',
  NEAR_SIGN_MESSAGE = 'NEAR_SIGN_MESSAGE',
  SOLANA_SIGN_MESSAGE = 'SOLANA_SIGN_MESSAGE',
  SUI_SIGNED_MESSAGE = 'SUI_SIGNED_MESSAGE'
}

/** Web3 Target */
export type Web3Target = {
  __typename?: 'Web3Target';
  accountId?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  senderAddress?: Maybe<Scalars['String']>;
  targetProtocol: Web3TargetProtocol;
  updatedDate: Scalars['DateTime'];
  walletBlockchain: WalletBlockchain;
};

export type Web3TargetNotFoundError = Error & {
  __typename?: 'Web3TargetNotFoundError';
  message: Scalars['String'];
};

export enum Web3TargetProtocol {
  XMTP = 'XMTP'
}

/** A connection to a list of items. */
export type Web3TargetsConnection = {
  __typename?: 'Web3TargetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Web3TargetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Web3Target>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Web3TargetsEdge = {
  __typename?: 'Web3TargetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Web3Target;
};

/** Web Push Target */
export type WebPushTarget = {
  __typename?: 'WebPushTarget';
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type WebPushTargetsConnection = {
  __typename?: 'WebPushTargetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WebPushTargetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WebPushTarget>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WebPushTargetsEdge = {
  __typename?: 'WebPushTargetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WebPushTarget;
};

export enum WebhookPayloadFormat {
  BROWSER_PUSH_CHROME = 'BROWSER_PUSH_CHROME',
  BROWSER_PUSH_MOZILLA = 'BROWSER_PUSH_MOZILLA',
  BROWSER_PUSH_NOTIFI = 'BROWSER_PUSH_NOTIFI',
  PAGER_DUTY = 'PAGER_DUTY',
  RAW = 'RAW'
}

export enum WebhookStatus {
  ERROR = 'ERROR',
  OK = 'OK',
  RATE_LIMITED = 'RATE_LIMITED',
  UNCONFIRMED = 'UNCONFIRMED'
}

export type WebhookTarget = {
  __typename?: 'WebhookTarget';
  createdDate: Scalars['DateTime'];
  format: WebhookPayloadFormat;
  headers?: Maybe<Array<KeyValuePairOfStringAndString>>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  status: WebhookStatus;
  updatedDate: Scalars['DateTime'];
  url: Scalars['String'];
};

export type XmtpAccountIsntConnectedWalletError = Error & {
  __typename?: 'XmtpAccountIsntConnectedWalletError';
  message: Scalars['String'];
};

export type AlertFragment = { __typename?: 'Alert', id: string, name?: string | undefined, groupName?: string | undefined, filterOptions: string, createdDate: string, updatedDate: string, sourceGroup: { __typename?: 'SourceGroup', id: string, name?: string | undefined, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined }, filter: { __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType }, targetGroup: { __typename?: 'TargetGroup', id: string, name?: string | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, discordTargets?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } | undefined> | undefined } };

export type ConnectedWalletFragment = { __typename?: 'ConnectedWallet', address?: string | undefined, walletBlockchain: WalletBlockchain };

export type ConversationFragment = { __typename?: 'Conversation', id: string, name: string, createdDate: string, backgroundImageUrl?: string | undefined, updatedDate: string, conversationType: ConversationType, conversationGates?: Array<{ __typename?: 'ConversationGate', name: string, tokenAddress: string, walletBlockchain: WalletBlockchain, conversationGateTokenType: ConversationGateTokenType, participantCount: any, createdDate: string, updatedDate: string } | undefined> | undefined, participants?: Array<{ __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined> | undefined };

export type ConversationGateFragment = { __typename?: 'ConversationGate', name: string, tokenAddress: string, walletBlockchain: WalletBlockchain, conversationGateTokenType: ConversationGateTokenType, participantCount: any, createdDate: string, updatedDate: string };

export type ConversationParticipantFragment = { __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } };

export type ConversationMessageFragment = { __typename?: 'ConversationMessage', id: string, userId: string, conversationId: string, createdDate: string, updatedDate: string, message: string, conversationParticipant?: { __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined };

export type ConvMessagePageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined };

export type DiscordTargetFragment = { __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined };

export type EmailTargetFragment = { __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined };

export type JabberMessageFragment = { __typename?: 'JabberV1Message', isEncrypted: boolean, message?: string | undefined, id: string, threadId: string, messageBase64: string, senderWalletAddress: string, senderWalletBlockchain: WalletBlockchain, timestamp?: string | undefined };

export type JabberParticipantFragment = { __typename?: 'JabberV1Participant', resolvedName?: string | undefined, solPerMessage?: number | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, notifiProfile?: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } | undefined };

export type JabberThreadFragment = { __typename?: 'JabberV1Thread', id: string, participants: Array<{ __typename?: 'JabberV1Participant', resolvedName?: string | undefined, solPerMessage?: number | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, notifiProfile?: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } | undefined }>, lastConversationMessage?: { __typename?: 'JabberV1Message', isEncrypted: boolean, message?: string | undefined, id: string, threadId: string, messageBase64: string, senderWalletAddress: string, senderWalletBlockchain: WalletBlockchain, timestamp?: string | undefined } | undefined };

export type NotificationTargetFragment = { __typename?: 'NotificationTarget', type: TargetType, name?: string | undefined };

export type NotificationHistoryEntryFragment = { __typename?: 'NotificationHistoryEntry', id: string, createdDate: string, eventId: string, read: boolean, sourceAddress?: string | undefined, category?: NotificationCategory | undefined, transactionSignature?: string | undefined, targets: Array<{ __typename?: 'NotificationTarget', type: TargetType, name?: string | undefined }>, detail?: { __typename: 'AccountBalanceChangedEventDetails', walletBlockchain: WalletBlockchain, direction: AccountBalanceChangeDirection, newValue: number, previousValue: number, tokenSymbol: string, isWhaleWatch: boolean } | { __typename: 'BroadcastMessageEventDetails', subject?: string | undefined, message?: string | undefined, messageHtml?: string | undefined, messageType: string } | { __typename: 'ChatMessageReceivedEventDetails', messageBody: string, senderName: string, conversationId: string, messageId: string, senderId: string, senderBlockchain: WalletBlockchain } | { __typename: 'DAOProposalChangedEventDetails', tenantName: string, description: string, state?: string | undefined, daoUrl?: string | undefined, proposalUrl?: string | undefined, proposalTitle?: string | undefined } | { __typename: 'DirectTenantMessageEventDetails', tenantName: string } | { __typename: 'GenericEventDetails', sourceName: string, notificationTypeName: string, genericMessage: string, action?: { __typename?: 'GenericEventAction', name: string, url: string } | undefined } | { __typename: 'HealthValueOverThresholdEventDetails', name: string, value: string, threshold: string, url: string } | { __typename: 'NftAuctionChangedEventDetails', auctionUrl?: string | undefined, walletBlockchain: WalletBlockchain, highBidAmount: number, highBidSymbol?: string | undefined, imageUrl?: string | undefined, auctionTitle: string } | { __typename: 'NftCollectionsReportEventDetails', type: NftCollectionsReportType, providerName: string, sourceLink: string, collections: Array<{ __typename?: 'NftCollectionStats', collectionId: string, name: string, imgUrl?: string | undefined, volume1Day?: string | undefined, volume1DayChange?: string | undefined }> } | { __typename: 'WalletsActivityReportEventDetails', providerName: string, sourceLink: string, walletActivityType: WalletsActivityReportType, wallets: Array<{ __typename?: 'WalletsActivityReportWallet', address: string, volume1Day: string, maxPurchase1Day?: string | undefined, maxPurchaseName?: string | undefined, maxPurchaseImgUrl?: string | undefined, maxPurchaseTokenAddress?: string | undefined }> } | undefined };

export type ParticipantsFragment = { __typename?: 'Conversation', id: string, participants?: Array<{ __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined> | undefined };

export type SlackTargetFragment = { __typename?: 'VerifySlackChannelTargetResponse', slackChannelTarget: { __typename?: 'SlackChannelTarget', id: string, name?: string | undefined, slackChannelName?: string | undefined, slackWorkspaceName?: string | undefined, verificationLink?: string | undefined, verificationStatus: SlackTargetStatus } };

export type SlackWebhookTargetFragment = { __typename?: 'VerifySlackChannelTargetForWebhookResponse', slackChannelTarget: { __typename?: 'SlackChannelTarget', id: string, name?: string | undefined, slackChannelName?: string | undefined, slackWorkspaceName?: string | undefined, webhookVerificationLink?: string | undefined, verificationStatus: SlackTargetStatus } };

export type ConfirmChannelForSlackChannelTargetResponseFragment = { __typename?: 'ConfirmChannelForSlackChannelTargetResponse', slackChannelTarget: { __typename?: 'SlackChannelTarget', id: string, name?: string | undefined, slackChannelName?: string | undefined, slackWorkspaceName?: string | undefined, verificationLink?: string | undefined, verificationStatus: SlackTargetStatus } };

export type ListAvailableSlackChannelResponseFragment = { __typename?: 'ListAvailableSlackChannelResponse', slackChannels?: Array<{ __typename?: 'SlackChannel', id: string, name: string }> | undefined };

export type GetSlackWorkspaceIconResponseFragment = { __typename?: 'GetSlackWorkspaceIconResponse', iconUrl: string };

export type GetSlackChannelBotInfoResponseFragment = { __typename?: 'GetSlackChannelBotInfoResponse', botName: string, iconUrl: string };

export type SmsTargetFragment = { __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean };

export type SourceFragment = { __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined };

export type SourceGroupFragment = { __typename?: 'SourceGroup', id: string, name?: string | undefined, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined };

export type TargetGroupFragment = { __typename?: 'TargetGroup', id: string, name?: string | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, discordTargets?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } | undefined> | undefined };

export type TelegramTargetFragment = { __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean };

export type UserFragment = { __typename?: 'User', id?: string | undefined, email?: string | undefined, emailConfirmed?: boolean | undefined, roles?: Array<string | undefined> | undefined, authorization?: { __typename?: 'Authorization', token: string, expiry: string } | undefined, settings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined };

export type UserProfileFragment = { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain };

export type UpdateUserProfileMutationVariables = Exact<{
  userProfileInput: UserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'NotifiMutation', updateUserProfile?: { __typename?: 'UserProfile', id: string } | undefined };

export type UserSettingsFragment = { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean };

export type CreateAlertMutationVariables = Exact<{
  alertInput?: InputMaybe<CreateAlertInput>;
}>;


export type CreateAlertMutation = { __typename?: 'NotifiMutation', createAlert?: { __typename?: 'Alert', id: string, name?: string | undefined, groupName?: string | undefined, filterOptions: string, createdDate: string, updatedDate: string, sourceGroup: { __typename?: 'SourceGroup', id: string, name?: string | undefined, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined }, filter: { __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType }, targetGroup: { __typename?: 'TargetGroup', id: string, name?: string | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, discordTargets?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } | undefined> | undefined } } | undefined };

export type DeleteAlertMutationVariables = Exact<{
  alertId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteAlertMutation = { __typename?: 'NotifiMutation', deleteAlert?: { __typename?: 'Alert', id: string } | undefined };

export type BeginLogInByQrCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type BeginLogInByQrCodeMutation = { __typename?: 'NotifiMutation', beginLogInByQRCode: { __typename?: 'BeginLogInByQRCodeResult', nonce: string } };

export type BeginLogInByTransactionMutationVariables = Exact<{
  input: BeginLogInByTransactionInput;
}>;


export type BeginLogInByTransactionMutation = { __typename?: 'NotifiMutation', beginLogInByTransaction: { __typename?: 'BeginLogInByTransactionResult', nonce: string } };

export type BroadcastMessageMutationVariables = Exact<{
  broadcastMessageInput: BroadcastMessageInput;
  signature: Scalars['String'];
}>;


export type BroadcastMessageMutation = { __typename?: 'NotifiMutation', broadcastMessage?: { __typename?: 'BroadcastMessageResult', id?: string | undefined } | undefined };

export type CompleteLogInByTransactionMutationVariables = Exact<{
  input: CompleteLogInByTransactionInput;
}>;


export type CompleteLogInByTransactionMutation = { __typename?: 'NotifiMutation', completeLogInByTransaction?: { __typename?: 'User', id?: string | undefined, email?: string | undefined, emailConfirmed?: boolean | undefined, roles?: Array<string | undefined> | undefined, authorization?: { __typename?: 'Authorization', token: string, expiry: string } | undefined, settings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined } | undefined };

export type ConfirmSlackChannelTargetMutationVariables = Exact<{
  input: ConfirmChannelForSlackChannelTargetInput;
}>;


export type ConfirmSlackChannelTargetMutation = { __typename?: 'NotifiMutation', confirmChannelForSlackChannelTarget: { __typename?: 'ConfirmChannelForSlackChannelTargetResponse', slackChannelTarget: { __typename?: 'SlackChannelTarget', id: string, name?: string | undefined, slackChannelName?: string | undefined, slackWorkspaceName?: string | undefined, verificationLink?: string | undefined, verificationStatus: SlackTargetStatus } } };

export type LeaveConversationMutationVariables = Exact<{
  leaveConversationInput: LeaveConversationInput;
}>;


export type LeaveConversationMutation = { __typename?: 'NotifiMutation', leaveConversation: { __typename?: 'Conversation', id: string } };

export type SendConversationMessageMutationVariables = Exact<{
  sendConversationMessageInput: SendConversationMessageInput;
}>;


export type SendConversationMessageMutation = { __typename?: 'NotifiMutation', sendConversationMessage: { __typename?: 'ConversationMessage', id: string, userId: string, conversationId: string, createdDate: string, updatedDate: string, message: string, conversationParticipant?: { __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined } };

export type CreateConversationMutationVariables = Exact<{
  createConversationInput: CreateConversationInput;
}>;


export type CreateConversationMutation = { __typename?: 'NotifiMutation', createConversation: { __typename?: 'Conversation', id: string, name: string, createdDate: string, backgroundImageUrl?: string | undefined, updatedDate: string, conversationType: ConversationType, conversationGates?: Array<{ __typename?: 'ConversationGate', name: string, tokenAddress: string, walletBlockchain: WalletBlockchain, conversationGateTokenType: ConversationGateTokenType, participantCount: any, createdDate: string, updatedDate: string } | undefined> | undefined, participants?: Array<{ __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined> | undefined } };

export type CreateDiscordTargetMutationVariables = Exact<{
  name: Scalars['String'];
  value: Scalars['String'];
}>;


export type CreateDiscordTargetMutation = { __typename?: 'NotifiMutation', createDiscordTarget: { __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } };

export type DeleteDAppSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type DeleteDAppSubscriptionMutation = { __typename?: 'NotifiMutation', deleteDAppSubscription?: { __typename?: 'DAppSubscription', id: string } | undefined };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  input: MarkNotificationsAsReadInput;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'NotifiMutation', markNotificationsAsRead?: Array<{ __typename?: 'NotificationHistoryEntry', id: string, createdDate: string, eventId: string, read: boolean, sourceAddress?: string | undefined, category?: NotificationCategory | undefined, transactionSignature?: string | undefined, targets: Array<{ __typename?: 'NotificationTarget', type: TargetType, name?: string | undefined }>, detail?: { __typename: 'AccountBalanceChangedEventDetails', walletBlockchain: WalletBlockchain, direction: AccountBalanceChangeDirection, newValue: number, previousValue: number, tokenSymbol: string, isWhaleWatch: boolean } | { __typename: 'BroadcastMessageEventDetails', subject?: string | undefined, message?: string | undefined, messageHtml?: string | undefined, messageType: string } | { __typename: 'ChatMessageReceivedEventDetails', messageBody: string, senderName: string, conversationId: string, messageId: string, senderId: string, senderBlockchain: WalletBlockchain } | { __typename: 'DAOProposalChangedEventDetails', tenantName: string, description: string, state?: string | undefined, daoUrl?: string | undefined, proposalUrl?: string | undefined, proposalTitle?: string | undefined } | { __typename: 'DirectTenantMessageEventDetails', tenantName: string } | { __typename: 'GenericEventDetails', sourceName: string, notificationTypeName: string, genericMessage: string, action?: { __typename?: 'GenericEventAction', name: string, url: string } | undefined } | { __typename: 'HealthValueOverThresholdEventDetails', name: string, value: string, threshold: string, url: string } | { __typename: 'NftAuctionChangedEventDetails', auctionUrl?: string | undefined, walletBlockchain: WalletBlockchain, highBidAmount: number, highBidSymbol?: string | undefined, imageUrl?: string | undefined, auctionTitle: string } | { __typename: 'NftCollectionsReportEventDetails', type: NftCollectionsReportType, providerName: string, sourceLink: string, collections: Array<{ __typename?: 'NftCollectionStats', collectionId: string, name: string, imgUrl?: string | undefined, volume1Day?: string | undefined, volume1DayChange?: string | undefined }> } | { __typename: 'WalletsActivityReportEventDetails', providerName: string, sourceLink: string, walletActivityType: WalletsActivityReportType, wallets: Array<{ __typename?: 'WalletsActivityReportWallet', address: string, volume1Day: string, maxPurchase1Day?: string | undefined, maxPurchaseName?: string | undefined, maxPurchaseImgUrl?: string | undefined, maxPurchaseTokenAddress?: string | undefined }> } | undefined }> | undefined };

export type CreateSourceMutationVariables = Exact<{
  createSourceInput?: InputMaybe<CreateSourceInput>;
}>;


export type CreateSourceMutation = { __typename?: 'NotifiMutation', createSource?: { __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined };

export type DeleteSourceMutationVariables = Exact<{
  sourceId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteSourceMutation = { __typename?: 'NotifiMutation', deleteSource?: { __typename?: 'Source', id: string } | undefined };

export type CreateSourceGroupMutationVariables = Exact<{
  sourceGroupInput?: InputMaybe<SourceGroupInput>;
}>;


export type CreateSourceGroupMutation = { __typename?: 'NotifiMutation', createSourceGroup?: { __typename?: 'SourceGroup', id: string, name?: string | undefined, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined } | undefined };

export type DeleteSourceGroupMutationVariables = Exact<{
  sourceGroupInput?: InputMaybe<SourceGroupInput>;
}>;


export type DeleteSourceGroupMutation = { __typename?: 'NotifiMutation', deleteSourceGroup?: { __typename?: 'SourceGroup', id: string } | undefined };

export type CreateEmailTargetMutationVariables = Exact<{
  createTargetInput?: InputMaybe<CreateTargetInput>;
}>;


export type CreateEmailTargetMutation = { __typename?: 'NotifiMutation', createEmailTarget?: { __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean } | undefined };

export type CreateSmsTargetMutationVariables = Exact<{
  createTargetInput?: InputMaybe<CreateTargetInput>;
}>;


export type CreateSmsTargetMutation = { __typename?: 'NotifiMutation', createSmsTarget?: { __typename?: 'SmsTarget', id: string, phoneNumber?: string | undefined, isConfirmed: boolean } | undefined };

export type CreateTelegramTargetMutationVariables = Exact<{
  createTargetInput?: InputMaybe<CreateTargetInput>;
}>;


export type CreateTelegramTargetMutation = { __typename?: 'NotifiMutation', createTelegramTarget?: { __typename?: 'TelegramTarget', id: string, telegramId: string, isConfirmed: boolean } | undefined };

export type DeleteEmailTargetMutationVariables = Exact<{
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
}>;


export type DeleteEmailTargetMutation = { __typename?: 'NotifiMutation', deleteEmailTarget?: { __typename?: 'EmailTarget', id: string } | undefined };

export type DeleteSmsTargetMutationVariables = Exact<{
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
}>;


export type DeleteSmsTargetMutation = { __typename?: 'NotifiMutation', deleteSmsTarget?: { __typename?: 'SmsTarget', id: string } | undefined };

export type DeleteTelegramTargetMutationVariables = Exact<{
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
}>;


export type DeleteTelegramTargetMutation = { __typename?: 'NotifiMutation', deleteTelegramTarget?: { __typename?: 'TelegramTarget', id: string } | undefined };

export type DeleteDiscordTargetMutationVariables = Exact<{
  deleteTargetInput?: InputMaybe<DeleteTargetInput>;
}>;


export type DeleteDiscordTargetMutation = { __typename?: 'NotifiMutation', deleteDiscordTarget: { __typename?: 'DiscordTarget', id: string } };

export type SendEmailTargetVerificationRequestMutationVariables = Exact<{
  sendTargetConfirmationRequestInput?: InputMaybe<SendTargetConfirmationRequestInput>;
}>;


export type SendEmailTargetVerificationRequestMutation = { __typename?: 'NotifiMutation', sendEmailTargetVerificationRequest?: { __typename?: 'EmailTarget', emailAddress?: string | undefined, isConfirmed: boolean, id: string, name?: string | undefined, createdDate: string, updatedDate: string } | undefined };

export type CreateTargetGroupMutationVariables = Exact<{
  targetGroupInput?: InputMaybe<TargetGroupInput>;
}>;


export type CreateTargetGroupMutation = { __typename?: 'NotifiMutation', createTargetGroup?: { __typename?: 'TargetGroup', id: string, name?: string | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, discordTargets?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } | undefined> | undefined } | undefined };

export type DeleteTargetGroupMutationVariables = Exact<{
  targetGroupInput?: InputMaybe<TargetGroupInput>;
}>;


export type DeleteTargetGroupMutation = { __typename?: 'NotifiMutation', deleteTargetGroup?: { __typename?: 'TargetGroup', id: string } | undefined };

export type VerifyTargetMutationVariables = Exact<{
  verifyTargetInput?: InputMaybe<VerifyTargetInput>;
}>;


export type VerifyTargetMutation = { __typename?: 'NotifiMutation', verifyTarget?: { __typename?: 'EmailTarget', emailAddress?: string | undefined, isConfirmed: boolean } | undefined };

export type UnsubscribeMutationVariables = Exact<{
  input: UnsubscribeInputTypeInput;
}>;


export type UnsubscribeMutation = { __typename?: 'NotifiMutation', unsubscribe: { __typename?: 'UnsubscribeResult', tenantName: string, targetValue: string } };

export type UpdateUserSettingsMutationVariables = Exact<{
  userSettingsInput: UserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'NotifiMutation', updateUserSettings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined };

export type ConfirmEmailMutationVariables = Exact<{
  email: Scalars['String'];
  token: Scalars['String'];
}>;


export type ConfirmEmailMutation = { __typename?: 'NotifiMutation', confirmEmail: boolean };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'NotifiMutation', create?: { __typename?: 'User', email?: string | undefined } | undefined };

export type SubmitLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SubmitLoginMutation = { __typename?: 'NotifiMutation', logIn?: { __typename?: 'User', id?: string | undefined, email?: string | undefined, emailConfirmed?: boolean | undefined, roles?: Array<string | undefined> | undefined, authorization?: { __typename?: 'Authorization', token: string, expiry: string } | undefined, settings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined } | undefined };

export type SubmitLoginByOAuthMutationVariables = Exact<{
  logInByOAuthInput: LogInByOAuthInput;
}>;


export type SubmitLoginByOAuthMutation = { __typename?: 'NotifiMutation', logInByOAuth?: { __typename?: 'User', id?: string | undefined, email?: string | undefined, emailConfirmed?: boolean | undefined, roles?: Array<string | undefined> | undefined, authorization?: { __typename?: 'Authorization', token: string, expiry: string } | undefined, settings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined } | undefined };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  tfaCode: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'NotifiMutation', resetPassword: boolean };

export type RefreshAuthorizationMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshAuthorizationMutation = { __typename?: 'NotifiMutation', refreshAuthorization?: { __typename?: 'Authorization', expiry: string, token: string } | undefined };

export type GenerateEmailConfirmationTokenMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type GenerateEmailConfirmationTokenMutation = { __typename?: 'NotifiMutation', generateEmailConfirmationToken: boolean };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'NotifiMutation', sendResetPasswordEmail: boolean };

export type ConnectWalletMutationVariables = Exact<{
  connectWalletInput: ConnectWalletInput;
  signature: Scalars['String'];
}>;


export type ConnectWalletMutation = { __typename?: 'NotifiMutation', connectWallet?: { __typename?: 'ConnectedWallet', address?: string | undefined, walletBlockchain: WalletBlockchain } | undefined };

export type DisconnectWalletMutationVariables = Exact<{
  disconnectWalletInput: DisconnectWalletInput;
}>;


export type DisconnectWalletMutation = { __typename?: 'NotifiMutation', disconnectWallet?: { __typename?: 'ConnectedWallet', address?: string | undefined, walletBlockchain: WalletBlockchain } | undefined };

export type VerifyDiscordTargetMutationVariables = Exact<{
  verifyDiscordTargetInput: VerifyDiscordTargetInput;
}>;


export type VerifyDiscordTargetMutation = { __typename?: 'NotifiMutation', verifyDiscordTarget: { __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } };

export type VerifySlackTargetMutationVariables = Exact<{
  input: VerifySlackChannelTargetInput;
}>;


export type VerifySlackTargetMutation = { __typename?: 'NotifiMutation', verifySlackChannelTarget: { __typename?: 'VerifySlackChannelTargetResponse', slackChannelTarget: { __typename?: 'SlackChannelTarget', id: string, name?: string | undefined, slackChannelName?: string | undefined, slackWorkspaceName?: string | undefined, verificationLink?: string | undefined, verificationStatus: SlackTargetStatus } } };

export type VerifySlackChannelForWebhookMutationVariables = Exact<{
  input: VerifySlackChannelTargetForWebhookInput;
}>;


export type VerifySlackChannelForWebhookMutation = { __typename?: 'NotifiMutation', verifySlackChannelForWebhook: { __typename?: 'VerifySlackChannelTargetForWebhookResponse', slackChannelTarget: { __typename?: 'SlackChannelTarget', id: string, name?: string | undefined, slackChannelName?: string | undefined, slackWorkspaceName?: string | undefined, webhookVerificationLink?: string | undefined, verificationStatus: SlackTargetStatus } } };

export type AlertQueryVariables = Exact<{
  getAlertInput?: InputMaybe<GetAlertInput>;
}>;


export type AlertQuery = { __typename?: 'NotifiQuery', alert?: Array<{ __typename?: 'Alert', id: string, name?: string | undefined, groupName?: string | undefined, filterOptions: string, createdDate: string, updatedDate: string, sourceGroup: { __typename?: 'SourceGroup', id: string, name?: string | undefined, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined }, filter: { __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType }, targetGroup: { __typename?: 'TargetGroup', id: string, name?: string | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, discordTargets?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } | undefined> | undefined } } | undefined> | undefined };

export type ConnectedWalletQueryVariables = Exact<{
  getConnectedWalletsInput?: InputMaybe<GetConnectedWalletsInput>;
}>;


export type ConnectedWalletQuery = { __typename?: 'NotifiQuery', connectedWallet?: Array<{ __typename?: 'ConnectedWallet', address?: string | undefined, walletBlockchain: WalletBlockchain } | undefined> | undefined };

export type ConversationMessagesQueryVariables = Exact<{
  getConversationMessagesInput: GetConversationMessagesInput;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type ConversationMessagesQuery = { __typename?: 'NotifiQuery', conversationMessages?: { __typename?: 'ConversationMessagesConnection', nodes?: Array<{ __typename?: 'ConversationMessage', id: string, message: string, userId: string, createdDate: string, updatedDate: string, conversationId: string, conversationParticipant?: { __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined }> | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } | undefined };

export type NotifiConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotifiConversationsQuery = { __typename?: 'NotifiQuery', conversations?: { __typename?: 'ConversationsConnection', nodes?: Array<{ __typename?: 'Conversation', id: string, name: string, createdDate: string, backgroundImageUrl?: string | undefined, updatedDate: string, conversationType: ConversationType, conversationGates?: Array<{ __typename?: 'ConversationGate', name: string, tokenAddress: string, walletBlockchain: WalletBlockchain, conversationGateTokenType: ConversationGateTokenType, participantCount: any, createdDate: string, updatedDate: string } | undefined> | undefined, participants?: Array<{ __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined> | undefined }> | undefined } | undefined };

export type DaoSourceQueryVariables = Exact<{
  getSourceInput?: InputMaybe<GetSourceInput>;
}>;


export type DaoSourceQuery = { __typename?: 'NotifiQuery', source?: Array<{ __typename?: 'Source', id: string, blockchainAddress: string, type: SourceType, name?: string | undefined, applicableFilters?: Array<{ __typename?: 'Filter', id: string, filterType: FilterType, name?: string | undefined } | undefined> | undefined } | undefined> | undefined };

export type DashboardQueryQueryVariables = Exact<{
  getAlertInput?: InputMaybe<GetAlertInput>;
  getSourceInput?: InputMaybe<GetSourceInput>;
  getTargetInput?: InputMaybe<GetTargetInput>;
}>;


export type DashboardQueryQuery = { __typename?: 'NotifiQuery', alert?: Array<{ __typename?: 'Alert', id: string, groupName?: string | undefined, createdDate: string, updatedDate: string, sourceGroup: { __typename?: 'SourceGroup', id: string, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, blockchainAddress: string, type: SourceType, activeAlertCount: any } | undefined> | undefined }, filter: { __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType }, targetGroup: { __typename?: 'TargetGroup', id: string, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', id: string, phoneNumber?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', id: string, name?: string | undefined, telegramId: string, isConfirmed: boolean } | undefined> | undefined } } | undefined> | undefined, source?: Array<{ __typename?: 'Source', id: string, blockchainAddress: string, type: SourceType, activeAlertCount: any, name?: string | undefined } | undefined> | undefined, telegramTarget?: Array<{ __typename?: 'TelegramTarget', id: string, name?: string | undefined, isConfirmed: boolean, telegramId: string } | undefined> | undefined, smsTarget?: Array<{ __typename?: 'SmsTarget', id: string, phoneNumber?: string | undefined, isConfirmed: boolean } | undefined> | undefined, emailTarget?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean } | undefined> | undefined };

export type DiscordTargetQueryVariables = Exact<{
  getTargetInput?: InputMaybe<GetTargetInput>;
}>;


export type DiscordTargetQuery = { __typename?: 'NotifiQuery', discordTarget?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined }> | undefined };

export type EmailTargetQueryVariables = Exact<{
  getTargetInput?: InputMaybe<GetTargetInput>;
}>;


export type EmailTargetQuery = { __typename?: 'NotifiQuery', emailTarget?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined };

export type FilterQueryVariables = Exact<{
  getFilterInput?: InputMaybe<GetFilterInput>;
}>;


export type FilterQuery = { __typename?: 'NotifiQuery', filter?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined };

export type GetSlackChannelBotInfoQueryVariables = Exact<{
  input: GetSlackChannelBotInfoInput;
}>;


export type GetSlackChannelBotInfoQuery = { __typename?: 'NotifiQuery', slackChannelBotInfo?: { __typename?: 'GetSlackChannelBotInfoResponse', botName: string, iconUrl: string } | undefined };

export type GetSlackWorkspaceIconQueryVariables = Exact<{
  input: GetSlackWorkspaceIconInput;
}>;


export type GetSlackWorkspaceIconQuery = { __typename?: 'NotifiQuery', slackWorkspaceIcon: { __typename?: 'GetSlackWorkspaceIconResponse', iconUrl: string } };

export type JabberMessagesQueryVariables = Exact<{
  getJabberMessagesInput: GetJabberMessagesInput;
}>;


export type JabberMessagesQuery = { __typename?: 'NotifiQuery', jabberMessages?: { __typename?: 'JabberMessagesConnection', nodes?: Array<{ __typename?: 'JabberV1Message', isEncrypted: boolean, message?: string | undefined, id: string, threadId: string, messageBase64: string, senderWalletAddress: string, senderWalletBlockchain: WalletBlockchain, timestamp?: string | undefined } | undefined> | undefined } | undefined };

export type JabberThreadsQueryVariables = Exact<{ [key: string]: never; }>;


export type JabberThreadsQuery = { __typename?: 'NotifiQuery', jabberThreads?: { __typename?: 'JabberThreadsConnection', nodes?: Array<{ __typename?: 'JabberV1Thread', id: string, participants: Array<{ __typename?: 'JabberV1Participant', resolvedName?: string | undefined, solPerMessage?: number | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, notifiProfile?: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } | undefined }>, lastConversationMessage?: { __typename?: 'JabberV1Message', isEncrypted: boolean, message?: string | undefined, id: string, threadId: string, messageBase64: string, senderWalletAddress: string, senderWalletBlockchain: WalletBlockchain, timestamp?: string | undefined } | undefined }> | undefined } | undefined };

export type ListAvailableSlackChannelsQueryVariables = Exact<{
  input: ListAvailableSlackChannelInput;
}>;


export type ListAvailableSlackChannelsQuery = { __typename?: 'NotifiQuery', listAvailableSlackChannels: { __typename?: 'ListAvailableSlackChannelResponse', slackChannels?: Array<{ __typename?: 'SlackChannel', id: string, name: string }> | undefined } };

export type NotificationByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type NotificationByIdQuery = { __typename?: 'NotifiQuery', notificationById?: { __typename?: 'NotificationHistoryEntry', id: string, createdDate: string, eventId: string, read: boolean, sourceAddress?: string | undefined, category?: NotificationCategory | undefined, transactionSignature?: string | undefined, targets: Array<{ __typename?: 'NotificationTarget', type: TargetType, name?: string | undefined }>, detail?: { __typename: 'AccountBalanceChangedEventDetails', walletBlockchain: WalletBlockchain, direction: AccountBalanceChangeDirection, newValue: number, previousValue: number, tokenSymbol: string, isWhaleWatch: boolean } | { __typename: 'BroadcastMessageEventDetails', subject?: string | undefined, message?: string | undefined, messageHtml?: string | undefined, messageType: string } | { __typename: 'ChatMessageReceivedEventDetails', messageBody: string, senderName: string, conversationId: string, messageId: string, senderId: string, senderBlockchain: WalletBlockchain } | { __typename: 'DAOProposalChangedEventDetails', tenantName: string, description: string, state?: string | undefined, daoUrl?: string | undefined, proposalUrl?: string | undefined, proposalTitle?: string | undefined } | { __typename: 'DirectTenantMessageEventDetails', tenantName: string } | { __typename: 'GenericEventDetails', sourceName: string, notificationTypeName: string, genericMessage: string, action?: { __typename?: 'GenericEventAction', name: string, url: string } | undefined } | { __typename: 'HealthValueOverThresholdEventDetails', name: string, value: string, threshold: string, url: string } | { __typename: 'NftAuctionChangedEventDetails', auctionUrl?: string | undefined, walletBlockchain: WalletBlockchain, highBidAmount: number, highBidSymbol?: string | undefined, imageUrl?: string | undefined, auctionTitle: string } | { __typename: 'NftCollectionsReportEventDetails', type: NftCollectionsReportType, providerName: string, sourceLink: string, collections: Array<{ __typename?: 'NftCollectionStats', collectionId: string, name: string, imgUrl?: string | undefined, volume1Day?: string | undefined, volume1DayChange?: string | undefined }> } | { __typename: 'WalletsActivityReportEventDetails', providerName: string, sourceLink: string, walletActivityType: WalletsActivityReportType, wallets: Array<{ __typename?: 'WalletsActivityReportWallet', address: string, volume1Day: string, maxPurchase1Day?: string | undefined, maxPurchaseName?: string | undefined, maxPurchaseImgUrl?: string | undefined, maxPurchaseTokenAddress?: string | undefined }> } | undefined } | undefined };

export type NotificationHistoryQueryVariables = Exact<{
  filter?: InputMaybe<NotificationHistoryFilterInput>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationHistoryQuery = { __typename?: 'NotifiQuery', notificationHistory?: { __typename?: 'NotificationHistoryConnection', edges?: Array<{ __typename?: 'NotificationHistoryEdge', cursor: string, node: { __typename?: 'NotificationHistoryEntry', id: string, createdDate: string, eventId: string, read: boolean, sourceAddress?: string | undefined, category?: NotificationCategory | undefined, transactionSignature?: string | undefined, targets: Array<{ __typename?: 'NotificationTarget', type: TargetType, name?: string | undefined }>, detail?: { __typename: 'AccountBalanceChangedEventDetails', walletBlockchain: WalletBlockchain, direction: AccountBalanceChangeDirection, newValue: number, previousValue: number, tokenSymbol: string, isWhaleWatch: boolean } | { __typename: 'BroadcastMessageEventDetails', subject?: string | undefined, message?: string | undefined, messageHtml?: string | undefined, messageType: string } | { __typename: 'ChatMessageReceivedEventDetails', messageBody: string, senderName: string, conversationId: string, messageId: string, senderId: string, senderBlockchain: WalletBlockchain } | { __typename: 'DAOProposalChangedEventDetails', tenantName: string, description: string, state?: string | undefined, daoUrl?: string | undefined, proposalUrl?: string | undefined, proposalTitle?: string | undefined } | { __typename: 'DirectTenantMessageEventDetails', tenantName: string } | { __typename: 'GenericEventDetails', sourceName: string, notificationTypeName: string, genericMessage: string, action?: { __typename?: 'GenericEventAction', name: string, url: string } | undefined } | { __typename: 'HealthValueOverThresholdEventDetails', name: string, value: string, threshold: string, url: string } | { __typename: 'NftAuctionChangedEventDetails', auctionUrl?: string | undefined, walletBlockchain: WalletBlockchain, highBidAmount: number, highBidSymbol?: string | undefined, imageUrl?: string | undefined, auctionTitle: string } | { __typename: 'NftCollectionsReportEventDetails', type: NftCollectionsReportType, providerName: string, sourceLink: string, collections: Array<{ __typename?: 'NftCollectionStats', collectionId: string, name: string, imgUrl?: string | undefined, volume1Day?: string | undefined, volume1DayChange?: string | undefined }> } | { __typename: 'WalletsActivityReportEventDetails', providerName: string, sourceLink: string, walletActivityType: WalletsActivityReportType, wallets: Array<{ __typename?: 'WalletsActivityReportWallet', address: string, volume1Day: string, maxPurchase1Day?: string | undefined, maxPurchaseName?: string | undefined, maxPurchaseImgUrl?: string | undefined, maxPurchaseTokenAddress?: string | undefined }> } | undefined } }> | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } | undefined };

export type PreviewCommunityManagerContentQueryVariables = Exact<{
  previewInput: CommunityManagerPreviewInput;
}>;


export type PreviewCommunityManagerContentQuery = { __typename?: 'NotifiQuery', previewCommunityManagerContent: { __typename?: 'CommunityManagerPreviewResult', content: string } };

export type ResolveSnsAddressFromNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type ResolveSnsAddressFromNameQuery = { __typename?: 'NotifiQuery', resolveSNSFromAddress?: string | undefined };

export type SmsTargetQueryVariables = Exact<{
  getTargetInput?: InputMaybe<GetTargetInput>;
}>;


export type SmsTargetQuery = { __typename?: 'NotifiQuery', smsTarget?: Array<{ __typename?: 'SmsTarget', id: string, phoneNumber?: string | undefined, isConfirmed: boolean } | undefined> | undefined };

export type SourceGroupQueryVariables = Exact<{
  getSourceGroupInput?: InputMaybe<GetSourceGroupInput>;
}>;


export type SourceGroupQuery = { __typename?: 'NotifiQuery', sourceGroup?: Array<{ __typename?: 'SourceGroup', id: string, name?: string | undefined, sources?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined };

export type SourceQueryVariables = Exact<{
  getSourceInput?: InputMaybe<GetSourceInput>;
}>;


export type SourceQuery = { __typename?: 'NotifiQuery', source?: Array<{ __typename?: 'Source', id: string, name?: string | undefined, activeAlertCount: any, fusionEventTypeId?: string | undefined, blockchainAddress: string, type: SourceType, createdDate: string, updatedDate: string, applicableFilters?: Array<{ __typename?: 'Filter', id: string, name?: string | undefined, filterType: FilterType } | undefined> | undefined } | undefined> | undefined };

export type TargetGroupQueryVariables = Exact<{
  getTargetGroupInput?: InputMaybe<GetTargetGroupInput>;
}>;


export type TargetGroupQuery = { __typename?: 'NotifiQuery', targetGroup?: Array<{ __typename?: 'TargetGroup', id: string, name?: string | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string, emailAddress?: string | undefined, isConfirmed: boolean, name?: string | undefined } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', phoneNumber?: string | undefined, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, telegramTargets?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined, discordTargets?: Array<{ __typename?: 'DiscordTarget', id: string, discordAccountId?: string | undefined, discriminator?: string | undefined, isConfirmed: boolean, username?: string | undefined, name?: string | undefined, userStatus: DiscordTargetStatus, verificationLink?: string | undefined, discordServerInviteLink?: string | undefined } | undefined> | undefined } | undefined> | undefined };

export type TelegramTargetQueryVariables = Exact<{
  getTargetInput?: InputMaybe<GetTargetInput>;
}>;


export type TelegramTargetQuery = { __typename?: 'NotifiQuery', telegramTarget?: Array<{ __typename?: 'TelegramTarget', telegramId: string, id: string, name?: string | undefined, isConfirmed: boolean } | undefined> | undefined };

export type TelegramTargetUrlQueryVariables = Exact<{
  getTargetInput?: InputMaybe<GetTargetInput>;
}>;


export type TelegramTargetUrlQuery = { __typename?: 'NotifiQuery', telegramTarget?: Array<{ __typename?: 'TelegramTarget', confirmationUrl?: string | undefined } | undefined> | undefined };

export type TopicsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TopicsQuery = { __typename?: 'NotifiQuery', topics?: { __typename?: 'TopicsConnection', nodes?: Array<{ __typename?: 'UserTopic', targetCollections?: Array<string> | undefined, targetTemplate?: string | undefined, topicName: string, name?: string | undefined }> | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | undefined } } | undefined };

export type UserFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFeatureFlagsQuery = { __typename?: 'NotifiQuery', userFeatureFlags?: { __typename?: 'UserFeatureFlags', chatEnabled?: boolean | undefined } | undefined };

export type SubmitLoginFromDappMutationVariables = Exact<{
  dappLogInInput: DappLogInInput;
  signature: Scalars['String'];
}>;


export type SubmitLoginFromDappMutation = { __typename?: 'NotifiMutation', logInFromDapp?: { __typename?: 'User', id?: string | undefined, email?: string | undefined, emailConfirmed?: boolean | undefined, roles?: Array<string | undefined> | undefined, authorization?: { __typename?: 'Authorization', token: string, expiry: string } | undefined, settings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined } | undefined };

export type UserProfileQueryVariables = Exact<{
  getUserProfileInput?: InputMaybe<GetUserProfileInput>;
}>;


export type UserProfileQuery = { __typename?: 'NotifiQuery', userProfile?: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } | undefined };

export type UserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSettingsQuery = { __typename?: 'NotifiQuery', userSettings?: { __typename?: 'UserSettings', detailedAlertHistoryEnabled: boolean, userHasChatEnabled: boolean } | undefined };

export type TargetGroupSummaryFragment = { __typename?: 'TargetGroup', telegramTargets?: Array<{ __typename?: 'TelegramTarget', id: string } | undefined> | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', id: string } | undefined> | undefined };

export type DAppsSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DAppsSubscriptionsQuery = { __typename?: 'NotifiQuery', dAppsSubscriptions?: Array<{ __typename?: 'DAppSubscription', id: string, dAppName: string, link?: string | undefined, name: string, targetGroup: { __typename?: 'TargetGroup', telegramTargets?: Array<{ __typename?: 'TelegramTarget', id: string } | undefined> | undefined, emailTargets?: Array<{ __typename?: 'EmailTarget', id: string } | undefined> | undefined, smsTargets?: Array<{ __typename?: 'SmsTarget', id: string } | undefined> | undefined } }> | undefined };

export type ChatMessageReceivedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ChatMessageReceivedSubscription = { __typename?: 'NotifiSubscription', messageReceived: { __typename?: 'ConversationMessage', id: string, userId: string, conversationId: string, createdDate: string, updatedDate: string, message: string, conversationParticipant?: { __typename?: 'ConversationParticipant', userId: string, resolvedName?: string | undefined, walletAddress: string, walletBlockchain: WalletBlockchain, profile: { __typename?: 'UserProfile', id: string, avatarData?: string | undefined, avatarDataType: AvatarDataType, preferredAddress?: string | undefined, preferredName?: string | undefined, preferredBlockchain: WalletBlockchain } } | undefined } };

export const SourceFragmentDoc = gql`
    fragment Source on Source {
  id
  name
  activeAlertCount
  fusionEventTypeId
  blockchainAddress
  type
  createdDate
  applicableFilters {
    id
    name
    filterType
  }
  updatedDate
}
    `;
export const SourceGroupFragmentDoc = gql`
    fragment SourceGroup on SourceGroup {
  id
  name
  sources {
    ...Source
  }
}
    ${SourceFragmentDoc}`;
export const EmailTargetFragmentDoc = gql`
    fragment EmailTarget on EmailTarget {
  id
  emailAddress
  isConfirmed
  name
}
    `;
export const SmsTargetFragmentDoc = gql`
    fragment SmsTarget on SmsTarget {
  phoneNumber
  id
  name
  isConfirmed
}
    `;
export const TelegramTargetFragmentDoc = gql`
    fragment TelegramTarget on TelegramTarget {
  telegramId
  id
  name
  isConfirmed
}
    `;
export const DiscordTargetFragmentDoc = gql`
    fragment DiscordTarget on DiscordTarget {
  id
  discordAccountId
  discriminator
  isConfirmed
  username
  name
  userStatus
  verificationLink
  discordServerInviteLink
}
    `;
export const TargetGroupFragmentDoc = gql`
    fragment TargetGroup on TargetGroup {
  id
  name
  emailTargets {
    ...EmailTarget
  }
  smsTargets {
    ...SmsTarget
  }
  telegramTargets {
    ...TelegramTarget
  }
  discordTargets {
    ...DiscordTarget
  }
}
    ${EmailTargetFragmentDoc}
${SmsTargetFragmentDoc}
${TelegramTargetFragmentDoc}
${DiscordTargetFragmentDoc}`;
export const AlertFragmentDoc = gql`
    fragment Alert on Alert {
  id
  name
  groupName
  sourceGroup {
    ...SourceGroup
  }
  filter {
    id
    name
    filterType
  }
  targetGroup {
    ...TargetGroup
  }
  filterOptions
  createdDate
  updatedDate
}
    ${SourceGroupFragmentDoc}
${TargetGroupFragmentDoc}`;
export const ConnectedWalletFragmentDoc = gql`
    fragment ConnectedWallet on ConnectedWallet {
  address
  walletBlockchain
}
    `;
export const ConversationGateFragmentDoc = gql`
    fragment ConversationGate on ConversationGate {
  name
  tokenAddress
  walletBlockchain
  conversationGateTokenType
  participantCount
  createdDate
  updatedDate
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on UserProfile {
  id
  avatarData
  avatarDataType
  preferredAddress
  preferredName
  preferredBlockchain
}
    `;
export const ConversationParticipantFragmentDoc = gql`
    fragment ConversationParticipant on ConversationParticipant {
  userId
  profile {
    ...UserProfile
  }
  resolvedName
  walletAddress
  walletBlockchain
}
    ${UserProfileFragmentDoc}`;
export const ParticipantsFragmentDoc = gql`
    fragment Participants on Conversation {
  id
  participants {
    ...ConversationParticipant
  }
}
    ${ConversationParticipantFragmentDoc}`;
export const ConversationFragmentDoc = gql`
    fragment Conversation on Conversation {
  id
  name
  createdDate
  backgroundImageUrl
  conversationGates {
    ...ConversationGate
  }
  updatedDate
  ...Participants
  conversationType
}
    ${ConversationGateFragmentDoc}
${ParticipantsFragmentDoc}`;
export const ConversationMessageFragmentDoc = gql`
    fragment ConversationMessage on ConversationMessage {
  id
  userId
  conversationId
  createdDate
  updatedDate
  message
  conversationParticipant {
    ...ConversationParticipant
  }
}
    ${ConversationParticipantFragmentDoc}`;
export const ConvMessagePageInfoFragmentDoc = gql`
    fragment ConvMessagePageInfo on PageInfo {
  hasNextPage
  endCursor
}
    `;
export const JabberParticipantFragmentDoc = gql`
    fragment JabberParticipant on JabberV1Participant {
  notifiProfile {
    ...UserProfile
  }
  resolvedName
  solPerMessage
  walletAddress
  walletBlockchain
}
    ${UserProfileFragmentDoc}`;
export const JabberMessageFragmentDoc = gql`
    fragment JabberMessage on JabberV1Message {
  isEncrypted
  message
  id
  threadId
  messageBase64
  senderWalletAddress
  senderWalletBlockchain
  timestamp
}
    `;
export const JabberThreadFragmentDoc = gql`
    fragment JabberThread on JabberV1Thread {
  id
  participants {
    ...JabberParticipant
  }
  lastConversationMessage {
    ...JabberMessage
  }
}
    ${JabberParticipantFragmentDoc}
${JabberMessageFragmentDoc}`;
export const NotificationTargetFragmentDoc = gql`
    fragment NotificationTarget on NotificationTarget {
  type
  name
}
    `;
export const NotificationHistoryEntryFragmentDoc = gql`
    fragment NotificationHistoryEntry on NotificationHistoryEntry {
  id
  createdDate
  eventId
  read
  sourceAddress
  category
  transactionSignature
  targets {
    ...NotificationTarget
  }
  detail {
    __typename
    ... on AccountBalanceChangedEventDetails {
      walletBlockchain
      direction
      newValue
      previousValue
      tokenSymbol
      isWhaleWatch
    }
    ... on BroadcastMessageEventDetails {
      messageType: type
      subject
      message
      messageHtml
    }
    ... on DirectTenantMessageEventDetails {
      tenantName
    }
    ... on NftCollectionsReportEventDetails {
      type
      providerName
      sourceLink
      collections {
        collectionId
        name
        imgUrl
        volume1Day
        volume1DayChange
      }
    }
    ... on ChatMessageReceivedEventDetails {
      messageBody
      senderName
      conversationId
      messageId
      senderId
      senderBlockchain
      senderName
      messageBody
    }
    ... on DAOProposalChangedEventDetails {
      tenantName
      proposalTitle: title
      description
      state
      daoUrl
      proposalUrl
    }
    ... on NftAuctionChangedEventDetails {
      auctionTitle: title
      auctionUrl
      walletBlockchain
      highBidAmount
      highBidSymbol
      imageUrl
    }
    ... on WalletsActivityReportEventDetails {
      providerName
      sourceLink
      walletActivityType: type
      wallets {
        address
        volume1Day
        maxPurchase1Day
        maxPurchaseName
        maxPurchaseImgUrl
        maxPurchaseTokenAddress
      }
    }
    ... on HealthValueOverThresholdEventDetails {
      name
      value
      threshold
      url
    }
    ... on DirectTenantMessageEventDetails {
      tenantName
    }
    ... on GenericEventDetails {
      sourceName
      notificationTypeName
      genericMessage: message
      action {
        name
        url
      }
    }
  }
}
    ${NotificationTargetFragmentDoc}`;
export const SlackTargetFragmentDoc = gql`
    fragment SlackTarget on VerifySlackChannelTargetResponse {
  slackChannelTarget {
    id
    name
    slackChannelName
    slackWorkspaceName
    verificationLink
    verificationStatus
  }
}
    `;
export const SlackWebhookTargetFragmentDoc = gql`
    fragment SlackWebhookTarget on VerifySlackChannelTargetForWebhookResponse {
  slackChannelTarget {
    id
    name
    slackChannelName
    slackWorkspaceName
    webhookVerificationLink
    verificationStatus
  }
}
    `;
export const ConfirmChannelForSlackChannelTargetResponseFragmentDoc = gql`
    fragment ConfirmChannelForSlackChannelTargetResponse on ConfirmChannelForSlackChannelTargetResponse {
  slackChannelTarget {
    id
    name
    slackChannelName
    slackWorkspaceName
    verificationLink
    verificationStatus
  }
}
    `;
export const ListAvailableSlackChannelResponseFragmentDoc = gql`
    fragment ListAvailableSlackChannelResponse on ListAvailableSlackChannelResponse {
  slackChannels {
    id
    name
  }
}
    `;
export const GetSlackWorkspaceIconResponseFragmentDoc = gql`
    fragment GetSlackWorkspaceIconResponse on GetSlackWorkspaceIconResponse {
  iconUrl
}
    `;
export const GetSlackChannelBotInfoResponseFragmentDoc = gql`
    fragment GetSlackChannelBotInfoResponse on GetSlackChannelBotInfoResponse {
  botName
  iconUrl
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  emailConfirmed
  roles
  authorization {
    token
    expiry
  }
  settings {
    detailedAlertHistoryEnabled
    userHasChatEnabled
  }
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on UserSettings {
  detailedAlertHistoryEnabled
  userHasChatEnabled
}
    `;
export const TargetGroupSummaryFragmentDoc = gql`
    fragment TargetGroupSummary on TargetGroup {
  telegramTargets {
    id
  }
  emailTargets {
    id
  }
  smsTargets {
    id
  }
}
    `;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($userProfileInput: UserProfileInput!) {
  updateUserProfile(userProfileInput: $userProfileInput) {
    id
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      userProfileInput: // value for 'userProfileInput'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const CreateAlertDocument = gql`
    mutation createAlert($alertInput: CreateAlertInput) {
  createAlert(alertInput: $alertInput) {
    ...Alert
  }
}
    ${AlertFragmentDoc}`;
export type CreateAlertMutationFn = Apollo.MutationFunction<CreateAlertMutation, CreateAlertMutationVariables>;

/**
 * __useCreateAlertMutation__
 *
 * To run a mutation, you first call `useCreateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertMutation, { data, loading, error }] = useCreateAlertMutation({
 *   variables: {
 *      alertInput: // value for 'alertInput'
 *   },
 * });
 */
export function useCreateAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertMutation, CreateAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertMutation, CreateAlertMutationVariables>(CreateAlertDocument, options);
      }
export type CreateAlertMutationHookResult = ReturnType<typeof useCreateAlertMutation>;
export type CreateAlertMutationResult = Apollo.MutationResult<CreateAlertMutation>;
export type CreateAlertMutationOptions = Apollo.BaseMutationOptions<CreateAlertMutation, CreateAlertMutationVariables>;
export const DeleteAlertDocument = gql`
    mutation deleteAlert($alertId: String) {
  deleteAlert(alertId: $alertId) {
    id
  }
}
    `;
export type DeleteAlertMutationFn = Apollo.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>;

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      alertId: // value for 'alertId'
 *   },
 * });
 */
export function useDeleteAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertMutation, DeleteAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertMutation, DeleteAlertMutationVariables>(DeleteAlertDocument, options);
      }
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = Apollo.MutationResult<DeleteAlertMutation>;
export type DeleteAlertMutationOptions = Apollo.BaseMutationOptions<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const BeginLogInByQrCodeDocument = gql`
    mutation beginLogInByQRCode {
  beginLogInByQRCode {
    nonce
  }
}
    `;
export type BeginLogInByQrCodeMutationFn = Apollo.MutationFunction<BeginLogInByQrCodeMutation, BeginLogInByQrCodeMutationVariables>;

/**
 * __useBeginLogInByQrCodeMutation__
 *
 * To run a mutation, you first call `useBeginLogInByQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginLogInByQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginLogInByQrCodeMutation, { data, loading, error }] = useBeginLogInByQrCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useBeginLogInByQrCodeMutation(baseOptions?: Apollo.MutationHookOptions<BeginLogInByQrCodeMutation, BeginLogInByQrCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginLogInByQrCodeMutation, BeginLogInByQrCodeMutationVariables>(BeginLogInByQrCodeDocument, options);
      }
export type BeginLogInByQrCodeMutationHookResult = ReturnType<typeof useBeginLogInByQrCodeMutation>;
export type BeginLogInByQrCodeMutationResult = Apollo.MutationResult<BeginLogInByQrCodeMutation>;
export type BeginLogInByQrCodeMutationOptions = Apollo.BaseMutationOptions<BeginLogInByQrCodeMutation, BeginLogInByQrCodeMutationVariables>;
export const BeginLogInByTransactionDocument = gql`
    mutation beginLogInByTransaction($input: BeginLogInByTransactionInput!) {
  beginLogInByTransaction(beginLogInByTransactionInput: $input) {
    nonce
  }
}
    `;
export type BeginLogInByTransactionMutationFn = Apollo.MutationFunction<BeginLogInByTransactionMutation, BeginLogInByTransactionMutationVariables>;

/**
 * __useBeginLogInByTransactionMutation__
 *
 * To run a mutation, you first call `useBeginLogInByTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginLogInByTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginLogInByTransactionMutation, { data, loading, error }] = useBeginLogInByTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBeginLogInByTransactionMutation(baseOptions?: Apollo.MutationHookOptions<BeginLogInByTransactionMutation, BeginLogInByTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginLogInByTransactionMutation, BeginLogInByTransactionMutationVariables>(BeginLogInByTransactionDocument, options);
      }
export type BeginLogInByTransactionMutationHookResult = ReturnType<typeof useBeginLogInByTransactionMutation>;
export type BeginLogInByTransactionMutationResult = Apollo.MutationResult<BeginLogInByTransactionMutation>;
export type BeginLogInByTransactionMutationOptions = Apollo.BaseMutationOptions<BeginLogInByTransactionMutation, BeginLogInByTransactionMutationVariables>;
export const BroadcastMessageDocument = gql`
    mutation broadcastMessage($broadcastMessageInput: BroadcastMessageInput!, $signature: String!) {
  broadcastMessage(
    broadcastMessageInput: $broadcastMessageInput
    signature: $signature
  ) {
    id
  }
}
    `;
export type BroadcastMessageMutationFn = Apollo.MutationFunction<BroadcastMessageMutation, BroadcastMessageMutationVariables>;

/**
 * __useBroadcastMessageMutation__
 *
 * To run a mutation, you first call `useBroadcastMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastMessageMutation, { data, loading, error }] = useBroadcastMessageMutation({
 *   variables: {
 *      broadcastMessageInput: // value for 'broadcastMessageInput'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useBroadcastMessageMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastMessageMutation, BroadcastMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastMessageMutation, BroadcastMessageMutationVariables>(BroadcastMessageDocument, options);
      }
export type BroadcastMessageMutationHookResult = ReturnType<typeof useBroadcastMessageMutation>;
export type BroadcastMessageMutationResult = Apollo.MutationResult<BroadcastMessageMutation>;
export type BroadcastMessageMutationOptions = Apollo.BaseMutationOptions<BroadcastMessageMutation, BroadcastMessageMutationVariables>;
export const CompleteLogInByTransactionDocument = gql`
    mutation completeLogInByTransaction($input: CompleteLogInByTransactionInput!) {
  completeLogInByTransaction(completeLogInByTransactionInput: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type CompleteLogInByTransactionMutationFn = Apollo.MutationFunction<CompleteLogInByTransactionMutation, CompleteLogInByTransactionMutationVariables>;

/**
 * __useCompleteLogInByTransactionMutation__
 *
 * To run a mutation, you first call `useCompleteLogInByTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLogInByTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLogInByTransactionMutation, { data, loading, error }] = useCompleteLogInByTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteLogInByTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteLogInByTransactionMutation, CompleteLogInByTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteLogInByTransactionMutation, CompleteLogInByTransactionMutationVariables>(CompleteLogInByTransactionDocument, options);
      }
export type CompleteLogInByTransactionMutationHookResult = ReturnType<typeof useCompleteLogInByTransactionMutation>;
export type CompleteLogInByTransactionMutationResult = Apollo.MutationResult<CompleteLogInByTransactionMutation>;
export type CompleteLogInByTransactionMutationOptions = Apollo.BaseMutationOptions<CompleteLogInByTransactionMutation, CompleteLogInByTransactionMutationVariables>;
export const ConfirmSlackChannelTargetDocument = gql`
    mutation ConfirmSlackChannelTarget($input: ConfirmChannelForSlackChannelTargetInput!) {
  confirmChannelForSlackChannelTarget(input: $input) {
    ...ConfirmChannelForSlackChannelTargetResponse
  }
}
    ${ConfirmChannelForSlackChannelTargetResponseFragmentDoc}`;
export type ConfirmSlackChannelTargetMutationFn = Apollo.MutationFunction<ConfirmSlackChannelTargetMutation, ConfirmSlackChannelTargetMutationVariables>;

/**
 * __useConfirmSlackChannelTargetMutation__
 *
 * To run a mutation, you first call `useConfirmSlackChannelTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSlackChannelTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSlackChannelTargetMutation, { data, loading, error }] = useConfirmSlackChannelTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmSlackChannelTargetMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmSlackChannelTargetMutation, ConfirmSlackChannelTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmSlackChannelTargetMutation, ConfirmSlackChannelTargetMutationVariables>(ConfirmSlackChannelTargetDocument, options);
      }
export type ConfirmSlackChannelTargetMutationHookResult = ReturnType<typeof useConfirmSlackChannelTargetMutation>;
export type ConfirmSlackChannelTargetMutationResult = Apollo.MutationResult<ConfirmSlackChannelTargetMutation>;
export type ConfirmSlackChannelTargetMutationOptions = Apollo.BaseMutationOptions<ConfirmSlackChannelTargetMutation, ConfirmSlackChannelTargetMutationVariables>;
export const LeaveConversationDocument = gql`
    mutation leaveConversation($leaveConversationInput: LeaveConversationInput!) {
  leaveConversation(leaveConversationInput: $leaveConversationInput) {
    id
  }
}
    `;
export type LeaveConversationMutationFn = Apollo.MutationFunction<LeaveConversationMutation, LeaveConversationMutationVariables>;

/**
 * __useLeaveConversationMutation__
 *
 * To run a mutation, you first call `useLeaveConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveConversationMutation, { data, loading, error }] = useLeaveConversationMutation({
 *   variables: {
 *      leaveConversationInput: // value for 'leaveConversationInput'
 *   },
 * });
 */
export function useLeaveConversationMutation(baseOptions?: Apollo.MutationHookOptions<LeaveConversationMutation, LeaveConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveConversationMutation, LeaveConversationMutationVariables>(LeaveConversationDocument, options);
      }
export type LeaveConversationMutationHookResult = ReturnType<typeof useLeaveConversationMutation>;
export type LeaveConversationMutationResult = Apollo.MutationResult<LeaveConversationMutation>;
export type LeaveConversationMutationOptions = Apollo.BaseMutationOptions<LeaveConversationMutation, LeaveConversationMutationVariables>;
export const SendConversationMessageDocument = gql`
    mutation sendConversationMessage($sendConversationMessageInput: SendConversationMessageInput!) {
  sendConversationMessage(
    sendConversationMessageInput: $sendConversationMessageInput
  ) {
    ...ConversationMessage
  }
}
    ${ConversationMessageFragmentDoc}`;
export type SendConversationMessageMutationFn = Apollo.MutationFunction<SendConversationMessageMutation, SendConversationMessageMutationVariables>;

/**
 * __useSendConversationMessageMutation__
 *
 * To run a mutation, you first call `useSendConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConversationMessageMutation, { data, loading, error }] = useSendConversationMessageMutation({
 *   variables: {
 *      sendConversationMessageInput: // value for 'sendConversationMessageInput'
 *   },
 * });
 */
export function useSendConversationMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendConversationMessageMutation, SendConversationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendConversationMessageMutation, SendConversationMessageMutationVariables>(SendConversationMessageDocument, options);
      }
export type SendConversationMessageMutationHookResult = ReturnType<typeof useSendConversationMessageMutation>;
export type SendConversationMessageMutationResult = Apollo.MutationResult<SendConversationMessageMutation>;
export type SendConversationMessageMutationOptions = Apollo.BaseMutationOptions<SendConversationMessageMutation, SendConversationMessageMutationVariables>;
export const CreateConversationDocument = gql`
    mutation createConversation($createConversationInput: CreateConversationInput!) {
  createConversation(createConversationInput: $createConversationInput) {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      createConversationInput: // value for 'createConversationInput'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const CreateDiscordTargetDocument = gql`
    mutation createDiscordTarget($name: String!, $value: String!) {
  createDiscordTarget(createTargetInput: {name: $name, value: $value}) {
    ...DiscordTarget
  }
}
    ${DiscordTargetFragmentDoc}`;
export type CreateDiscordTargetMutationFn = Apollo.MutationFunction<CreateDiscordTargetMutation, CreateDiscordTargetMutationVariables>;

/**
 * __useCreateDiscordTargetMutation__
 *
 * To run a mutation, you first call `useCreateDiscordTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscordTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscordTargetMutation, { data, loading, error }] = useCreateDiscordTargetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateDiscordTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscordTargetMutation, CreateDiscordTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscordTargetMutation, CreateDiscordTargetMutationVariables>(CreateDiscordTargetDocument, options);
      }
export type CreateDiscordTargetMutationHookResult = ReturnType<typeof useCreateDiscordTargetMutation>;
export type CreateDiscordTargetMutationResult = Apollo.MutationResult<CreateDiscordTargetMutation>;
export type CreateDiscordTargetMutationOptions = Apollo.BaseMutationOptions<CreateDiscordTargetMutation, CreateDiscordTargetMutationVariables>;
export const DeleteDAppSubscriptionDocument = gql`
    mutation deleteDAppSubscription($subscriptionId: String!) {
  deleteDAppSubscription(subscriptionId: $subscriptionId) {
    id
  }
}
    `;
export type DeleteDAppSubscriptionMutationFn = Apollo.MutationFunction<DeleteDAppSubscriptionMutation, DeleteDAppSubscriptionMutationVariables>;

/**
 * __useDeleteDAppSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteDAppSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDAppSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDAppSubscriptionMutation, { data, loading, error }] = useDeleteDAppSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useDeleteDAppSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDAppSubscriptionMutation, DeleteDAppSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDAppSubscriptionMutation, DeleteDAppSubscriptionMutationVariables>(DeleteDAppSubscriptionDocument, options);
      }
export type DeleteDAppSubscriptionMutationHookResult = ReturnType<typeof useDeleteDAppSubscriptionMutation>;
export type DeleteDAppSubscriptionMutationResult = Apollo.MutationResult<DeleteDAppSubscriptionMutation>;
export type DeleteDAppSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteDAppSubscriptionMutation, DeleteDAppSubscriptionMutationVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
  markNotificationsAsRead(input: $input) {
    ...NotificationHistoryEntry
  }
}
    ${NotificationHistoryEntryFragmentDoc}`;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const CreateSourceDocument = gql`
    mutation createSource($createSourceInput: CreateSourceInput) {
  createSource(createSourceInput: $createSourceInput) {
    ...Source
  }
}
    ${SourceFragmentDoc}`;
export type CreateSourceMutationFn = Apollo.MutationFunction<CreateSourceMutation, CreateSourceMutationVariables>;

/**
 * __useCreateSourceMutation__
 *
 * To run a mutation, you first call `useCreateSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourceMutation, { data, loading, error }] = useCreateSourceMutation({
 *   variables: {
 *      createSourceInput: // value for 'createSourceInput'
 *   },
 * });
 */
export function useCreateSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSourceMutation, CreateSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSourceMutation, CreateSourceMutationVariables>(CreateSourceDocument, options);
      }
export type CreateSourceMutationHookResult = ReturnType<typeof useCreateSourceMutation>;
export type CreateSourceMutationResult = Apollo.MutationResult<CreateSourceMutation>;
export type CreateSourceMutationOptions = Apollo.BaseMutationOptions<CreateSourceMutation, CreateSourceMutationVariables>;
export const DeleteSourceDocument = gql`
    mutation deleteSource($sourceId: String) {
  deleteSource(sourceId: $sourceId) {
    id
  }
}
    `;
export type DeleteSourceMutationFn = Apollo.MutationFunction<DeleteSourceMutation, DeleteSourceMutationVariables>;

/**
 * __useDeleteSourceMutation__
 *
 * To run a mutation, you first call `useDeleteSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourceMutation, { data, loading, error }] = useDeleteSourceMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useDeleteSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSourceMutation, DeleteSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSourceMutation, DeleteSourceMutationVariables>(DeleteSourceDocument, options);
      }
export type DeleteSourceMutationHookResult = ReturnType<typeof useDeleteSourceMutation>;
export type DeleteSourceMutationResult = Apollo.MutationResult<DeleteSourceMutation>;
export type DeleteSourceMutationOptions = Apollo.BaseMutationOptions<DeleteSourceMutation, DeleteSourceMutationVariables>;
export const CreateSourceGroupDocument = gql`
    mutation createSourceGroup($sourceGroupInput: SourceGroupInput) {
  createSourceGroup(sourceGroupInput: $sourceGroupInput) {
    ...SourceGroup
  }
}
    ${SourceGroupFragmentDoc}`;
export type CreateSourceGroupMutationFn = Apollo.MutationFunction<CreateSourceGroupMutation, CreateSourceGroupMutationVariables>;

/**
 * __useCreateSourceGroupMutation__
 *
 * To run a mutation, you first call `useCreateSourceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourceGroupMutation, { data, loading, error }] = useCreateSourceGroupMutation({
 *   variables: {
 *      sourceGroupInput: // value for 'sourceGroupInput'
 *   },
 * });
 */
export function useCreateSourceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSourceGroupMutation, CreateSourceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSourceGroupMutation, CreateSourceGroupMutationVariables>(CreateSourceGroupDocument, options);
      }
export type CreateSourceGroupMutationHookResult = ReturnType<typeof useCreateSourceGroupMutation>;
export type CreateSourceGroupMutationResult = Apollo.MutationResult<CreateSourceGroupMutation>;
export type CreateSourceGroupMutationOptions = Apollo.BaseMutationOptions<CreateSourceGroupMutation, CreateSourceGroupMutationVariables>;
export const DeleteSourceGroupDocument = gql`
    mutation deleteSourceGroup($sourceGroupInput: SourceGroupInput) {
  deleteSourceGroup(sourceGroupInput: $sourceGroupInput) {
    id
  }
}
    `;
export type DeleteSourceGroupMutationFn = Apollo.MutationFunction<DeleteSourceGroupMutation, DeleteSourceGroupMutationVariables>;

/**
 * __useDeleteSourceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSourceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourceGroupMutation, { data, loading, error }] = useDeleteSourceGroupMutation({
 *   variables: {
 *      sourceGroupInput: // value for 'sourceGroupInput'
 *   },
 * });
 */
export function useDeleteSourceGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSourceGroupMutation, DeleteSourceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSourceGroupMutation, DeleteSourceGroupMutationVariables>(DeleteSourceGroupDocument, options);
      }
export type DeleteSourceGroupMutationHookResult = ReturnType<typeof useDeleteSourceGroupMutation>;
export type DeleteSourceGroupMutationResult = Apollo.MutationResult<DeleteSourceGroupMutation>;
export type DeleteSourceGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSourceGroupMutation, DeleteSourceGroupMutationVariables>;
export const CreateEmailTargetDocument = gql`
    mutation createEmailTarget($createTargetInput: CreateTargetInput) {
  createEmailTarget(createTargetInput: $createTargetInput) {
    id
    emailAddress
    isConfirmed
  }
}
    `;
export type CreateEmailTargetMutationFn = Apollo.MutationFunction<CreateEmailTargetMutation, CreateEmailTargetMutationVariables>;

/**
 * __useCreateEmailTargetMutation__
 *
 * To run a mutation, you first call `useCreateEmailTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTargetMutation, { data, loading, error }] = useCreateEmailTargetMutation({
 *   variables: {
 *      createTargetInput: // value for 'createTargetInput'
 *   },
 * });
 */
export function useCreateEmailTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTargetMutation, CreateEmailTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTargetMutation, CreateEmailTargetMutationVariables>(CreateEmailTargetDocument, options);
      }
export type CreateEmailTargetMutationHookResult = ReturnType<typeof useCreateEmailTargetMutation>;
export type CreateEmailTargetMutationResult = Apollo.MutationResult<CreateEmailTargetMutation>;
export type CreateEmailTargetMutationOptions = Apollo.BaseMutationOptions<CreateEmailTargetMutation, CreateEmailTargetMutationVariables>;
export const CreateSmsTargetDocument = gql`
    mutation createSmsTarget($createTargetInput: CreateTargetInput) {
  createSmsTarget(createTargetInput: $createTargetInput) {
    id
    phoneNumber
    isConfirmed
  }
}
    `;
export type CreateSmsTargetMutationFn = Apollo.MutationFunction<CreateSmsTargetMutation, CreateSmsTargetMutationVariables>;

/**
 * __useCreateSmsTargetMutation__
 *
 * To run a mutation, you first call `useCreateSmsTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSmsTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSmsTargetMutation, { data, loading, error }] = useCreateSmsTargetMutation({
 *   variables: {
 *      createTargetInput: // value for 'createTargetInput'
 *   },
 * });
 */
export function useCreateSmsTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateSmsTargetMutation, CreateSmsTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSmsTargetMutation, CreateSmsTargetMutationVariables>(CreateSmsTargetDocument, options);
      }
export type CreateSmsTargetMutationHookResult = ReturnType<typeof useCreateSmsTargetMutation>;
export type CreateSmsTargetMutationResult = Apollo.MutationResult<CreateSmsTargetMutation>;
export type CreateSmsTargetMutationOptions = Apollo.BaseMutationOptions<CreateSmsTargetMutation, CreateSmsTargetMutationVariables>;
export const CreateTelegramTargetDocument = gql`
    mutation createTelegramTarget($createTargetInput: CreateTargetInput) {
  createTelegramTarget(createTargetInput: $createTargetInput) {
    id
    telegramId
    isConfirmed
  }
}
    `;
export type CreateTelegramTargetMutationFn = Apollo.MutationFunction<CreateTelegramTargetMutation, CreateTelegramTargetMutationVariables>;

/**
 * __useCreateTelegramTargetMutation__
 *
 * To run a mutation, you first call `useCreateTelegramTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTelegramTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTelegramTargetMutation, { data, loading, error }] = useCreateTelegramTargetMutation({
 *   variables: {
 *      createTargetInput: // value for 'createTargetInput'
 *   },
 * });
 */
export function useCreateTelegramTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateTelegramTargetMutation, CreateTelegramTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTelegramTargetMutation, CreateTelegramTargetMutationVariables>(CreateTelegramTargetDocument, options);
      }
export type CreateTelegramTargetMutationHookResult = ReturnType<typeof useCreateTelegramTargetMutation>;
export type CreateTelegramTargetMutationResult = Apollo.MutationResult<CreateTelegramTargetMutation>;
export type CreateTelegramTargetMutationOptions = Apollo.BaseMutationOptions<CreateTelegramTargetMutation, CreateTelegramTargetMutationVariables>;
export const DeleteEmailTargetDocument = gql`
    mutation deleteEmailTarget($deleteTargetInput: DeleteTargetInput) {
  deleteEmailTarget(deleteTargetInput: $deleteTargetInput) {
    id
  }
}
    `;
export type DeleteEmailTargetMutationFn = Apollo.MutationFunction<DeleteEmailTargetMutation, DeleteEmailTargetMutationVariables>;

/**
 * __useDeleteEmailTargetMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTargetMutation, { data, loading, error }] = useDeleteEmailTargetMutation({
 *   variables: {
 *      deleteTargetInput: // value for 'deleteTargetInput'
 *   },
 * });
 */
export function useDeleteEmailTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTargetMutation, DeleteEmailTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTargetMutation, DeleteEmailTargetMutationVariables>(DeleteEmailTargetDocument, options);
      }
export type DeleteEmailTargetMutationHookResult = ReturnType<typeof useDeleteEmailTargetMutation>;
export type DeleteEmailTargetMutationResult = Apollo.MutationResult<DeleteEmailTargetMutation>;
export type DeleteEmailTargetMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTargetMutation, DeleteEmailTargetMutationVariables>;
export const DeleteSmsTargetDocument = gql`
    mutation deleteSmsTarget($deleteTargetInput: DeleteTargetInput) {
  deleteSmsTarget(deleteTargetInput: $deleteTargetInput) {
    id
  }
}
    `;
export type DeleteSmsTargetMutationFn = Apollo.MutationFunction<DeleteSmsTargetMutation, DeleteSmsTargetMutationVariables>;

/**
 * __useDeleteSmsTargetMutation__
 *
 * To run a mutation, you first call `useDeleteSmsTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSmsTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSmsTargetMutation, { data, loading, error }] = useDeleteSmsTargetMutation({
 *   variables: {
 *      deleteTargetInput: // value for 'deleteTargetInput'
 *   },
 * });
 */
export function useDeleteSmsTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSmsTargetMutation, DeleteSmsTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSmsTargetMutation, DeleteSmsTargetMutationVariables>(DeleteSmsTargetDocument, options);
      }
export type DeleteSmsTargetMutationHookResult = ReturnType<typeof useDeleteSmsTargetMutation>;
export type DeleteSmsTargetMutationResult = Apollo.MutationResult<DeleteSmsTargetMutation>;
export type DeleteSmsTargetMutationOptions = Apollo.BaseMutationOptions<DeleteSmsTargetMutation, DeleteSmsTargetMutationVariables>;
export const DeleteTelegramTargetDocument = gql`
    mutation deleteTelegramTarget($deleteTargetInput: DeleteTargetInput) {
  deleteTelegramTarget(deleteTargetInput: $deleteTargetInput) {
    id
  }
}
    `;
export type DeleteTelegramTargetMutationFn = Apollo.MutationFunction<DeleteTelegramTargetMutation, DeleteTelegramTargetMutationVariables>;

/**
 * __useDeleteTelegramTargetMutation__
 *
 * To run a mutation, you first call `useDeleteTelegramTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTelegramTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTelegramTargetMutation, { data, loading, error }] = useDeleteTelegramTargetMutation({
 *   variables: {
 *      deleteTargetInput: // value for 'deleteTargetInput'
 *   },
 * });
 */
export function useDeleteTelegramTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTelegramTargetMutation, DeleteTelegramTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTelegramTargetMutation, DeleteTelegramTargetMutationVariables>(DeleteTelegramTargetDocument, options);
      }
export type DeleteTelegramTargetMutationHookResult = ReturnType<typeof useDeleteTelegramTargetMutation>;
export type DeleteTelegramTargetMutationResult = Apollo.MutationResult<DeleteTelegramTargetMutation>;
export type DeleteTelegramTargetMutationOptions = Apollo.BaseMutationOptions<DeleteTelegramTargetMutation, DeleteTelegramTargetMutationVariables>;
export const DeleteDiscordTargetDocument = gql`
    mutation deleteDiscordTarget($deleteTargetInput: DeleteTargetInput) {
  deleteDiscordTarget(deleteTargetInput: $deleteTargetInput) {
    id
  }
}
    `;
export type DeleteDiscordTargetMutationFn = Apollo.MutationFunction<DeleteDiscordTargetMutation, DeleteDiscordTargetMutationVariables>;

/**
 * __useDeleteDiscordTargetMutation__
 *
 * To run a mutation, you first call `useDeleteDiscordTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscordTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscordTargetMutation, { data, loading, error }] = useDeleteDiscordTargetMutation({
 *   variables: {
 *      deleteTargetInput: // value for 'deleteTargetInput'
 *   },
 * });
 */
export function useDeleteDiscordTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscordTargetMutation, DeleteDiscordTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscordTargetMutation, DeleteDiscordTargetMutationVariables>(DeleteDiscordTargetDocument, options);
      }
export type DeleteDiscordTargetMutationHookResult = ReturnType<typeof useDeleteDiscordTargetMutation>;
export type DeleteDiscordTargetMutationResult = Apollo.MutationResult<DeleteDiscordTargetMutation>;
export type DeleteDiscordTargetMutationOptions = Apollo.BaseMutationOptions<DeleteDiscordTargetMutation, DeleteDiscordTargetMutationVariables>;
export const SendEmailTargetVerificationRequestDocument = gql`
    mutation sendEmailTargetVerificationRequest($sendTargetConfirmationRequestInput: SendTargetConfirmationRequestInput) {
  sendEmailTargetVerificationRequest(
    sendTargetConfirmationRequestInput: $sendTargetConfirmationRequestInput
  ) {
    emailAddress
    isConfirmed
    id
    name
    createdDate
    updatedDate
  }
}
    `;
export type SendEmailTargetVerificationRequestMutationFn = Apollo.MutationFunction<SendEmailTargetVerificationRequestMutation, SendEmailTargetVerificationRequestMutationVariables>;

/**
 * __useSendEmailTargetVerificationRequestMutation__
 *
 * To run a mutation, you first call `useSendEmailTargetVerificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailTargetVerificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailTargetVerificationRequestMutation, { data, loading, error }] = useSendEmailTargetVerificationRequestMutation({
 *   variables: {
 *      sendTargetConfirmationRequestInput: // value for 'sendTargetConfirmationRequestInput'
 *   },
 * });
 */
export function useSendEmailTargetVerificationRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailTargetVerificationRequestMutation, SendEmailTargetVerificationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailTargetVerificationRequestMutation, SendEmailTargetVerificationRequestMutationVariables>(SendEmailTargetVerificationRequestDocument, options);
      }
export type SendEmailTargetVerificationRequestMutationHookResult = ReturnType<typeof useSendEmailTargetVerificationRequestMutation>;
export type SendEmailTargetVerificationRequestMutationResult = Apollo.MutationResult<SendEmailTargetVerificationRequestMutation>;
export type SendEmailTargetVerificationRequestMutationOptions = Apollo.BaseMutationOptions<SendEmailTargetVerificationRequestMutation, SendEmailTargetVerificationRequestMutationVariables>;
export const CreateTargetGroupDocument = gql`
    mutation createTargetGroup($targetGroupInput: TargetGroupInput) {
  createTargetGroup(targetGroupInput: $targetGroupInput) {
    ...TargetGroup
  }
}
    ${TargetGroupFragmentDoc}`;
export type CreateTargetGroupMutationFn = Apollo.MutationFunction<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>;

/**
 * __useCreateTargetGroupMutation__
 *
 * To run a mutation, you first call `useCreateTargetGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetGroupMutation, { data, loading, error }] = useCreateTargetGroupMutation({
 *   variables: {
 *      targetGroupInput: // value for 'targetGroupInput'
 *   },
 * });
 */
export function useCreateTargetGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>(CreateTargetGroupDocument, options);
      }
export type CreateTargetGroupMutationHookResult = ReturnType<typeof useCreateTargetGroupMutation>;
export type CreateTargetGroupMutationResult = Apollo.MutationResult<CreateTargetGroupMutation>;
export type CreateTargetGroupMutationOptions = Apollo.BaseMutationOptions<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>;
export const DeleteTargetGroupDocument = gql`
    mutation deleteTargetGroup($targetGroupInput: TargetGroupInput) {
  deleteTargetGroup(targetGroupInput: $targetGroupInput) {
    id
  }
}
    `;
export type DeleteTargetGroupMutationFn = Apollo.MutationFunction<DeleteTargetGroupMutation, DeleteTargetGroupMutationVariables>;

/**
 * __useDeleteTargetGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTargetGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTargetGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTargetGroupMutation, { data, loading, error }] = useDeleteTargetGroupMutation({
 *   variables: {
 *      targetGroupInput: // value for 'targetGroupInput'
 *   },
 * });
 */
export function useDeleteTargetGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTargetGroupMutation, DeleteTargetGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTargetGroupMutation, DeleteTargetGroupMutationVariables>(DeleteTargetGroupDocument, options);
      }
export type DeleteTargetGroupMutationHookResult = ReturnType<typeof useDeleteTargetGroupMutation>;
export type DeleteTargetGroupMutationResult = Apollo.MutationResult<DeleteTargetGroupMutation>;
export type DeleteTargetGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTargetGroupMutation, DeleteTargetGroupMutationVariables>;
export const VerifyTargetDocument = gql`
    mutation verifyTarget($verifyTargetInput: VerifyTargetInput) {
  verifyTarget(verifyTargetInput: $verifyTargetInput) {
    emailAddress
    isConfirmed
  }
}
    `;
export type VerifyTargetMutationFn = Apollo.MutationFunction<VerifyTargetMutation, VerifyTargetMutationVariables>;

/**
 * __useVerifyTargetMutation__
 *
 * To run a mutation, you first call `useVerifyTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTargetMutation, { data, loading, error }] = useVerifyTargetMutation({
 *   variables: {
 *      verifyTargetInput: // value for 'verifyTargetInput'
 *   },
 * });
 */
export function useVerifyTargetMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTargetMutation, VerifyTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTargetMutation, VerifyTargetMutationVariables>(VerifyTargetDocument, options);
      }
export type VerifyTargetMutationHookResult = ReturnType<typeof useVerifyTargetMutation>;
export type VerifyTargetMutationResult = Apollo.MutationResult<VerifyTargetMutation>;
export type VerifyTargetMutationOptions = Apollo.BaseMutationOptions<VerifyTargetMutation, VerifyTargetMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation unsubscribe($input: UnsubscribeInputTypeInput!) {
  unsubscribe(unsubscribeInputType: $input) {
    tenantName
    targetValue
  }
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($userSettingsInput: UserSettingsInput!) {
  updateUserSettings(userSettings: $userSettingsInput) {
    detailedAlertHistoryEnabled
    userHasChatEnabled
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      userSettingsInput: // value for 'userSettingsInput'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation confirmEmail($email: String!, $token: String!) {
  confirmEmail(email: $email, token: $token)
}
    `;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $password: String!) {
  create(user: {email: $email, password: $password}) {
    email
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const SubmitLoginDocument = gql`
    mutation submitLogin($email: String!, $password: String!) {
  logIn(email: $email, password: $password) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type SubmitLoginMutationFn = Apollo.MutationFunction<SubmitLoginMutation, SubmitLoginMutationVariables>;

/**
 * __useSubmitLoginMutation__
 *
 * To run a mutation, you first call `useSubmitLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLoginMutation, { data, loading, error }] = useSubmitLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSubmitLoginMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLoginMutation, SubmitLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLoginMutation, SubmitLoginMutationVariables>(SubmitLoginDocument, options);
      }
export type SubmitLoginMutationHookResult = ReturnType<typeof useSubmitLoginMutation>;
export type SubmitLoginMutationResult = Apollo.MutationResult<SubmitLoginMutation>;
export type SubmitLoginMutationOptions = Apollo.BaseMutationOptions<SubmitLoginMutation, SubmitLoginMutationVariables>;
export const SubmitLoginByOAuthDocument = gql`
    mutation submitLoginByOAuth($logInByOAuthInput: LogInByOAuthInput!) {
  logInByOAuth(logInByOAuthInput: $logInByOAuthInput) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type SubmitLoginByOAuthMutationFn = Apollo.MutationFunction<SubmitLoginByOAuthMutation, SubmitLoginByOAuthMutationVariables>;

/**
 * __useSubmitLoginByOAuthMutation__
 *
 * To run a mutation, you first call `useSubmitLoginByOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLoginByOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLoginByOAuthMutation, { data, loading, error }] = useSubmitLoginByOAuthMutation({
 *   variables: {
 *      logInByOAuthInput: // value for 'logInByOAuthInput'
 *   },
 * });
 */
export function useSubmitLoginByOAuthMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLoginByOAuthMutation, SubmitLoginByOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLoginByOAuthMutation, SubmitLoginByOAuthMutationVariables>(SubmitLoginByOAuthDocument, options);
      }
export type SubmitLoginByOAuthMutationHookResult = ReturnType<typeof useSubmitLoginByOAuthMutation>;
export type SubmitLoginByOAuthMutationResult = Apollo.MutationResult<SubmitLoginByOAuthMutation>;
export type SubmitLoginByOAuthMutationOptions = Apollo.BaseMutationOptions<SubmitLoginByOAuthMutation, SubmitLoginByOAuthMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!, $password: String!, $tfaCode: String!) {
  resetPassword(email: $email, password: $password, tfaCode: $tfaCode)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      tfaCode: // value for 'tfaCode'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RefreshAuthorizationDocument = gql`
    mutation refreshAuthorization {
  refreshAuthorization {
    expiry
    token
  }
}
    `;
export type RefreshAuthorizationMutationFn = Apollo.MutationFunction<RefreshAuthorizationMutation, RefreshAuthorizationMutationVariables>;

/**
 * __useRefreshAuthorizationMutation__
 *
 * To run a mutation, you first call `useRefreshAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthorizationMutation, { data, loading, error }] = useRefreshAuthorizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAuthorizationMutation, RefreshAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAuthorizationMutation, RefreshAuthorizationMutationVariables>(RefreshAuthorizationDocument, options);
      }
export type RefreshAuthorizationMutationHookResult = ReturnType<typeof useRefreshAuthorizationMutation>;
export type RefreshAuthorizationMutationResult = Apollo.MutationResult<RefreshAuthorizationMutation>;
export type RefreshAuthorizationMutationOptions = Apollo.BaseMutationOptions<RefreshAuthorizationMutation, RefreshAuthorizationMutationVariables>;
export const GenerateEmailConfirmationTokenDocument = gql`
    mutation generateEmailConfirmationToken($email: String!) {
  generateEmailConfirmationToken(email: $email)
}
    `;
export type GenerateEmailConfirmationTokenMutationFn = Apollo.MutationFunction<GenerateEmailConfirmationTokenMutation, GenerateEmailConfirmationTokenMutationVariables>;

/**
 * __useGenerateEmailConfirmationTokenMutation__
 *
 * To run a mutation, you first call `useGenerateEmailConfirmationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEmailConfirmationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEmailConfirmationTokenMutation, { data, loading, error }] = useGenerateEmailConfirmationTokenMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateEmailConfirmationTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEmailConfirmationTokenMutation, GenerateEmailConfirmationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEmailConfirmationTokenMutation, GenerateEmailConfirmationTokenMutationVariables>(GenerateEmailConfirmationTokenDocument, options);
      }
export type GenerateEmailConfirmationTokenMutationHookResult = ReturnType<typeof useGenerateEmailConfirmationTokenMutation>;
export type GenerateEmailConfirmationTokenMutationResult = Apollo.MutationResult<GenerateEmailConfirmationTokenMutation>;
export type GenerateEmailConfirmationTokenMutationOptions = Apollo.BaseMutationOptions<GenerateEmailConfirmationTokenMutation, GenerateEmailConfirmationTokenMutationVariables>;
export const SendResetPasswordEmailDocument = gql`
    mutation sendResetPasswordEmail($email: String!) {
  sendResetPasswordEmail(email: $email)
}
    `;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(SendResetPasswordEmailDocument, options);
      }
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const ConnectWalletDocument = gql`
    mutation connectWallet($connectWalletInput: ConnectWalletInput!, $signature: String!) {
  connectWallet(connectWalletInput: $connectWalletInput, signature: $signature) {
    address
    walletBlockchain
  }
}
    `;
export type ConnectWalletMutationFn = Apollo.MutationFunction<ConnectWalletMutation, ConnectWalletMutationVariables>;

/**
 * __useConnectWalletMutation__
 *
 * To run a mutation, you first call `useConnectWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectWalletMutation, { data, loading, error }] = useConnectWalletMutation({
 *   variables: {
 *      connectWalletInput: // value for 'connectWalletInput'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useConnectWalletMutation(baseOptions?: Apollo.MutationHookOptions<ConnectWalletMutation, ConnectWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectWalletMutation, ConnectWalletMutationVariables>(ConnectWalletDocument, options);
      }
export type ConnectWalletMutationHookResult = ReturnType<typeof useConnectWalletMutation>;
export type ConnectWalletMutationResult = Apollo.MutationResult<ConnectWalletMutation>;
export type ConnectWalletMutationOptions = Apollo.BaseMutationOptions<ConnectWalletMutation, ConnectWalletMutationVariables>;
export const DisconnectWalletDocument = gql`
    mutation disconnectWallet($disconnectWalletInput: DisconnectWalletInput!) {
  disconnectWallet(disconnectWalletInput: $disconnectWalletInput) {
    address
    walletBlockchain
  }
}
    `;
export type DisconnectWalletMutationFn = Apollo.MutationFunction<DisconnectWalletMutation, DisconnectWalletMutationVariables>;

/**
 * __useDisconnectWalletMutation__
 *
 * To run a mutation, you first call `useDisconnectWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectWalletMutation, { data, loading, error }] = useDisconnectWalletMutation({
 *   variables: {
 *      disconnectWalletInput: // value for 'disconnectWalletInput'
 *   },
 * });
 */
export function useDisconnectWalletMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectWalletMutation, DisconnectWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectWalletMutation, DisconnectWalletMutationVariables>(DisconnectWalletDocument, options);
      }
export type DisconnectWalletMutationHookResult = ReturnType<typeof useDisconnectWalletMutation>;
export type DisconnectWalletMutationResult = Apollo.MutationResult<DisconnectWalletMutation>;
export type DisconnectWalletMutationOptions = Apollo.BaseMutationOptions<DisconnectWalletMutation, DisconnectWalletMutationVariables>;
export const VerifyDiscordTargetDocument = gql`
    mutation verifyDiscordTarget($verifyDiscordTargetInput: VerifyDiscordTargetInput!) {
  verifyDiscordTarget(verifyDiscordTargetInput: $verifyDiscordTargetInput) {
    ...DiscordTarget
  }
}
    ${DiscordTargetFragmentDoc}`;
export type VerifyDiscordTargetMutationFn = Apollo.MutationFunction<VerifyDiscordTargetMutation, VerifyDiscordTargetMutationVariables>;

/**
 * __useVerifyDiscordTargetMutation__
 *
 * To run a mutation, you first call `useVerifyDiscordTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDiscordTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDiscordTargetMutation, { data, loading, error }] = useVerifyDiscordTargetMutation({
 *   variables: {
 *      verifyDiscordTargetInput: // value for 'verifyDiscordTargetInput'
 *   },
 * });
 */
export function useVerifyDiscordTargetMutation(baseOptions?: Apollo.MutationHookOptions<VerifyDiscordTargetMutation, VerifyDiscordTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyDiscordTargetMutation, VerifyDiscordTargetMutationVariables>(VerifyDiscordTargetDocument, options);
      }
export type VerifyDiscordTargetMutationHookResult = ReturnType<typeof useVerifyDiscordTargetMutation>;
export type VerifyDiscordTargetMutationResult = Apollo.MutationResult<VerifyDiscordTargetMutation>;
export type VerifyDiscordTargetMutationOptions = Apollo.BaseMutationOptions<VerifyDiscordTargetMutation, VerifyDiscordTargetMutationVariables>;
export const VerifySlackTargetDocument = gql`
    mutation verifySlackTarget($input: VerifySlackChannelTargetInput!) {
  verifySlackChannelTarget(input: $input) {
    ...SlackTarget
  }
}
    ${SlackTargetFragmentDoc}`;
export type VerifySlackTargetMutationFn = Apollo.MutationFunction<VerifySlackTargetMutation, VerifySlackTargetMutationVariables>;

/**
 * __useVerifySlackTargetMutation__
 *
 * To run a mutation, you first call `useVerifySlackTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySlackTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySlackTargetMutation, { data, loading, error }] = useVerifySlackTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifySlackTargetMutation(baseOptions?: Apollo.MutationHookOptions<VerifySlackTargetMutation, VerifySlackTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySlackTargetMutation, VerifySlackTargetMutationVariables>(VerifySlackTargetDocument, options);
      }
export type VerifySlackTargetMutationHookResult = ReturnType<typeof useVerifySlackTargetMutation>;
export type VerifySlackTargetMutationResult = Apollo.MutationResult<VerifySlackTargetMutation>;
export type VerifySlackTargetMutationOptions = Apollo.BaseMutationOptions<VerifySlackTargetMutation, VerifySlackTargetMutationVariables>;
export const VerifySlackChannelForWebhookDocument = gql`
    mutation verifySlackChannelForWebhook($input: VerifySlackChannelTargetForWebhookInput!) {
  verifySlackChannelForWebhook(input: $input) {
    ...SlackWebhookTarget
  }
}
    ${SlackWebhookTargetFragmentDoc}`;
export type VerifySlackChannelForWebhookMutationFn = Apollo.MutationFunction<VerifySlackChannelForWebhookMutation, VerifySlackChannelForWebhookMutationVariables>;

/**
 * __useVerifySlackChannelForWebhookMutation__
 *
 * To run a mutation, you first call `useVerifySlackChannelForWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySlackChannelForWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySlackChannelForWebhookMutation, { data, loading, error }] = useVerifySlackChannelForWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifySlackChannelForWebhookMutation(baseOptions?: Apollo.MutationHookOptions<VerifySlackChannelForWebhookMutation, VerifySlackChannelForWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySlackChannelForWebhookMutation, VerifySlackChannelForWebhookMutationVariables>(VerifySlackChannelForWebhookDocument, options);
      }
export type VerifySlackChannelForWebhookMutationHookResult = ReturnType<typeof useVerifySlackChannelForWebhookMutation>;
export type VerifySlackChannelForWebhookMutationResult = Apollo.MutationResult<VerifySlackChannelForWebhookMutation>;
export type VerifySlackChannelForWebhookMutationOptions = Apollo.BaseMutationOptions<VerifySlackChannelForWebhookMutation, VerifySlackChannelForWebhookMutationVariables>;
export const AlertDocument = gql`
    query alert($getAlertInput: GetAlertInput) {
  alert(getAlertInput: $getAlertInput) {
    ...Alert
  }
}
    ${AlertFragmentDoc}`;

/**
 * __useAlertQuery__
 *
 * To run a query within a React component, call `useAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertQuery({
 *   variables: {
 *      getAlertInput: // value for 'getAlertInput'
 *   },
 * });
 */
export function useAlertQuery(baseOptions?: Apollo.QueryHookOptions<AlertQuery, AlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertQuery, AlertQueryVariables>(AlertDocument, options);
      }
export function useAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertQuery, AlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertQuery, AlertQueryVariables>(AlertDocument, options);
        }
export type AlertQueryHookResult = ReturnType<typeof useAlertQuery>;
export type AlertLazyQueryHookResult = ReturnType<typeof useAlertLazyQuery>;
export type AlertQueryResult = Apollo.QueryResult<AlertQuery, AlertQueryVariables>;
export const ConnectedWalletDocument = gql`
    query connectedWallet($getConnectedWalletsInput: GetConnectedWalletsInput) {
  connectedWallet(getConnectedWalletsInput: $getConnectedWalletsInput) {
    ...ConnectedWallet
  }
}
    ${ConnectedWalletFragmentDoc}`;

/**
 * __useConnectedWalletQuery__
 *
 * To run a query within a React component, call `useConnectedWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedWalletQuery({
 *   variables: {
 *      getConnectedWalletsInput: // value for 'getConnectedWalletsInput'
 *   },
 * });
 */
export function useConnectedWalletQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedWalletQuery, ConnectedWalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedWalletQuery, ConnectedWalletQueryVariables>(ConnectedWalletDocument, options);
      }
export function useConnectedWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedWalletQuery, ConnectedWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedWalletQuery, ConnectedWalletQueryVariables>(ConnectedWalletDocument, options);
        }
export type ConnectedWalletQueryHookResult = ReturnType<typeof useConnectedWalletQuery>;
export type ConnectedWalletLazyQueryHookResult = ReturnType<typeof useConnectedWalletLazyQuery>;
export type ConnectedWalletQueryResult = Apollo.QueryResult<ConnectedWalletQuery, ConnectedWalletQueryVariables>;
export const ConversationMessagesDocument = gql`
    query conversationMessages($getConversationMessagesInput: GetConversationMessagesInput!, $after: String, $first: Int) {
  conversationMessages(
    first: $first
    after: $after
    getConversationMessagesInput: $getConversationMessagesInput
  ) {
    nodes {
      id
      message
      userId
      createdDate
      updatedDate
      conversationId
      conversationParticipant {
        ...ConversationParticipant
      }
    }
    pageInfo {
      ...ConvMessagePageInfo
    }
  }
}
    ${ConversationParticipantFragmentDoc}
${ConvMessagePageInfoFragmentDoc}`;

/**
 * __useConversationMessagesQuery__
 *
 * To run a query within a React component, call `useConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationMessagesQuery({
 *   variables: {
 *      getConversationMessagesInput: // value for 'getConversationMessagesInput'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
      }
export function useConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
        }
export type ConversationMessagesQueryHookResult = ReturnType<typeof useConversationMessagesQuery>;
export type ConversationMessagesLazyQueryHookResult = ReturnType<typeof useConversationMessagesLazyQuery>;
export type ConversationMessagesQueryResult = Apollo.QueryResult<ConversationMessagesQuery, ConversationMessagesQueryVariables>;
export const NotifiConversationsDocument = gql`
    query NotifiConversations {
  conversations {
    nodes {
      ...Conversation
    }
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useNotifiConversationsQuery__
 *
 * To run a query within a React component, call `useNotifiConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotifiConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotifiConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotifiConversationsQuery(baseOptions?: Apollo.QueryHookOptions<NotifiConversationsQuery, NotifiConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotifiConversationsQuery, NotifiConversationsQueryVariables>(NotifiConversationsDocument, options);
      }
export function useNotifiConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotifiConversationsQuery, NotifiConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotifiConversationsQuery, NotifiConversationsQueryVariables>(NotifiConversationsDocument, options);
        }
export type NotifiConversationsQueryHookResult = ReturnType<typeof useNotifiConversationsQuery>;
export type NotifiConversationsLazyQueryHookResult = ReturnType<typeof useNotifiConversationsLazyQuery>;
export type NotifiConversationsQueryResult = Apollo.QueryResult<NotifiConversationsQuery, NotifiConversationsQueryVariables>;
export const DaoSourceDocument = gql`
    query daoSource($getSourceInput: GetSourceInput) {
  source(getSourceInput: $getSourceInput) {
    id
    blockchainAddress
    type
    name
    applicableFilters {
      id
      filterType
      name
    }
  }
}
    `;

/**
 * __useDaoSourceQuery__
 *
 * To run a query within a React component, call `useDaoSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDaoSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDaoSourceQuery({
 *   variables: {
 *      getSourceInput: // value for 'getSourceInput'
 *   },
 * });
 */
export function useDaoSourceQuery(baseOptions?: Apollo.QueryHookOptions<DaoSourceQuery, DaoSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DaoSourceQuery, DaoSourceQueryVariables>(DaoSourceDocument, options);
      }
export function useDaoSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DaoSourceQuery, DaoSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DaoSourceQuery, DaoSourceQueryVariables>(DaoSourceDocument, options);
        }
export type DaoSourceQueryHookResult = ReturnType<typeof useDaoSourceQuery>;
export type DaoSourceLazyQueryHookResult = ReturnType<typeof useDaoSourceLazyQuery>;
export type DaoSourceQueryResult = Apollo.QueryResult<DaoSourceQuery, DaoSourceQueryVariables>;
export const DashboardQueryDocument = gql`
    query DashboardQuery($getAlertInput: GetAlertInput, $getSourceInput: GetSourceInput, $getTargetInput: GetTargetInput) {
  alert(getAlertInput: $getAlertInput) {
    sourceGroup {
      id
      sources {
        id
        name
        blockchainAddress
        type
        activeAlertCount
      }
    }
    filter {
      id
      name
      filterType
    }
    targetGroup {
      id
      emailTargets {
        id
        emailAddress
        isConfirmed
      }
      smsTargets {
        id
        phoneNumber
        isConfirmed
      }
      telegramTargets {
        id
        name
        telegramId
        isConfirmed
      }
    }
    id
    groupName
    createdDate
    updatedDate
  }
  source(getSourceInput: $getSourceInput) {
    id
    blockchainAddress
    type
    activeAlertCount
    name
  }
  telegramTarget(getTargetInput: $getTargetInput) {
    id
    name
    isConfirmed
    telegramId
  }
  smsTarget(getTargetInput: $getTargetInput) {
    id
    phoneNumber
    isConfirmed
  }
  emailTarget(getTargetInput: $getTargetInput) {
    id
    emailAddress
    isConfirmed
  }
}
    `;

/**
 * __useDashboardQueryQuery__
 *
 * To run a query within a React component, call `useDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQueryQuery({
 *   variables: {
 *      getAlertInput: // value for 'getAlertInput'
 *      getSourceInput: // value for 'getSourceInput'
 *      getTargetInput: // value for 'getTargetInput'
 *   },
 * });
 */
export function useDashboardQueryQuery(baseOptions?: Apollo.QueryHookOptions<DashboardQueryQuery, DashboardQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQueryQuery, DashboardQueryQueryVariables>(DashboardQueryDocument, options);
      }
export function useDashboardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQueryQuery, DashboardQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQueryQuery, DashboardQueryQueryVariables>(DashboardQueryDocument, options);
        }
export type DashboardQueryQueryHookResult = ReturnType<typeof useDashboardQueryQuery>;
export type DashboardQueryLazyQueryHookResult = ReturnType<typeof useDashboardQueryLazyQuery>;
export type DashboardQueryQueryResult = Apollo.QueryResult<DashboardQueryQuery, DashboardQueryQueryVariables>;
export const DiscordTargetDocument = gql`
    query discordTarget($getTargetInput: GetTargetInput) {
  discordTarget(getTargetInput: $getTargetInput) {
    ...DiscordTarget
  }
}
    ${DiscordTargetFragmentDoc}`;

/**
 * __useDiscordTargetQuery__
 *
 * To run a query within a React component, call `useDiscordTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscordTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscordTargetQuery({
 *   variables: {
 *      getTargetInput: // value for 'getTargetInput'
 *   },
 * });
 */
export function useDiscordTargetQuery(baseOptions?: Apollo.QueryHookOptions<DiscordTargetQuery, DiscordTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscordTargetQuery, DiscordTargetQueryVariables>(DiscordTargetDocument, options);
      }
export function useDiscordTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscordTargetQuery, DiscordTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscordTargetQuery, DiscordTargetQueryVariables>(DiscordTargetDocument, options);
        }
export type DiscordTargetQueryHookResult = ReturnType<typeof useDiscordTargetQuery>;
export type DiscordTargetLazyQueryHookResult = ReturnType<typeof useDiscordTargetLazyQuery>;
export type DiscordTargetQueryResult = Apollo.QueryResult<DiscordTargetQuery, DiscordTargetQueryVariables>;
export const EmailTargetDocument = gql`
    query emailTarget($getTargetInput: GetTargetInput) {
  emailTarget(getTargetInput: $getTargetInput) {
    ...EmailTarget
  }
}
    ${EmailTargetFragmentDoc}`;

/**
 * __useEmailTargetQuery__
 *
 * To run a query within a React component, call `useEmailTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTargetQuery({
 *   variables: {
 *      getTargetInput: // value for 'getTargetInput'
 *   },
 * });
 */
export function useEmailTargetQuery(baseOptions?: Apollo.QueryHookOptions<EmailTargetQuery, EmailTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTargetQuery, EmailTargetQueryVariables>(EmailTargetDocument, options);
      }
export function useEmailTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailTargetQuery, EmailTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTargetQuery, EmailTargetQueryVariables>(EmailTargetDocument, options);
        }
export type EmailTargetQueryHookResult = ReturnType<typeof useEmailTargetQuery>;
export type EmailTargetLazyQueryHookResult = ReturnType<typeof useEmailTargetLazyQuery>;
export type EmailTargetQueryResult = Apollo.QueryResult<EmailTargetQuery, EmailTargetQueryVariables>;
export const FilterDocument = gql`
    query filter($getFilterInput: GetFilterInput) {
  filter(getFilterInput: $getFilterInput) {
    id
    name
    filterType
  }
}
    `;

/**
 * __useFilterQuery__
 *
 * To run a query within a React component, call `useFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterQuery({
 *   variables: {
 *      getFilterInput: // value for 'getFilterInput'
 *   },
 * });
 */
export function useFilterQuery(baseOptions?: Apollo.QueryHookOptions<FilterQuery, FilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterQuery, FilterQueryVariables>(FilterDocument, options);
      }
export function useFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterQuery, FilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterQuery, FilterQueryVariables>(FilterDocument, options);
        }
export type FilterQueryHookResult = ReturnType<typeof useFilterQuery>;
export type FilterLazyQueryHookResult = ReturnType<typeof useFilterLazyQuery>;
export type FilterQueryResult = Apollo.QueryResult<FilterQuery, FilterQueryVariables>;
export const GetSlackChannelBotInfoDocument = gql`
    query GetSlackChannelBotInfo($input: GetSlackChannelBotInfoInput!) {
  slackChannelBotInfo(input: $input) {
    ...GetSlackChannelBotInfoResponse
  }
}
    ${GetSlackChannelBotInfoResponseFragmentDoc}`;

/**
 * __useGetSlackChannelBotInfoQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelBotInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelBotInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelBotInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSlackChannelBotInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSlackChannelBotInfoQuery, GetSlackChannelBotInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlackChannelBotInfoQuery, GetSlackChannelBotInfoQueryVariables>(GetSlackChannelBotInfoDocument, options);
      }
export function useGetSlackChannelBotInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlackChannelBotInfoQuery, GetSlackChannelBotInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlackChannelBotInfoQuery, GetSlackChannelBotInfoQueryVariables>(GetSlackChannelBotInfoDocument, options);
        }
export type GetSlackChannelBotInfoQueryHookResult = ReturnType<typeof useGetSlackChannelBotInfoQuery>;
export type GetSlackChannelBotInfoLazyQueryHookResult = ReturnType<typeof useGetSlackChannelBotInfoLazyQuery>;
export type GetSlackChannelBotInfoQueryResult = Apollo.QueryResult<GetSlackChannelBotInfoQuery, GetSlackChannelBotInfoQueryVariables>;
export const GetSlackWorkspaceIconDocument = gql`
    query GetSlackWorkspaceIcon($input: GetSlackWorkspaceIconInput!) {
  slackWorkspaceIcon(input: $input) {
    ...GetSlackWorkspaceIconResponse
  }
}
    ${GetSlackWorkspaceIconResponseFragmentDoc}`;

/**
 * __useGetSlackWorkspaceIconQuery__
 *
 * To run a query within a React component, call `useGetSlackWorkspaceIconQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackWorkspaceIconQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackWorkspaceIconQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSlackWorkspaceIconQuery(baseOptions: Apollo.QueryHookOptions<GetSlackWorkspaceIconQuery, GetSlackWorkspaceIconQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlackWorkspaceIconQuery, GetSlackWorkspaceIconQueryVariables>(GetSlackWorkspaceIconDocument, options);
      }
export function useGetSlackWorkspaceIconLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlackWorkspaceIconQuery, GetSlackWorkspaceIconQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlackWorkspaceIconQuery, GetSlackWorkspaceIconQueryVariables>(GetSlackWorkspaceIconDocument, options);
        }
export type GetSlackWorkspaceIconQueryHookResult = ReturnType<typeof useGetSlackWorkspaceIconQuery>;
export type GetSlackWorkspaceIconLazyQueryHookResult = ReturnType<typeof useGetSlackWorkspaceIconLazyQuery>;
export type GetSlackWorkspaceIconQueryResult = Apollo.QueryResult<GetSlackWorkspaceIconQuery, GetSlackWorkspaceIconQueryVariables>;
export const JabberMessagesDocument = gql`
    query jabberMessages($getJabberMessagesInput: GetJabberMessagesInput!) {
  jabberMessages(getJabberMessagesInput: $getJabberMessagesInput) {
    nodes {
      ...JabberMessage
    }
  }
}
    ${JabberMessageFragmentDoc}`;

/**
 * __useJabberMessagesQuery__
 *
 * To run a query within a React component, call `useJabberMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJabberMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJabberMessagesQuery({
 *   variables: {
 *      getJabberMessagesInput: // value for 'getJabberMessagesInput'
 *   },
 * });
 */
export function useJabberMessagesQuery(baseOptions: Apollo.QueryHookOptions<JabberMessagesQuery, JabberMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JabberMessagesQuery, JabberMessagesQueryVariables>(JabberMessagesDocument, options);
      }
export function useJabberMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JabberMessagesQuery, JabberMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JabberMessagesQuery, JabberMessagesQueryVariables>(JabberMessagesDocument, options);
        }
export type JabberMessagesQueryHookResult = ReturnType<typeof useJabberMessagesQuery>;
export type JabberMessagesLazyQueryHookResult = ReturnType<typeof useJabberMessagesLazyQuery>;
export type JabberMessagesQueryResult = Apollo.QueryResult<JabberMessagesQuery, JabberMessagesQueryVariables>;
export const JabberThreadsDocument = gql`
    query jabberThreads {
  jabberThreads {
    nodes {
      ...JabberThread
    }
  }
}
    ${JabberThreadFragmentDoc}`;

/**
 * __useJabberThreadsQuery__
 *
 * To run a query within a React component, call `useJabberThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJabberThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJabberThreadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJabberThreadsQuery(baseOptions?: Apollo.QueryHookOptions<JabberThreadsQuery, JabberThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JabberThreadsQuery, JabberThreadsQueryVariables>(JabberThreadsDocument, options);
      }
export function useJabberThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JabberThreadsQuery, JabberThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JabberThreadsQuery, JabberThreadsQueryVariables>(JabberThreadsDocument, options);
        }
export type JabberThreadsQueryHookResult = ReturnType<typeof useJabberThreadsQuery>;
export type JabberThreadsLazyQueryHookResult = ReturnType<typeof useJabberThreadsLazyQuery>;
export type JabberThreadsQueryResult = Apollo.QueryResult<JabberThreadsQuery, JabberThreadsQueryVariables>;
export const ListAvailableSlackChannelsDocument = gql`
    query ListAvailableSlackChannels($input: ListAvailableSlackChannelInput!) {
  listAvailableSlackChannels(input: $input) {
    ...ListAvailableSlackChannelResponse
  }
}
    ${ListAvailableSlackChannelResponseFragmentDoc}`;

/**
 * __useListAvailableSlackChannelsQuery__
 *
 * To run a query within a React component, call `useListAvailableSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableSlackChannelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListAvailableSlackChannelsQuery(baseOptions: Apollo.QueryHookOptions<ListAvailableSlackChannelsQuery, ListAvailableSlackChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAvailableSlackChannelsQuery, ListAvailableSlackChannelsQueryVariables>(ListAvailableSlackChannelsDocument, options);
      }
export function useListAvailableSlackChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAvailableSlackChannelsQuery, ListAvailableSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAvailableSlackChannelsQuery, ListAvailableSlackChannelsQueryVariables>(ListAvailableSlackChannelsDocument, options);
        }
export type ListAvailableSlackChannelsQueryHookResult = ReturnType<typeof useListAvailableSlackChannelsQuery>;
export type ListAvailableSlackChannelsLazyQueryHookResult = ReturnType<typeof useListAvailableSlackChannelsLazyQuery>;
export type ListAvailableSlackChannelsQueryResult = Apollo.QueryResult<ListAvailableSlackChannelsQuery, ListAvailableSlackChannelsQueryVariables>;
export const NotificationByIdDocument = gql`
    query notificationById($id: String!) {
  notificationById(id: $id) {
    ...NotificationHistoryEntry
  }
}
    ${NotificationHistoryEntryFragmentDoc}`;

/**
 * __useNotificationByIdQuery__
 *
 * To run a query within a React component, call `useNotificationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationByIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationByIdQuery, NotificationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationByIdQuery, NotificationByIdQueryVariables>(NotificationByIdDocument, options);
      }
export function useNotificationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationByIdQuery, NotificationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationByIdQuery, NotificationByIdQueryVariables>(NotificationByIdDocument, options);
        }
export type NotificationByIdQueryHookResult = ReturnType<typeof useNotificationByIdQuery>;
export type NotificationByIdLazyQueryHookResult = ReturnType<typeof useNotificationByIdLazyQuery>;
export type NotificationByIdQueryResult = Apollo.QueryResult<NotificationByIdQuery, NotificationByIdQueryVariables>;
export const NotificationHistoryDocument = gql`
    query notificationHistory($filter: NotificationHistoryFilterInput, $after: String, $first: Int) {
  notificationHistory(after: $after, first: $first, filter: $filter) {
    edges {
      node {
        ...NotificationHistoryEntry
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NotificationHistoryEntryFragmentDoc}`;

/**
 * __useNotificationHistoryQuery__
 *
 * To run a query within a React component, call `useNotificationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useNotificationHistoryQuery(baseOptions?: Apollo.QueryHookOptions<NotificationHistoryQuery, NotificationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationHistoryQuery, NotificationHistoryQueryVariables>(NotificationHistoryDocument, options);
      }
export function useNotificationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationHistoryQuery, NotificationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationHistoryQuery, NotificationHistoryQueryVariables>(NotificationHistoryDocument, options);
        }
export type NotificationHistoryQueryHookResult = ReturnType<typeof useNotificationHistoryQuery>;
export type NotificationHistoryLazyQueryHookResult = ReturnType<typeof useNotificationHistoryLazyQuery>;
export type NotificationHistoryQueryResult = Apollo.QueryResult<NotificationHistoryQuery, NotificationHistoryQueryVariables>;
export const PreviewCommunityManagerContentDocument = gql`
    query previewCommunityManagerContent($previewInput: CommunityManagerPreviewInput!) {
  previewCommunityManagerContent(communityManagerPreviewInput: $previewInput) {
    content
  }
}
    `;

/**
 * __usePreviewCommunityManagerContentQuery__
 *
 * To run a query within a React component, call `usePreviewCommunityManagerContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCommunityManagerContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCommunityManagerContentQuery({
 *   variables: {
 *      previewInput: // value for 'previewInput'
 *   },
 * });
 */
export function usePreviewCommunityManagerContentQuery(baseOptions: Apollo.QueryHookOptions<PreviewCommunityManagerContentQuery, PreviewCommunityManagerContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewCommunityManagerContentQuery, PreviewCommunityManagerContentQueryVariables>(PreviewCommunityManagerContentDocument, options);
      }
export function usePreviewCommunityManagerContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewCommunityManagerContentQuery, PreviewCommunityManagerContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewCommunityManagerContentQuery, PreviewCommunityManagerContentQueryVariables>(PreviewCommunityManagerContentDocument, options);
        }
export type PreviewCommunityManagerContentQueryHookResult = ReturnType<typeof usePreviewCommunityManagerContentQuery>;
export type PreviewCommunityManagerContentLazyQueryHookResult = ReturnType<typeof usePreviewCommunityManagerContentLazyQuery>;
export type PreviewCommunityManagerContentQueryResult = Apollo.QueryResult<PreviewCommunityManagerContentQuery, PreviewCommunityManagerContentQueryVariables>;
export const ResolveSnsAddressFromNameDocument = gql`
    query resolveSNSAddressFromName($name: String!) {
  resolveSNSFromAddress(address: $name)
}
    `;

/**
 * __useResolveSnsAddressFromNameQuery__
 *
 * To run a query within a React component, call `useResolveSnsAddressFromNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveSnsAddressFromNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveSnsAddressFromNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useResolveSnsAddressFromNameQuery(baseOptions: Apollo.QueryHookOptions<ResolveSnsAddressFromNameQuery, ResolveSnsAddressFromNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveSnsAddressFromNameQuery, ResolveSnsAddressFromNameQueryVariables>(ResolveSnsAddressFromNameDocument, options);
      }
export function useResolveSnsAddressFromNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveSnsAddressFromNameQuery, ResolveSnsAddressFromNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveSnsAddressFromNameQuery, ResolveSnsAddressFromNameQueryVariables>(ResolveSnsAddressFromNameDocument, options);
        }
export type ResolveSnsAddressFromNameQueryHookResult = ReturnType<typeof useResolveSnsAddressFromNameQuery>;
export type ResolveSnsAddressFromNameLazyQueryHookResult = ReturnType<typeof useResolveSnsAddressFromNameLazyQuery>;
export type ResolveSnsAddressFromNameQueryResult = Apollo.QueryResult<ResolveSnsAddressFromNameQuery, ResolveSnsAddressFromNameQueryVariables>;
export const SmsTargetDocument = gql`
    query smsTarget($getTargetInput: GetTargetInput) {
  smsTarget(getTargetInput: $getTargetInput) {
    id
    phoneNumber
    isConfirmed
  }
}
    `;

/**
 * __useSmsTargetQuery__
 *
 * To run a query within a React component, call `useSmsTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsTargetQuery({
 *   variables: {
 *      getTargetInput: // value for 'getTargetInput'
 *   },
 * });
 */
export function useSmsTargetQuery(baseOptions?: Apollo.QueryHookOptions<SmsTargetQuery, SmsTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsTargetQuery, SmsTargetQueryVariables>(SmsTargetDocument, options);
      }
export function useSmsTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsTargetQuery, SmsTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsTargetQuery, SmsTargetQueryVariables>(SmsTargetDocument, options);
        }
export type SmsTargetQueryHookResult = ReturnType<typeof useSmsTargetQuery>;
export type SmsTargetLazyQueryHookResult = ReturnType<typeof useSmsTargetLazyQuery>;
export type SmsTargetQueryResult = Apollo.QueryResult<SmsTargetQuery, SmsTargetQueryVariables>;
export const SourceGroupDocument = gql`
    query sourceGroup($getSourceGroupInput: GetSourceGroupInput) {
  sourceGroup(getSourceGroupInput: $getSourceGroupInput) {
    ...SourceGroup
  }
}
    ${SourceGroupFragmentDoc}`;

/**
 * __useSourceGroupQuery__
 *
 * To run a query within a React component, call `useSourceGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceGroupQuery({
 *   variables: {
 *      getSourceGroupInput: // value for 'getSourceGroupInput'
 *   },
 * });
 */
export function useSourceGroupQuery(baseOptions?: Apollo.QueryHookOptions<SourceGroupQuery, SourceGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceGroupQuery, SourceGroupQueryVariables>(SourceGroupDocument, options);
      }
export function useSourceGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceGroupQuery, SourceGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceGroupQuery, SourceGroupQueryVariables>(SourceGroupDocument, options);
        }
export type SourceGroupQueryHookResult = ReturnType<typeof useSourceGroupQuery>;
export type SourceGroupLazyQueryHookResult = ReturnType<typeof useSourceGroupLazyQuery>;
export type SourceGroupQueryResult = Apollo.QueryResult<SourceGroupQuery, SourceGroupQueryVariables>;
export const SourceDocument = gql`
    query source($getSourceInput: GetSourceInput) {
  source(getSourceInput: $getSourceInput) {
    ...Source
  }
}
    ${SourceFragmentDoc}`;

/**
 * __useSourceQuery__
 *
 * To run a query within a React component, call `useSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceQuery({
 *   variables: {
 *      getSourceInput: // value for 'getSourceInput'
 *   },
 * });
 */
export function useSourceQuery(baseOptions?: Apollo.QueryHookOptions<SourceQuery, SourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceQuery, SourceQueryVariables>(SourceDocument, options);
      }
export function useSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceQuery, SourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceQuery, SourceQueryVariables>(SourceDocument, options);
        }
export type SourceQueryHookResult = ReturnType<typeof useSourceQuery>;
export type SourceLazyQueryHookResult = ReturnType<typeof useSourceLazyQuery>;
export type SourceQueryResult = Apollo.QueryResult<SourceQuery, SourceQueryVariables>;
export const TargetGroupDocument = gql`
    query targetGroup($getTargetGroupInput: GetTargetGroupInput) {
  targetGroup(getTargetGroupInput: $getTargetGroupInput) {
    ...TargetGroup
  }
}
    ${TargetGroupFragmentDoc}`;

/**
 * __useTargetGroupQuery__
 *
 * To run a query within a React component, call `useTargetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetGroupQuery({
 *   variables: {
 *      getTargetGroupInput: // value for 'getTargetGroupInput'
 *   },
 * });
 */
export function useTargetGroupQuery(baseOptions?: Apollo.QueryHookOptions<TargetGroupQuery, TargetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetGroupQuery, TargetGroupQueryVariables>(TargetGroupDocument, options);
      }
export function useTargetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetGroupQuery, TargetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetGroupQuery, TargetGroupQueryVariables>(TargetGroupDocument, options);
        }
export type TargetGroupQueryHookResult = ReturnType<typeof useTargetGroupQuery>;
export type TargetGroupLazyQueryHookResult = ReturnType<typeof useTargetGroupLazyQuery>;
export type TargetGroupQueryResult = Apollo.QueryResult<TargetGroupQuery, TargetGroupQueryVariables>;
export const TelegramTargetDocument = gql`
    query telegramTarget($getTargetInput: GetTargetInput) {
  telegramTarget(getTargetInput: $getTargetInput) {
    ...TelegramTarget
  }
}
    ${TelegramTargetFragmentDoc}`;

/**
 * __useTelegramTargetQuery__
 *
 * To run a query within a React component, call `useTelegramTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelegramTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelegramTargetQuery({
 *   variables: {
 *      getTargetInput: // value for 'getTargetInput'
 *   },
 * });
 */
export function useTelegramTargetQuery(baseOptions?: Apollo.QueryHookOptions<TelegramTargetQuery, TelegramTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelegramTargetQuery, TelegramTargetQueryVariables>(TelegramTargetDocument, options);
      }
export function useTelegramTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelegramTargetQuery, TelegramTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelegramTargetQuery, TelegramTargetQueryVariables>(TelegramTargetDocument, options);
        }
export type TelegramTargetQueryHookResult = ReturnType<typeof useTelegramTargetQuery>;
export type TelegramTargetLazyQueryHookResult = ReturnType<typeof useTelegramTargetLazyQuery>;
export type TelegramTargetQueryResult = Apollo.QueryResult<TelegramTargetQuery, TelegramTargetQueryVariables>;
export const TelegramTargetUrlDocument = gql`
    query telegramTargetUrl($getTargetInput: GetTargetInput) {
  telegramTarget(getTargetInput: $getTargetInput) {
    confirmationUrl
  }
}
    `;

/**
 * __useTelegramTargetUrlQuery__
 *
 * To run a query within a React component, call `useTelegramTargetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelegramTargetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelegramTargetUrlQuery({
 *   variables: {
 *      getTargetInput: // value for 'getTargetInput'
 *   },
 * });
 */
export function useTelegramTargetUrlQuery(baseOptions?: Apollo.QueryHookOptions<TelegramTargetUrlQuery, TelegramTargetUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelegramTargetUrlQuery, TelegramTargetUrlQueryVariables>(TelegramTargetUrlDocument, options);
      }
export function useTelegramTargetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelegramTargetUrlQuery, TelegramTargetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelegramTargetUrlQuery, TelegramTargetUrlQueryVariables>(TelegramTargetUrlDocument, options);
        }
export type TelegramTargetUrlQueryHookResult = ReturnType<typeof useTelegramTargetUrlQuery>;
export type TelegramTargetUrlLazyQueryHookResult = ReturnType<typeof useTelegramTargetUrlLazyQuery>;
export type TelegramTargetUrlQueryResult = Apollo.QueryResult<TelegramTargetUrlQuery, TelegramTargetUrlQueryVariables>;
export const TopicsDocument = gql`
    query topics($first: Int, $after: String) {
  topics(first: $first, after: $after) {
    nodes {
      targetCollections
      targetTemplate
      topicName
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTopicsQuery__
 *
 * To run a query within a React component, call `useTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTopicsQuery(baseOptions?: Apollo.QueryHookOptions<TopicsQuery, TopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
      }
export function useTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicsQuery, TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
        }
export type TopicsQueryHookResult = ReturnType<typeof useTopicsQuery>;
export type TopicsLazyQueryHookResult = ReturnType<typeof useTopicsLazyQuery>;
export type TopicsQueryResult = Apollo.QueryResult<TopicsQuery, TopicsQueryVariables>;
export const UserFeatureFlagsDocument = gql`
    query userFeatureFlags {
  userFeatureFlags {
    chatEnabled
  }
}
    `;

/**
 * __useUserFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useUserFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
      }
export function useUserFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
        }
export type UserFeatureFlagsQueryHookResult = ReturnType<typeof useUserFeatureFlagsQuery>;
export type UserFeatureFlagsLazyQueryHookResult = ReturnType<typeof useUserFeatureFlagsLazyQuery>;
export type UserFeatureFlagsQueryResult = Apollo.QueryResult<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>;
export const SubmitLoginFromDappDocument = gql`
    mutation submitLoginFromDapp($dappLogInInput: DappLogInInput!, $signature: String!) {
  logInFromDapp(dappLogInInput: $dappLogInInput, signature: $signature) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type SubmitLoginFromDappMutationFn = Apollo.MutationFunction<SubmitLoginFromDappMutation, SubmitLoginFromDappMutationVariables>;

/**
 * __useSubmitLoginFromDappMutation__
 *
 * To run a mutation, you first call `useSubmitLoginFromDappMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLoginFromDappMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLoginFromDappMutation, { data, loading, error }] = useSubmitLoginFromDappMutation({
 *   variables: {
 *      dappLogInInput: // value for 'dappLogInInput'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useSubmitLoginFromDappMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLoginFromDappMutation, SubmitLoginFromDappMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLoginFromDappMutation, SubmitLoginFromDappMutationVariables>(SubmitLoginFromDappDocument, options);
      }
export type SubmitLoginFromDappMutationHookResult = ReturnType<typeof useSubmitLoginFromDappMutation>;
export type SubmitLoginFromDappMutationResult = Apollo.MutationResult<SubmitLoginFromDappMutation>;
export type SubmitLoginFromDappMutationOptions = Apollo.BaseMutationOptions<SubmitLoginFromDappMutation, SubmitLoginFromDappMutationVariables>;
export const UserProfileDocument = gql`
    query userProfile($getUserProfileInput: GetUserProfileInput) {
  userProfile(getUserProfileInput: $getUserProfileInput) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      getUserProfileInput: // value for 'getUserProfileInput'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserSettingsDocument = gql`
    query userSettings {
  userSettings {
    ...UserSettings
  }
}
    ${UserSettingsFragmentDoc}`;

/**
 * __useUserSettingsQuery__
 *
 * To run a query within a React component, call `useUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
      }
export function useUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
        }
export type UserSettingsQueryHookResult = ReturnType<typeof useUserSettingsQuery>;
export type UserSettingsLazyQueryHookResult = ReturnType<typeof useUserSettingsLazyQuery>;
export type UserSettingsQueryResult = Apollo.QueryResult<UserSettingsQuery, UserSettingsQueryVariables>;
export const DAppsSubscriptionsDocument = gql`
    query dAppsSubscriptions {
  dAppsSubscriptions {
    id
    dAppName
    link
    name
    targetGroup {
      ...TargetGroupSummary
    }
  }
}
    ${TargetGroupSummaryFragmentDoc}`;

/**
 * __useDAppsSubscriptionsQuery__
 *
 * To run a query within a React component, call `useDAppsSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppsSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDAppsSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDAppsSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<DAppsSubscriptionsQuery, DAppsSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DAppsSubscriptionsQuery, DAppsSubscriptionsQueryVariables>(DAppsSubscriptionsDocument, options);
      }
export function useDAppsSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DAppsSubscriptionsQuery, DAppsSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DAppsSubscriptionsQuery, DAppsSubscriptionsQueryVariables>(DAppsSubscriptionsDocument, options);
        }
export type DAppsSubscriptionsQueryHookResult = ReturnType<typeof useDAppsSubscriptionsQuery>;
export type DAppsSubscriptionsLazyQueryHookResult = ReturnType<typeof useDAppsSubscriptionsLazyQuery>;
export type DAppsSubscriptionsQueryResult = Apollo.QueryResult<DAppsSubscriptionsQuery, DAppsSubscriptionsQueryVariables>;
export const ChatMessageReceivedDocument = gql`
    subscription ChatMessageReceived {
  messageReceived {
    ...ConversationMessage
  }
}
    ${ConversationMessageFragmentDoc}`;

/**
 * __useChatMessageReceivedSubscription__
 *
 * To run a query within a React component, call `useChatMessageReceivedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageReceivedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessageReceivedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatMessageReceivedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatMessageReceivedSubscription, ChatMessageReceivedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatMessageReceivedSubscription, ChatMessageReceivedSubscriptionVariables>(ChatMessageReceivedDocument, options);
      }
export type ChatMessageReceivedSubscriptionHookResult = ReturnType<typeof useChatMessageReceivedSubscription>;
export type ChatMessageReceivedSubscriptionResult = Apollo.SubscriptionResult<ChatMessageReceivedSubscription>;